export default {
  "t-menu": "Menu",
  "t-device-trend-chart": "Device Rrend Chart",
  "t-dashboard": "Dashboard",
  "t-search": "Search",
  "t-reset": "Reset",
  "t-default": "Default",
  "t-system": "System",
  "t-system-param": "System Param",
  "t-normal": "Normal",
  "t-not-supported": "Not Supported",
  "t-suspend": "Suspend",
  "t-create": "Create",
  "t-edit": "Edit",
  "t-copy": "Copy",
  "t-export": "Export",
  "t-download": "Download",
  "t-install": "Install",
  "t-clean": "Clean",
  "t-enter": "Enter",
  "t-select": "Select",
  "t-selected": "Selected",
  "t-next": "Next",
  "t-submit": "Submit",
  "t-update": "Update",
  "t-cancel": "Cancel",
  "t-cancel-reset": "Reset & Cancel",
  "t-name": "Name",
  "t-alias": "Alias",
  "t-value": "Value",
  "t-from": "From",
  "t-user-name": "User Name",
  "t-current": "Current",
  "t-new": "New",
  "t-password": "Password",
  "t-confirm-password": "Confirm Password",
  "t-length": "Length",
  "t-type": "Type",
  "t-check": "Check",
  "t-radius": "Radius",
  "t-refresh": "Refresh",
  "t-delete": "Delete",
  "t-deleting": "Deleting",
  "t-import": "Import",
  "t-confirm": "Confirm",
  "t-confirm-to": "Are you sure",
  "t-confirm-delete": "Are you sure you want to delete - {param}",
  "t-confirm-unbind": "Are you sure you want to unbind - {param}",
  "t-confirm-clean-logs": "Are you sure you want to clean logs?",
  "t-detail": "Detail",
  "t-usage": "Usage",
  "t-records": "Records",
  "t-location": "Location",
  "t-add": "Add",
  "t-size": "Size",
  "t-website": "Website",
  "t-address": "Address",
  "t-remark": "Remark",
  "t-description": "Description",
  "t-description-max-length": "Description cannot exceed 500 characters",
  "t-phone": "Phone",
  "t-phone-number": "Phone Number",
  "t-icon": "Icon",
  "t-file": "File",
  "t-batch-file": "Batch File",
  "t-push-decompressed-file": "Automatically extract archive after download",
  "t-push-decompressed-file-tip": "If enabled, the downloaded archive will be extracted automatically on the target device.",
  "t-status": "Status",
  "t-action": "Action",
  "t-code": "Code",
  "t-id": "ID",
  "t-revoke": "Revoke",
  "t-create-by": "Create By",
  "t-create-time": "Create Time",
  "t-first-connect-time": "First Connect Time",
  "t-executed-at": "Executed At",
  "t-execution-time": "Execution Time",
  "t-execute-by": "Execution By",
  "t-expiration-time": "Expiration Time",
  "t-modified-by": "Modified By",
  "t-modified-time": "Modified Time",
  "t-date": "Date",
  "t-minute": "Minute",
  "t-hour": "Hour",
  "t-day": "Day",
  "t-day-number": "rd",
  "t-month": "Month",
  "t-week": "Week",
  "t-year": "Year",
  "t-region": "Region",
  "t-continent": "Continent",
  "t-basic": "Basic",
  "t-premium": "Permium",
  "t-switch": "Switch",
  "t-quantity": "Quantity",
  "t-success": "Success",
  "t-fail": "Fail",
  "t-pending": "Pending",
  "t-reverted": "Revoked",
  "t-revoke-success-tip": "Revocation submitted, check the task list later.",
  "t-yes": "Yes",
  "t-no": "No",
  "t-login": "Login",
  "t-logout": "Logout",
  "t-last-online-time": "Last Online Time",
  "t-last-updated-time": "Last Data Updated on",
  "t-back": "Back",
  "t-duration": "Duration",
  "t-click-check": "Click View",
  "t-aborted": "Revoke",
  "t-terminal-supported-functions": "Terminal Type",
  "t-format": "Format",
  "t-disable-signature": "Disable Signature",
  "t-polygon": "Polygon",
  "t-radius-in-meters": "Radius in Meters [50-9999]M",
  "t-radius-in-hours": "Duration in Hours [0-72]H",
  "t-duration-value-range": "Duration range is 0-72 hours",
  "t-radius-value-range":"Radius range is 50-9999 meters",
  "t-loading": "Loading...",
  "t-image": "Image",
  "t-video": "Video",
  "t-text": "Text",
  "t-html": "HTML",
  "t-required": "is required.",
  "t-remove": "Remove",
  "t-logo": "Logo",
  "t-partner-portal-logo": "Partner Portal Logo",
  "t-notfound-result": "Sorry！No Result Found",
  "t-set": "Set",
  "t-number": "Number",
  "t-login-as-partner": "Login As Partner",
  "t-logout-as-partner": "Logout As Partner",
  "t-abnormal-devices": "Abnormal Devices",
  "t-abnormal-device-status": "Abnormal Devices Status",
  "t-last-7-days": "Last 7 Days",
  "t-last-14-days": "Last 14 Days",
  "t-last-30-days": "Last 30 Days",
  "t-last-90-days": "Last 90 Days",
  "t-last-365-days": "Last 365 Days",
  "t-last-days-number": "Last {param} Days",
  "t-table": "Table",
  "t-head": "Head",
  "t-open": "Open",
  "t-close": "Close",
  "t-notification": "Notification",
  "t-public": "Public",
  "t-welcome-back": "Welcome Back",
  "t-sign-in-continue-storm": "Sign in to continue to Storm",
  "t-remember-me": "Remember me",
  "t-sign-in": "Sign In",
  "t-please-wait": "Please Wait",
  "t-storm-introduction-title1": "Smart Terminal Operations Remote Manager",
  "t-storm-introduction-title2": "FeiTian has developed the next generation TMS platform called STORM",
  "t-storm-introduction-title3": "Message Push Service、Remote Key Injection、OTA、Remote assistance of terminal devices",
  "t-login-status-expired": "Login timed out, please log in again！",
  "t-m": "M",
  "t-action-list": "Action List",


  "t-tooltip-device": "SN,TID,MID,IMEI",
  "t-sn": "SN",
  "t-designate-scope": "Designate Scope",
  "t-designate-device": "Designate Device",
  "t-terminal-management-system": "Terminal Management System",
  "t-device-mgmt": "Device Mgmt",
  "t-uninstall": "Uninstall",
  "t-uninstall-block": "Uninstall Block",
  "t-device": "Device",
  "t-device-type": "Device Type",
  "t-ecr-pos": "ECR POS",
  "t-pos": "POS",
  "t-ecr": "ECR",
  "t-serial-number": "Serial Number",
  "t-product-bundle": "Product Bundle",
  "t-device-detail": "Device Detail",
  "t-charts-devices": "Devices",
  "t-charts-push-report": "Push Report",
  "t-bind": "Bind",
  "t-bind-to": "Bind To",
  "t-unbind": "Unbind",
  "t-device-secret": "Device Secret",
  "t-product-key": "Product Key",
  "t-available": "Available",
  "t-used": "Used",
  "t-current-version-deleted": "has been deleted",
  "t-available-list": "Available List",
  "t-bound-list": "Bound List",
  "t-selected-list": "Selected List",
  "t-select-device-bind": "Please select device to bind",
  "t-batch": "Batch",
  "t-upload": "Upload",
  "t-refresh-device": "Refresh Device",
  "t-remote-control": "Remote Control",
  "t-remote-control-auto-pwd": "RC(Auto-PWD)",
  "t-disable-remote-control": "Disable RC",
  "t-device-not-partner": "This device does not have a partner",
  "t-remote-control-failed": "Remote control failed, please remove the Kiosk Mode first",
  "t-health-check-failed-kiosk": "Health check failed, please remove the Kiosk Mode first",
  "t-remote-control-steps": "In the remote control connection device...",
  "t-out-of-fence": "Out Of Fence",
  "t-active-statistics": "Active Statistics",
  "t-online-statistics": "Online Statistics",
  "t-active": "Active",
  "t-inactive": "Inactive",
  "t-out-of-country": "Out Of Country",
  "t-under-activation": "Under Activation",
  "t-online": "Online",
  "t-offline": "Offline",
  "t-abnormal": "Abnormal",
  "t-block": "Block",
  "t-device-disabled": "Device Disabled",
  "t-device-disabled-tamper": "Device Disabled,Tamper",
  "t-device-tamper-no": "Device Ok",
  "t-device-tamper-yes": "Device Tampered",
  "t-filters": "Filters",
  "t-basic-information": "Basic Information",
  "t-installed-application": "Installed Application",
  "t-last-factory-settings-time": "Last Factory Settings Time",
  "t-kiosk-mode": "Kiosk Mode",
  "t-set-kiosk-mode": "Set Kiosk Mode",
  "t-cancel-kiosk-mode": "Cancel Kiosk Mode",
  "t-open-immediately": "Open Immediately",
  "t-options": "Options",
  "t-application-starts-automatically-after-installation": "The application starts automatically upon completion of installation.",
  "t-cancel-open-immediately": "Cancel Open Immediately",
  "t-timeline": "Timeline",
  "t-android": "Android",
  "t-build-number": "Build Number",
  "t-sp-bootloader": "SP Bootloader",
  "t-sma-version-code": "SMA Version Code",
  "t-version-code": "Version Code",
  "t-version-type": "Version Type",
  "t-upgrade-model": "Upgrade Mode",
  "t-sma-status": "SMA Status",
  "t-pubkey-status": "PubKey Status",
  "t-cortex-scanner": "Cortex Scanner",
  "t-total": "Total",
  "t-cpu-statistics": "CPU Statistics",
  "t-ram-statistics": "RAM Statistics",
  "t-storage-statistics": "Storage Statistics",
  "t-authorisations": "Authorisations",
  "t-screen-resolution": "Screen Resolution",
  "t-battery-capacity": "Battery Capacity",
  "t-sim-number": "SIM Number",
  "t-sp-firmware": "SP Firmware",
  "t-cpu": "CPU",
  "t-iccid": "ICCID - (SIM)",
  "t-production-batch": "Production Batch",
  "t-category": "Category",
  "t-sales-batch": "Sales Batch",
  "t-network": "Network",
  "t-router-address": "Router Address",
  "t-router-name": "Router Name",
  "t-communication-type": "Communication Type",
  "t-signal-strength": "Signal Strength",
  "t-transmission-speed": "Transmission Speed",
  "t-mobile": "Mobile",
  "t-wifi": "WIFI",
  "t-wifi-mac-address": "WIFI Mac Address",
  "t-push-mgmt": "Push Mgmt",
  "t-rki-mgmt": "RKI Mgmt",
  "t-partner": "Partner",
  "t-parent": "Parent",
  "t-continent-region-exist": "The same continent and region data exist. Please delete the existing data and add it again.",
  "t-customer": "Customer",
  "t-merchant": "Merchant",
  "t-store": "Store",
  "t-excel-sample-file": "Excel Sample File",
  "t-import-strip": "strip",
  "t-number-of-successes": "Number of successes",
  "t-number-of-failed": "Number of failed",
  "t-import-failed-file": "Failed file (click to download)",
  "t-device-settings": "Device Settings",
  "t-manufacturer": "Manufacturer",
  "t-model": "Model",
  "t-model-version": "Model Version",
  "t-general": "General",
  "t-beta": "Beta",
  "t-resolution": "Resolution",
  "t-connection-type": "Connection Type",
  "t-message-protocol": "Message Protocol",
  "t-hardware-parameter": "Hardware Parameter",
  "t-version": "Version",
  "t-version-list": "Version List",
  "t-json-layout": "JSON Layout",
  "t-general-parameter": "General Parameter",
  "t-terminal-profiles": "Terminal Profiles",
  "t-force-initialization": "Force Initialization",
  "t-group": "Group",
  "t-add-device-to-group": "Add Device To Group",
  "t-upload-file-bind-device": "Upload files and batch bind/unbind devices",
  "t-geo-fence": "Geo Fencing",
  "t-erase-drawing": "Erase Drawing",
  "t-log-capture": "Log Capture",
  "t-log": "Log",
  "t-firmware": "Firmware",
  "t-firmware-version": "Firmware Version",
  "t-md5": "MD5",
  "t-application-mgmt": "Application Mgmt",
  "t-application": "Application",
  "t-application-name": "Application Name",
  "t-application-version": "Application Version",
  "t-application-certificates": "Application Certificates",
  "t-api-sign": "API Applications",
  "t-ft-applications": "FT Applications",
  "t-sign-status-created": "Pending",
  "t-sign-status-queued": "Queued",
  "t-sign-status-signing": "Signing",
  "t-sign-status-completed": "Completed",
  "t-sign-status-failed": "Failed",
  "t-certificates": "Certificates",
  "t-certificate-level": "Certificate Level",
  "t-tls-certificates": "TLS Certificate",
  "t-certificate-version": "Certificate Version",
  "t-certificate-owner": "Certificate Owner",
  "t-certificate": "Certificate",
  "t-certificate-issuer": "Certificate Issuer",
  "t-subject-dn": "Subject DN",
  "t-issuer-dn": "Issuer DN",
  "t-not-before": "Not Before",
  "t-not-after": "Not After",
  "t-certificate-serial-number": "Certificate Seria Number",
  "t-certificate-effective-date": "Certificate Effective Date",
  "t-certificate-expiration-date": "Certificate Expiration Date",
  "t-certificate-signing-algorithm": "Certificate Signing Algorithm",
  "t-batch-upload": "Batch Upload",
  "t-friendly-name": "Friendly Name",
  "t-name-common": "Common Name",
  "t-country": "Country",
  "t-currency": "Currency",
  "t-city": "City",
  "t-org-unit": "Organization Unit",
  "t-org": "Organization",
  "t-state-province": "State/Province",
  "t-common-name": "Common Name",
  "t-organization": "Organization",
  "t-organizational-unit-name": "Organizational Unit Name",
  "t-locality": "Locality",
  "t-key-store-password": "Key Store Password",
  "t-calendar": "Calendar",
  "t-transaction-param": "Transaction Param",
  "t-byte": "Byte",
  "t-copy-code": "Copy Code",
  "t-offline-data-authentication-was-not-performed": "Offline data authentication was not performed",
  "t-sda-failed": "SDA failed",
  "t-icc-data-missing": "ICC data missing",
  "t-card-appears-on-terminal-exception-file": "Card appears on terminal exception file",
  "t-dda-failed": "DDA failed",
  "t-cda-failed": "CDA failed",
  "t-rfu": "RFU",
  "t-icc-and-terminal-have-different-application": "ICC and terminal have different application",
  "t-expired-application": "Expired application",
  "t-application-not-yet-effective": "Application not yet effective",
  "t-requested-service-not-allowed-for-card-product": "Requested service not allowed for card product",
  "t-new-card": "New Card",
  "t-cardholder-verification-was-not-successful": "Cardholder verification was not successful",
  "t-unrecognised-cvm": "Unrecognised CVM",
  "t-pin-try-limit-exceeded": "PIN Try Limit exceeded",
  "t-pin-entry-required-and-pin-pad-not-present-or-not-working": "PIN entry required and PIN pad not present or not working",
  "t-pin-entry-required-pin-pad-present-but-pin-was-not-entered": "PIN entry required, PIN pad present, but PIN was not entered",
  "t-online-pin-entered": "Online PIN entered",
  "t-transaction-exceeds-floor-limit": "Transaction exceeds floor limit",
  "t-lower-consecutive-offline-limit-exceeded": "Lower consecutive offline limit exceeded",
  "t-upper-consecutive-offline-limit-exceeded": "Upper consecutive offline limit exceeded",
  "t-transaction-selected-randomly-for-online-processing": "Transaction selected randomly for online processing",
  "t-merchant-forced-transaction-online": "Merchant forced transaction online",
  "t-package": "Package",
  "t-package-name": "Package Name",
  "server.mam.ft.package.mismatch": "Package name does not match",
  "t-intent-name": "Intent Name",
  "t-application-token": "Application Token",
  "t-client-token": "Client Token",
  "t-file-name": "File Name",
  "t-file-size": "File Size",
  "t-silent-upgrade": "Automatic Upgrade",
  "t-prompt-for-upgrade": "Manual Upgrade",
  "t-upgrade-strategy": "Upgrade Strategy",
  "t-upgrade": "Upgrade",
  "t-upgrade-strategy-for-supports-sma": "Upgrade strategy only supports SMA,SMA Version Code 100517 and above support this upgrade strategy",
  "t-allow-use-network-download": "Allow downloading using mobile network",
  "t-selected-range-not-allowed": "The selected time range is not allowed to exceed 18 hours",
  "t-terminal-allow-use-network-download-network": "If you select this option, the terminal will be allowed to download firmware files using the mobile network",
  "t-time-period-upgrade-tip": "The terminal will upgrade automatically within a specified period of time. If the terminal cancels this upgrade, it will go to the next one. Re-enter the upgrade within a period of time",
  "t-period-of-time": "Period of time",
  "t-start-time-and-end-time-cannot-be-same": "The selected time interval is not allowed to be the same",
  "t-push-to-device-group": "Push to device or group",
  "t-push-login-as-partner": "Please login as a Partner to perform this function.",
  "t-push-to-device": "Push to device",
  "t-push-to-group": "Push to group",
  "t-push-report": "Push Report",
  "t-abort-push": "Revoke Push",
  "t-not-start": "Not Start",
  "t-warning-to-cancel-push": "Are you sure you want to revoke push?",
  "t-scheduler-tasks": "Scheduler Tasks",
  "t-planned": "Planned",
  "t-message": "Message",
  "t-message-type": "Message Type",
  "t-push-message": "Plan message has expired",
  "t-showing-duration": "Showing Duration",
  "t-unlimited": "Unlimited",
  "t-plan-time": "Plan Time",
  "t-message-from": "From",
  "t-every": "Every",
  "t-content": "Content",
  "t-advertisement": "Advertisement",
  "t-advertisement-planner": "Advertisement Planner",
  "t-planner": "Planner",
  "t-push-advertisement-expired": "Advertisement has expired",
  "t-advertisement-file": "Advertisement File",
  "t-loop": "Loop",
  "t-ads-start-date": "Ads Start Date",
  "t-ads-end-date": "Ads End Date",
  "t-more-detail-url": "More Detail Url",
  "t-detail-url": "Detail Url",
  "t-folder": "Folder",
  "t-key-capture": "Key Capture",
  "t-key": "Key",
  "t-index": "Index",
  "t-algorithm": "Algorithm",
  "t-key-type": "Key Type",
  "t-number-keys": "Number Of Keys",
  "t-key-group": "Key Group",
  "t-key-value": "Key Value",
  "t-kcv": "KCV",
  "t-clear-key": "Clear Key",
  "t-encrypted-key-under": "Encrypted Key Under",
  "t-key-capture-report": "Key Capture Report",
  "t-key-injection": "Key Injection",
  "t-ksi": "KSI",
  "t-did": "DID",
  "t-counter": "Counter",
  "t-ksn": "KSN",
  "t-ksn-example": "KSN Example",
  "t-hsm": "HSM",
  "t-hsm-model": "HSM Model",
  "t-interface": "Interface",
  "t-primary-host": "Primary Host",
  "t-primary-port": "Primary Port",
  "t-secondary-host": "Secondary Host",
  "t-secondary-port": "Secondary Port",
  "t-hsm-enable": "HSM Enable",
  "t-lmk-index": "LMK Index",
  "t-enable": "Enable",
  "t-key-block": "Key Block",
  "t-widgets": "Widgets",
  "t-settings": "Settings",
  "t-device-locations": "Device Locations",
  "t-role-widget-save-successfully": "Authorized List saved successfully",
  "t-partner-settings": "Partner Settings",
  "t-signature": "Signature",
  "t-cloud-messaging": "Cloud Messaging",
  "t-detamper-auth": "DeTamper Auth",
  "t-enable-signature-error-partner-not-found": " Cannot enable Signature, Partner not associated",
  "t-enable-signature-error-2nd-cert-not-found": " Cannot enable Signature, 2nd Level Certificate not found",
  "t-partner-setting-updated-successfully": "Partner Setting updated successfully！",
  "t-error-updating-partner-setting": "Error while updating Partner Setting",
  "t-error-loading-partner-setting": "Error while loading Partner Setting",
  "t-email-settings": "Email Settings",
  "t-email": "Email",
  "t-otp": "OTP",
  "t-mfa": "MFA",
  "t-email-server": "Email Server",
  "t-email-account": "Email Account",
  "t-port": "Port",
  "t-ssl": "SSL",
  "t-starttls": "STARTTLS",
  "t-email-sender": "Email Sender",
  "t-sms-settings": "SMS Settings",
  "t-sms": "SMS",
  "t-sms-gateway": "SMS Gateway",
  "t-sms-settings-signname": "SMS Settings Signname",
  "t-access": "Access",
  "t-access-key-id": "Access Key ID",
  "t-access-key-secret": "Access Key Secret",
  "t-password-policy": "Password Policy",
  "t-enable-password-policy": "Enable Password Policy",
  "t-enable-password-length-minimum": "Enable password length minimum",
  "t-password-length": "Minimum password length [value range: 4-32]",
  "t-required-item": "This item is required.",
  "t-password-length-minimum": "The minimum value is 4.",
  "t-password-length-maximum": "The maximum value is 32.",
  "t-password-policy-pattern": "This value must be an integer",
  "t-enable-password-part": "Enable password pattern",
  "t-password-numbers-and-letters-combination": "Password should be numbers and letters combination",
  "t-password-use-least-one-uppercase-letter": "Use at least one uppercase letter",
  "t-repeated-characters-not-allowed-to-use": "Repeated characters are not allowed to use",
  "t-allows-use-special-characters": "Allows the use of special characters (without spaces)",
  "t-use-least-one-special-character": "Use at least one special character",
  "t-different-user-name-and-password": "The username and password must be different",
  "t-whether-to-enable-history-password": "Whether to prohibit the use of historical passwords",
  "t-use-history-password-number": "Historical password number are not allowed to use [value range: 3-6]",
  "t-use-history-password-number-minimum": "The minimum value is 3.",
  "t-use-history-password-number-maximum": "The maximum value is 6.",
  "t-enable-password-change-frequency": "Whether to enable password change frequency",
  "t-password-change-frequency": "Password change frequency (days)  [value range: 1-9]",
  "t-password-change-frequency-minimum": "The minimum value is 1.",
  "t-password-change-frequency-maximum": "The maximum value is 9.",
  "t-change-the-password-regular-basis": "Whether to change the password on a regular basis",
  "t-password-periodically-change": "Password periodically change(days) [value range: 90-365]",
  "t-password-periodically-minimum": "The minimum value is 90.",
  "t-password-periodically-maximum": "The maximum value is 365.",
  "t-password-configuration-updated-successfully": "Password Policy updated successfully!",
  "t-error-updated-password-configuration": "Password Policy updated failed",
  "t-times-task": "Times Task",
  "t-execute-once": "Execute Once",
  "t-task-group": "Task Group",
  "t-method": "Method",
  "t-log-information": "Log Information",
  "t-cron-expression": "Cron expression",
  "t-clean-condition": "Clean Condition",
  "t-concurrent": "Concurrency",
  "t-wrong-strategy": "Wrong Strategy",
  "t-allow": "Allow",
  "t-prohibit": "Prohibit",
  "t-execute-immediately": "Execute Immediately",
  "t-next-execution-time": "Next Execution Time",
  "t-execute": "Execute",
  "t-cancel-execution": "Cancel Execution",
  "t-task-scheduler": "Task Scheduler",
  "t-task-scheduler-logs": "Task Scheduler Logs",
  "t-notice": "Notice",
  "t-alarm-settings": "Alarm Settings",
  "t-alarm": "Alarm",
  "t-alarm-mgmt": "Alarm Mgmt",
  "t-already-used": "Already Used",
  "t-silence-time": "Silence Time",
  "t-alert-logs": "Alarm Logs",
  "t-logs": "Logs",
  "t-alert-status-info-untreated": "Unprocessed",
  "t-alert-status-info-processed": "Processed",
  "t-alert-status-info-closed": "Closed",
  "t-alert-status-info-handle": "Process",
  "t-alert-status-info-close": "Close",
  "t-rule": "Rule",
  "t-alert-policies": "Alarm Policies",
  "t-policies": "Policies",
  "t-level": "Level",
  "t-alert-level": "Alarm Level",
  "t-alerts-cycles": "Alarm Cycles",
  "t-alert-channel": "Alarm Channel",
  "t-contacts-group": "Contacts Group",
  "t-contacts-user": "Contacts User",
  "t-alert-rule": "Alarm Rule",
  "t-email-alert-template": "Email Alarm Template",
  "t-email-template": "Email Template",
  "t-alert-rule-template": "Rule Template",
  "t-template-title": "Template Title",
  "t-template": "Template",
  "t-from-name": "From Name",
  "t-email-alert-content": "Email Template Content",
  "t-search-alert": "Alarm Name",
  "t-alert-notice": "Alarm Notice",
  "t-alert-policy": "Alarm Policy",
  "t-policy": "Policy",
  "t-alert-contacts": "Alarm Contacts",
  "t-alert-start-time": "Alarm Start Time",
  "t-alert-mechanism": "Alarm Mechanism",
  "t-notice-channels": "Notice Channels",
  "t-channels": "Channels",
  "t-first-sequence-notifier": "First Sequence Notifier",
  "t-second-sequence-notifier": "Second Sequence Notifier",
  "t-third-sequence-notifier": "Third Sequence Notifier",
  "t-notification-interval": "Next Notification Interval",
  "t-error-sms-not-enable": "There is no enabled SMS settings",
  "t-error-email-not-enable": "There is no enabled email settings",
  "t-enable-fence-alert": "Enable Fence Alarm",
  "t-policy-alert-rule-content": " Alarm rule",
  "t-alert-channel-template-configuration": "Alarm Channel Template Configuration",
  "t-available-merge-fields": "Available Merge Fields",
  "t-sunday": "Sunday",
  "t-monday": "Monday",
  "t-tuesday": "Tuesday",
  "t-wednesday": "Wednesday",
  "t-thursday": "Thursday",
  "t-friday": "Friday",
  "t-saturday": "Saturday",
  "t-notifying-user": "Notify User",
  "t-notifying-partner": "Notify Partner",
  "t-notifying-customer": "Notify Customer",
  "t-notifying-merchat": "Notify Merchat",
  "t-notifying-text-message": "Short Message",
  "t-notifying-info": "Notification Message",
  "t-alert-status": "Notification Status",
  "t-alert-time": "Alarm Time",
  "t-ui": "UI",
  "t-wallpaper": "Wallpaper",
  "t-boot-picture": "Boot Picture",
  "t-boot-animation": "Boot Animation",
  "t-log-report": "Log & Report",
  "t-entity-value": "Entity Value",
  "t-system-health": "System Health",
  "t-gateway": "Gateway",
  "t-configuration": "Configuration",
  "t-health": "Health",
  "t-audit-logs": "Audit Logs",
  "t-tickets": "Tickets",
  "t-last-update-time": "Last Update Time",
  "t-disconnect": "Disconnect",
  "t-received": "Received",
  "t-unreceived": "Unreceived",
  "t-subject": "Subject",
  "t-user-mgmt": "User Mgmt",
  "t-user": "User",
  "t-authorities": "Authorities",
  "t-reset-password": "Reset Password",
  "t-activate-token": "Multi-Factor Authentication",
  "t-replace-token": "Replace MFA",
  "t-activate-user": "Activate User",
  "t-activate": "Activate",
  "t-deactivate": "Deactivate",
  "t-reboot": "Reboot",
  "t-warning-to-reboot": "Are you sure you want to Reboot device?",
  "t-warning-to-unbind": "Are you sure you want to unbind this record?",
  "t-lock": "Lock",
  "t-lock-device": "Lock Device",
  "t-warning-to-lock": "Are you sure you want to Lock device?",
  "t-unlock": "Unlock",
  "t-warning-to-unlock": "Are you sure you want to Unlock device?",
  "t-factory-settings": "Factory Reset",
  "t-warning-to-reset": "Are you sure Reset device to Factory Reset? This operation will result in data loss.Are you sure?",
  "t-warning-to-shut-down": "Are you sure you want to Shut Down device?",
  "t-shut-down-device": "Shut Down Device",
  "t-enable-geo-tracking": "Enable Geo Tracking",
  "t-disable-geo-tracking": "Disable Geo Tracking",
  "t-warning-to-geo-tracking": "Please note that enabling Geo-Tracking will cause Battery Power consumption.",
  "t-warning-to-disable-geo-tracking": "Are you sure you want to disable Geo-Tracking?",
  "t-device-geo-tracking-not-enable": "Geo-Tracking is not enabled on the device",
  "t-device-geo-tracking-has-enable": "The device has Geo-Tracking enabled",
  "t-enter-package-name": "Enter Package Name",
  "t-package-name-already-exists": "This package name already exists",
  "t-duplicate-package-name-warning": "Duplicate package names found: ",
  "t-duplicate-package-name-error": "Please remove duplicate package names: ",
  "t-device-sn": "Device SN",
  "t-device-name": "Device Name",
  "t-device-license-file-does-not-exist": "Device license file does not exist",
  "t-device-under-activation": "Device Under Activation OR Device Inactive",
  "t-device-is-out-of-range-activation-failed": "Device is out of range activation failed",
  "t-sync": "Sync",
  "t-cancel-geo-fencing": "Cancel Geo Fencing",
  "t-warning-to-cancel-geo-fencing": "Are you sure you want to Cancel Geo Fencing?",
  "t-device-not-support-pubkey-synchronization": "The device does not support pubkey synchronization, please check the device",
  "t-device-geo-location": "Device Geo Location",
  "t-geo-location": "Geo Location",
  "t-longitude": "Longitude",
  "t-latitude": "Latitude",
  "t-device-unbind-successful": "Device unbind successful",
  "t-device-bind-successful": "Device binding successful",
  "t-wait-pend": "Pending, please wait for the device to respond.",
  "t-warning-to-activate-kiosk": "Are you sure you want to Activate Kiosk?",
  "t-setting-version-type-general": "If this version is set to the General version,the following application will be modified to the Beta version.",
  "t-error-application-not-function": "The system application cannot perform this operation",
  "t-error-device-no-application": "No Such Application on device",
  "t-warning-to-deactivate-kiosk": "Are you sure you want to Deactivate Kiosk?",
  "t-device-is-disabled-status": "The device is disabled, please enable the device",
  "t-device-need-specified-area": "The device needs to return to the specified area",
  "t-device-need-specified-fence": "The device needs to return to the specified fence",
  "t-recover-key-success": "Recover key request sent to device successfully",
  "t-error-domineering-state-already": "There are already other apps in a domineering state",
  "t-app-has-dominated": "This app has dominated the screen, please do not send instructions again",
  "t-error-app-not-domineering-state": "The app is not in the domineering state",
  "t-error-device-not-app-in-dominant-state": "The device does not have an app in the dominant screen state",
  "t-error-current-domineering-state-already": "The current application is already in the dominant screen state",
  "t-warning-to-uninstall": "Are you sure you want to uninstall application",
  "t-warning-to-uninstall-block": "Are you sure you want to Uninstall Block?",
  "t-application-in-kiosk-mode": "The Application is in Kiosk Mode, please release Kiosk Mode firstly",
  "t-uninstall-application": "Uninstall APP",
  "t-device-not-activated": "The device is not activated",
  "t-device-not-online": "The device is not online",
  "t-request-sent-device": "Request sent to device successfully",
  "t-storm-restore-factory-settings": "Storm - Factory Reset",
  "t-device-restore-factory-settings": "Device - Factory Reset",
  "t-activate-request-sent": "Activate request sent to device successfully",
  "t-error-updating-device": "Error occurred while updating Device",
  "t-first-name": "First Name",
  "t-last-name": "Last Name",
  "t-deactivated": "Deactivated",
  "t-activated": "Activated",
  "t-role": "Role",
  "t-permissions-name-connot-replace": "Name format mismatch,The Name cannot be equal to any of 'ROLE_ADMIN', 'ROLE_OPERATOR','ROLE_PARTNER', or 'ROLE_USER'.",
  "t-auto-generate-password": "Auto Generate Password",
  "t-deactivate-user": "Deactivate User",
  "t-role-permissions": "Role Permissions",
  "t-permissions": "Permissions",
  "t-read": "Read",
  "t-write": "Write",
  "t-push": "Push",
  "t-record": "Record",
  "t-tid": "TID",
  "t-mid": "MID",
  "t-imei": "IMEI",
  "t-disable": "Disable",
  "t-tamper": "Tamper",
  "t-de-tamper": "De-Tamper",
  "t-report": "Report",
  "t-report-data": "Report Data",
  "t-report-settings": "Report Settings",
  "t-report-download": "Report Download",
  "t-sort-digit": "Sort Digit",
  "t-universal": "Universal",
  "t-widget": "Widget",
  "t-conditions": "Conditions",
  "t-attribute-code": "Attribute Code",
  "t-attribute-name": "Attribute Name",
  "t-attribute": "Attribute",
  "t-data-type": "Data Type",
  "t-attribute-type": "Attribute Type",
  "t-language-type": "Language Type",
  "t-enumerated-value": "Enumerated Value",
  "t-enumerated-name": "Enumeration Name",
  "t-association": "Association",
  "t-sql": "SQL",
  "t-chart": "Chart",
  "t-pie-chart": "Pie Chart",
  "t-bar-chart": "Bar Chart",
  "t-line-chart": "Line Chart",
  "t-time-frame": "Time Frame",
  "t-enumeration": "Enumeration",
  "t-string": "String",
  "t-internationalization": "Internationalization",
  "t-language": "Language",
  "t-charts": "Charts",
  "t-fixed-report": "Fixed Report",
  "t-dynamic-report": "Dynamic Report",
  "t-reason": "Reason",
  "t-time-limit": "Time Limit",
  "t-log-type": "Log Type",
  "t-seconds": "seconds",
  "t-minutes": "minutes",
  "t-hours": "hours",
  "t-numbers-letter": "Composed of uppercase and lowercase letters, numbers, and horizontal lines.",
  "t-input-invalid-pattern-default": "Composed of numbers, letters, underscores, dots, and spaces, it supports Chinese, English, French, Russian, and Spanish, and cannot start or end with spaces.",
  "t-input-invalid-pattern-default-arabic": "Composed of numbers, letters, underscores, dots, and spaces, it supports Chinese, English, French, Russian, Spanish, and Arabic, and cannot start or end with spaces.",
  "t-input-invalid-pattern-user-name": "Composed of numbers, letters, hyphens, and spaces, it supports Chinese, English, French, Russian, and Spanish, and cannot start or end with spaces.",
  "t-input-invalid-pattern-phone": "Consists of numbers, horizontal lines,+, and spaces, and cannot start or end with spaces or horizontal lines. Spaces and horizontal lines cannot be entered consecutively, and numbers with area codes start with+or 00.",
  "t-input-invalid-pattern-website": "Composed of URL format.",
  "t-input-invalid-pattern-host": "Composed of IP address format.",
  "t-input-invalid-pattern-email": "Example email format: abc@ftsafe.com",
  "t-input-invalid-pattern-smtp": "Composed of SMTP domain name format.",
  "t-input-invalid-pattern-sn": "Composed of uppercase and lowercase letters, numbers, and horizontal lines.",
  "t-input-invalid-pattern-imei": "Composed of pure numbers.",
  "t-input-invalid-pattern-device-imei": "IMEI can only enter numbers.",
  "t-input-invalid-pattern-tid": "Composed of uppercase and lowercase letters and numbers.",
  "t-input-invalid-pattern-key": "Composed of uppercase and lowercase letters, dots, and numbers.",
  "t-input-invalid-pattern-key-number": "Composed of uppercase and lowercase letters, dots.",
  "t-input-invalid-pattern": "Please enter a valid value. Please note that the first and end characters cannot be spaces.",
  "t-input-invalid-pattern-password": "Please enter a valid value. Include at least one number or letter. Please note that the first and end characters cannot be spaces.",
  "t-input-invalid-pattern-letters-numbers": "Only letters and numbers are allowed.",
  "t-minlength-valid-pattern": "Minimum character limit of ",
  "t-maxlength-valid-pattern": "Maximum character limit of ",
  "t-file-maximum-size": "File size should be maximum ",
  "t-file-upload-right-spec": "Please upload a file that meets the requirements.",
  "t-model-name": "Model Name",
  "t-operation": "Operation",
  "t-log-info": "Log Information",
  "t-clean-success": "Clean Job Log Successfully",
  "t-push-event-id": "Push Event ID",
  "t-input-password-mismatch": "Password mismatch",
  "t-generated": "generated",
  "t-entity": "Entity",
  "t-entity-name": "Entity Name",
  "t-app-incremental-upgrade": "APP Incremental Upgrade",
  "t-restart": "Restart",
  "t-shutdown-device": "Shut Down Device",
  "t-system-parameter": "System Parameter",
  "t-start": "Start",
  "t-end": "End",
  "t-stop": "Stop",
  "t-time": "Time",
  "t-geo-fencing": "Geo Fencing",
  "t-initialization": "Initialization",
  "t-erase": "Erase",
  "t-initial-key": "Initial Key",
  "t-geo-tracking": "Geo Tracking",
  "t-automatic": "Automatic",
  "t-sma-data-synchronization": "SMA Data Synchronization",
  "t-pubkey-synchronization": "PubKey Synchronization",
  "t-m20-transaction-param": "M20 Transaction Param",
  "t-push-select-device-group": "Please select the device or group that needs to be pushed.",
  "t-push-status-push-sent": "PUSH SENT",
  "t-push-status-push-received": "PUSH RECEIVED",
  "t-push-status-downloading": "DOWNLOADING",
  "t-push-status-installing": "INSTALLING",
  "t-push-status-executing": "EXECUTING",
  "t-push-status-success": "SUCCESS",
  "t-push-status-fail": "FAIL",
  "t-push-status-app-not-signed": "FAIL, APP NOT SIGNED",
  "t-push-status-install-later": "INSTALL LATER",
  "t-push-status-higher-version-exist": "FAIL, HIGHER VERSION EXIST",
  "t-push-status-app-not-installed": "FAIL, APP NOT INSTALLED",
  "t-push-status-broadcast-transmitted": "BROADCAST TRANSMITTED",
  "t-push-status-increment-file-error": "FAIL, INCREMENT FILE ERROR",
  "t-push-status-file-format-error": "FAIL, FILE FORMAT ERROR",
  "t-push-status-download-file-error": "FAIL, DOWNLOAD FILE ERROR",
  "t-push-status-task-reached-the-maximum": "FAIL, TASK REACHED THE MAXIMUM",
  "t-push-status-insufficient-electricity": "FAIL, INSUFFICIENT ELECTRICITY, TRY LATER",
  "t-push-status-app-patch-updating": "APP PATCH UPDATING",
  "t-push-status-app-patch-update-error": "FAIL,APP PATCH UPDATE ERROR",
  "t-push-status-parameter-error": "FAIL,PARAMETER ERROR",
  "t-push-status-download-completed": "DOWNLOAD COMPLETED",
  "t-push-status-same-task-exist": "FAIL,SAME_TASK_EXIST",
  "t-push-status-push-uploading": "PUSH UPLOADING",
  "t-push-status-push-ota-file-mismatch": "FAIL, PUSH OTA FILE MISMATCH",
  "t-push-status-start-capture": "START CAPTURE",
  "t-push-status-stop": "STOP",
  "t-push-status-key-parameter-error": "FAIL, KEY PARAMETER ERROR",
  "t-push-status-already-activated": "ALREADY ACTIVATED",
  "t-push-status-no-space-left-on-device": "FAIL, NO SPACE LEFT ON DEVICE",
  "t-push-status-initkey-failed": "CLEAN TAMPTER SUCCEED BUT INITKEY FAILED",
  "t-push-status-erase-tamper-failed": "FAIL, ERASE TAMPER FAILED",
  "t-push-status-close-2nd-sig-failed": "FAIL, CLOSE 2ND SIG FAILED",
  "t-push-status-open-2nd-sig-failed": "FAIL, OPEN 2ND SIG FAILED",
  "t-push-status-verify-2nd-sig-cert-failed": "FAIL, VERIFY 2ND SIG CERT_FAILED",
  "t-push-status-push-to-pulsar-failed": "FAIL, PUSH TO PULSAR FAILED",
  "t-push-status-push-to-mpush-failed": "FAIL, PUSH TO MPUSH FAILED",
  "t-push-status-status-push-sp-server-is-busy": "STATUS_PUSH_SP_SERVER_IS_BUSY",
  "t-push-status-reverted": "REVERTED",
  "t-push-status-factory-setting-cause-no-log": "FAIL, FACTORY SETTING CAUSE NO LOG",
  "t-push-status-md5-verification-failed": "FAIL, MD5 VERIFICATION FAILED",
  "t-push-status-device-offline": "DEVICE OFFLINE, RETRY LATER",
  "t-push-status-mpush-push-to-device-fail": "MPUSH PUSH TO DEVICE FAIL, RETRY LATER",
  "t-push-status-download-completed-wait-for-upgrade": "DOWNLOAD COMPLETED, WAIT FOR UPGRADE",
  "t-push-status-push-event-has-been-fetched": "PUSH EVENT HAS BEEN FETCHED",
  "t-push-status-get-push-event-fail": "FAIL, GET PUSH EVENT FAIL",
  "t-push-status-apk-install-failed-invalid": "FAIL, PUSH APK INSTALL FAILED INVALID",
  "t-push-status-apk-install-failed-system-mistake": "FAIL, PUSH APK INSTALL FAILED SYSTEM MISTAKE",
  "t-push-status-apk-install-failed": "FAIL, PUSH APK INSTALL FAILED SDCARD EXCEPTION OR NOT ENOUGH STORAGE",
  "t-push-status-apk-install-failed-certificate-mistake": "FAIL, PUSH APK INSTALL FAILED CERTIFICATE MISTAKE",
  "t-push-status-apk-install-failed-other": "FAIL, PUSH APK INSTALL FAILED OTHER",
  "t-push-status-init-key-failed": "FAIL, STATUS_PUSH_INIT_KEY_FAILED",
  "t-push-status-kiosk-mode-in-progress": "FAIL, KIOSK MODE IN PROGRESS",
  "t-push-status-network-issue": "FAIL, NETWORK ISSUE, TRY AGAIN LATER",
  "t-push-status-network-failed": "FAIL, STATUS_PUSH_NETWORK_FAILED",
  "t-push-status-unsupported-action": "FAIL, STATUS_PUSH_UNSUPPORTED_ACTION",
  "t-push-status-initialization-interupted": "FAIL, INITIALIZATION INTERUPTED",
  "t-push-status-cert-install-failed": "FAIL, CERT INSTALL FAILED",
  "t-push-status-apk-install-failed-device-os-version-not-support": "FAIL, PUSH APK INSTALL FAILED DEVICE OS VERSION NOT SUPPORT",
  "t-push-status-invalid-apk-file-caused-signature-failure": "FAIL, INVALID APK FILE CAUSED SIGNATURE FAILURE",
  "t-push-status-device-unusual-status-unactive": "FAIL, UNUSUAL STATUS DEVICE UNACTIVE",
  "t-push-status-device-unusual-status-geoFence": "FAIL, UNUSUAL STATUS GEO-FENCE OUT",
  "t-push-status-device-unusual-status-regionOut": "FAIL, UNUSUAL STATUS REGION OUT",
  "t-push-status-device-unusual-status-tamper": "FAIL, UNUSUAL STATUS TAMPER",
  "t-push-status-device-unusual-status-regionOut-tamper": "FAIL, UNUSUAL STATUS REGION OUT AND TAMPER",
  "t-push-status-device-unusual-status-region-geoFence": "FAIL, UNUSUAL STATUS REGION OUT AND GEO-FENCE OUT",
  "t-push-status-device-unusual-status-under-activation": "FAIL, UNUSUAL STATUS DEVICE UNDER ACTIVATION",
  "t-data-exception-sync-completed": "DATA EXCEPTION, SYNC COMPLETED",
  "t-data-is-normal-no-need-to-sync": "DATA IS NORMAL, NO NEED TO SYNC",
  "t-pubkey-uploaded": "PUBKEY UPLOADED",
  "t-pubkey-exception-sync-completed": "PUBKEY EXCEPTION, SYNC COMPLETED",
  "t-pubkey-is-normal-no-need-to-sync": "PUBKEY IS NORMAL, NO NEED TO SYNC",
  "t-push-status-push-has-expired-please-try-again": "FAIL, PUSH HAS EXPIRED PLEASE TRY AGAIN",
  "t-push-status-public_key_no_mismatch": "FAIL,PUBLIC KEY MISMATCH",
  "t-push-status-device-upgrading": "FAIL, TASK FAILED DUE TO ONGOING DEVICE UPGRADE.",
  "t-push-status-sp-unavailable-state": "FAIL, SP UNAVAILABLE STATE.",
  "t-push-status-app-not-enable-kiosk-mode": "FAIL, APP NOT ENABLE KIOSK MODE",
  "t-push-status-device-region-geoFence-tamper": "FAIL, UNUSUAL STATUS REGION OUT AND TAMPER AND GEO-FENCE OUT",
  "t-push-status-device-geoFence-tamper": "FAIL, UNUSUAL STATUS GEO-FENCE OUT AND TAMPER",
  "t-system-param-version": "System Param Version",
  "t-profile-details": "Profile Details",
  "t-profile": "Profile",
  "t-wallpaper-file": "Wallpaper File",
  "t-picture-file": "Boot Picture File",
  "t-animation-file": "Boot Animation File",
  "t-server-mfm-picture-resolution-not-match": "FAIL to upload, The picture resolution in the compressed package does not match!",
  "t-server-mfm-picture-format-not-match": "FAIL to upload, The picture Format in the compressed package does not match!",
  "t-server-mfm-boot-animatio-upload-failed": "FAIL to upload, The contents of the zip file do not comply with the boot animation picture rules!",
  "t-server-mfm-resolution-and-model-version-not-match": "FAIL to upload, The resolution and format of the file are the same as that of model version mismatch!",
  "t-key-capture-records-status-hsm-error": "HSM ERROR",
  "t-key-capture-records-status-kcv-value-error": "KCV KEYVALUE ERROR",
  "t-key-capture-records-status-public-key-not-exist": "DEVICE PUBLIC KEY NOT EXIST",
  "t-date-range-90-day": "The selected date range cannot exceed 90 days",
  "t-select-start-end-time": "Must select start time and end time",
  "t-In Progress": "In Progress",
  "t-Approved": "Approved",
  "t-action-type": "Action Type",
  "t-client": "Client",
  "t-client-ip": "Client Ip",
  "t-log-details": "Log Details",
  "t-add.profile.check.application": "Make sure that the signature APK is detected successfully.",
  "t-select.identical.application": "You have selected a duplicate application",
  "t-log-capture-not-start": "Capture Not Start",
  "t-log-capture-completed": "Capture Completed",
  "t-log-capture-failed": "Capture Failed",
  "t-log-capture-capturing": "Capturing",
  "t-plaintext": "Plaintext",
  "t-cipher": "Cipher",
  "t-bdk-lmk": "BDK / LMK",
  "t-error-match-password": "Confirm Password must be equal to Password.",
  "t-ui-settings": "UI Settings",
  "t-license-mgmt": "License Mgmt",
  "t-license": "License",
  "t-license-settings": "License Settings",
  "t-tamper-authorization-times": "Tamper Authorization Times",
  "t-number-assignable-authorizations": "Number of assignable authorizations",
  "t-license-information": "Authorized User",
  "t-allocate-authorization": "Allocate Authorization",
  "t-add-allocate-authorization": "Add Allocate Authorization",
  "t-edit-allocate-authorization": "Edit Allocate Authorization",
  "t-authorization-times": "Authorization Times",
  "t-remaining-times": "Remaining Times",
  "t-enter-authorization-times": "Enter Authorization times",
  "t-email-use-for-code": "The email used for receiving OTP verification code.",
  "t-allocate-authorization-created-successfully": "Allocate Authorization {param} created successfully!",
  "t-allocate-authorization-updated-successfully": "Allocate Authorization {param} updated successfully!",
  "t-allocate-authorization-updated-times.successfully": "Allocate Authorization times updated successfully!",
  "t-error-allocate-authorization-created": "Error occurred while created Allocate Authorization",
  "t-error-allocate-authorization-updated": "Error occurred while updated Allocate Authorization",
  "t-error-allocate-authorization-updated-times": "Error occurred while updated Allocate Authorization Times",

  "service.mpm.push.device.in.abnormal.status": "The device is in an abnormal state",
  "server.mdm.device.already.activated.not.modify.imei": "Device already activated, cannot update imei",
  "server.imei.cannot.be.empty": "IMEI cant not be empty!",
  "t-confirm-reset-password": "Are you sure you want to Reset Password?",
  "t-sent-reset-password": "Reset password email sent successfully.",
  "t-resend-token-email": "Send Activate QRCode",
  "t-correct": "Correct",
  "t-check-kcv-values": "Please enter both values.",
  "t-adb-enable": "ADB",
  "t-bluetooth-enable": "Bluetooth",
  "t-mobile-data-enable": "MobileData",
  "t-nfc-enable": "NFC",
  "t-hot-spot-enable": "HotSpot",
  "t-on": "ON",
  "t-off": "OFF",
  "t-no-content-selected": "No content selected",

  "t-key-capture-records-sn-repeatedly": "SN CANNOT IMPORT REPEATEDLY",
  "t-key-capture-records-sn-empty": "SN CANNOT BE EMPTY, AND THE SERIAL NUMBER CAN ONLY ENTER LETTERS, NUMBERS AND HORIZONTAL BARS",
  "t-key-capture-records-key-value-empty": "KEY VALUE CANNOT BE EMPTY",
  "t-key-capture-records-kcv-empty": "KCV CANNOT BE EMPTY",
  "t-key-capture-records-device-not-exist": "DEVICE NOT FOUND UNDER CURRENT CONDITIONS",
  "t-key-capture-records-sn-not-bound-partner": "SN IS NOT BOUND TO A PARTNER YET",
  "t-key-capture-records-device-not-belong-user": "THE DEVICE DOES NOT BELONG TO THE CURRENT USER",
  "t-key-capture-records-device-not-activated": "DEVICE NOT ACTIVATED",
  "t-key-capture-records-key-applied-device-model": "CANNOT BE APPLIED TO THIS DEVICE MODEL",
  "t-key-capture-records-failed-verify-countries-currencies": "FAILED TO VERIFY RELEVANT COUNTRIES AND CURRENCIES",
  "t-key-capture-records-tid-format-mismatch": "TID FORMAT MISMATCH",
  "t-key-capture-records-tid-repeated": "TID HAS BEEN REPEATED",
  "t-key-capture-records-tid-not-match-country-region": "THE TID QUANTITY COUNTRY REGION QUANTITY AND CURRENCY QUANTITY DO NOT MATCH",
  "t-key-capture-records-country-currency-not-empty": "COUNTRY AND CURRENCY CANNOT BE EMPTY AS TID IS NOT EMPTY",
  "t-key-capture-records-tid-not-empty": "COUNTRY OR CURRENCY IS NOT EMPTY TID CANNOT BE EMPTY",
  "t-key-capture-records-kcv-keyvalue-mismatch": "KCV KEYVALUE MISMATCH",
  "t-expiry-date": "Expiry Date",
  "t-papers-available": "Papers available",
  "t-out-of-papers": "Out of papers or not supported",
  "t-lack-of-paper": "Printer Receipt Status",
  "t-bind-device-information-details": "Bind device information details",
  "t-unbind-device-information-details": "UnBind device information details",
  "t-device-has-been-bind-partner-file": "device bind partner file (click to download)",
  "t-device-bind-confirm-info": "This device has been bound to partner. Are you sure you want to bind it to ",
  "t-role-type": "Role Type",
  "t-user-type": "User Type",
  "t-user-source": "User Source",
  "t-json": "JSON",
  "t-excel": "Excel",
  "t-release-notes": "Release Notes",
  "t-cloud-message": "Cloud Message",
  "t-select-duration": "Select Duration",
  "t-onboard-merchants": "Onboard Merchants",
  "t-access-key": "Access Key",
  "t-notifications": "Notifications",
  "t-signIn": "Iniciar sesion",
  "t-email-userName": "Email / User Name",
  "t-forgot-password": "Forgot Password",
  "t-devices": "Devices",
  "t-manufacturer-name": "Manufacturer Name",
  "t-manipulate": "Manipulate",
  "t-firmwares": "Firmwares",
  "t-applications": "Applications",
  "t-group-management": "Group Management",
  "t-key-capture-records": "Key Capture Report",
  "t-search-key-capture-records-details": "Search Records Details",
  "t-key-capture-records-details": "Key Capture Report Details",
  "t-key-capture-event-id": "Key Capture Event ID",
  "t-key-capture-records-status-success": "SUCCESS",
  "t-key-configuration": "Key Configuration",
  "t-status-check": "Status Check",
  "t-device-selection": "Device Selection",
  "t-complete": "Complete",
  "t-existing-records-found": "Found {count} existing records, latest Key:",
  "t-add-device-key": "Append to Latest Record",
  "t-add-device-key-tooltip": "Append the new key to the latest existing record",
  "t-regenerate-overwrite": "Regenerate",
  "t-regenerate-overwrite-tooltip": "Regenerate the key, will overwrite the original record",
  "t-key-new-title": "New Key",
  "t-key-new-description": "This is a new key configuration and can be created directly.",
  "t-key-exists-title": "Key Exists",
  "t-key-exists-description": "Detected existing key records with the same configuration.",
  "t-historical-records": "Historical Records",
  "t-no-key-record": "No Key Record",
  "t-select-devices": "Select Devices",
  "t-captured": "Captured",
  "t-uncaptured": "Uncaptured",
  "t-pubkey-changed": "Public Key Changed",
  "t-operation-option": "Operation Option",
  "t-operation-success": "Operation Success",
  "t-key-capture-complete": "Key capture completed",
  "t-view-report": "View Report",
  "t-capture-another": "Capture Another",
  "t-file-management": "File Management",
  "t-ads-reporter": "Ads Reporter",
  "t-push-scheduler": "Push Scheduler",
  "t-device-import": "Device Import",
  "t-manufacturer-import": "Manufacturer Import",
  "t-partner-import": "Partner Import",
  "t-customer-import": "Customer Import",
  "t-merchant-import": "Merchant Import",
  "t-store-import": "Store Import",
  "t-key-import": "Key Import",
  "t-device-upstream": "Device Upstream",
  "t-device-downstream": "Device Downstream",
  "t-user-management": "User Management",
  "t-roles-permissions": "Roles Permissions",
  "t-brands": "HSM",
  "t-ui-management": "UI Management",
  "t-system-params": "System Params",
  "t-keys-management": "Keys Mgmt",
  "t-media": "Media",
  "t-import-mgmt": "Import Mgmt",
  "t-log-mgmt": "Log Mgmt",
  "t-system-mgmt": "System Mgmt",
  "t-add-device": "Add Device",
  "t-edit-device": "Edit Device",
  "t-placeholder-enter-sn": "Enter SN",
  "t-error-enter-sn": "Sn name is required.",
  "t-error-enter-valid-sn": "Sn only allows input of uppercase and lowercase letters, numbers and horizontal bars.",
  "t-error-enter-valid-tid": "TID only allows input of uppercase and lowercase letters, numbers and horizontal bars.",
  "t-error-enter-minlength-sn": "Sn length cannot be less than 2.",
  "t-error-enter-minlength-tid": "TID length cannot be less than 2.",
  "t-placeholder-enter-imei": "Enter IMEI",
  "t-update-imei-successfully": "Update IMEI Successfully",
  "t-error-enter-imei": "IMEI is required.",
  "t-error-enter-minlength-imei": "IMEI length cannot be less than 2.",
  "t-error-enter-valid-imei": "IMEI can only enter numbers.",
  "t-error-enter-valid-pusheventid": "Push Event ID can only enter numbers.",
  "t-placeholder-enter-tid-name": "Enter TID Name",
  "t-error-enter-tid-name": "TID name is required.",
  "t-error-model-version-required": "ModelVersion is required.",
  "t-save-changes": "Save Changes",
  "t-saving": "Saving...",
  "t-search-by-model-name": "Search Model By Name",
  "t-search-device": "Search Device",
  "t-bind-devices": "Bind Devices",
  "t-unbind-devices": "UnBind Devices",
  "t-export-to-excel": "Export To Excel",
  "t-select-model-version": "-Model Version-",
  "t-search-by-name": "Search By Name",
  "t-all": "ALL",
  "t-search-selected-device": "Search Selected Device",
  "t-search-available-device": "Search Available Device",
  "t-required-partner": "Partner is required.",
  "t-enter-manufacturer": "Enter Manufacturer Name.",
  "t-loading-dashboard": "Loading Dashboard Module...",
  "t-signing-in": "Sigining in...",
  "t-error-manufacturer-required": "Manufacturer name is required.",
  "t-enter-website": "Enter Website",
  "t-error-url-required": "Please Enter Valid URL.",
  "t-select-logo": "Select Logo",
  "t-add-manufacturer": "Add Manufacturer",
  "t-edit-manufacturer": "Edit Manufacturer",
  "t-error-loading-category": "Error occurred loading Category",
  "t-error-loading-group": "Error occurred loading Group",
  "t-error-loading-production-batch": "Error occurred loading Production Batch",
  "t-error-loading-sales-batch": "Error occurred loading Sales Batch",
  "t-error-loading-model-version": "Error occurred loading Model Version",
  "t-error-loading": "Error occurred loading",
  "t-timeline-device-title": "Device Timeline",
  "t-device-created-successfully": "Device {sn}created successfully!",
  "t-error-created-device": "Error occurred while created device",
  "t-device-updated-successfully": "Device {sn}updated successfully!",
  "t-error-updated-device": "Error occurred while updated device",
  "t-package-name-required": "Package name is required.",
  "t-submit-kiosk": "Submit Kiosk",
  "t-uninstall-app": "Uninstall APP",
  "t-uninstall-application-successfully": "Application Uninstalled successfully",
  "t-error-occurred": "Error occurred",
  "t-no-data-avaliable": "No Data Available",
  "t-no-data": "No Data",
  "t-no-data-selected": "No Data Selected",
  "t-no-firmware-version-in-folder": "No available firmware version under this firmware folder",
  "t-lat": "Lat",
  "t-lng": "Lng",
  "t-device-out-of-region": "This device is out of region, please check the Region at Device Status",
  "t-technical-details": "Technical Details",
  "t-en": "EN",
  "t-android-version": "Android Version",
  "t-base-band-version": "Base Band Version",
  "t-battery-usage": "Battery Usage",
  "t-android-security-level": "Android Security Level",
  "t-system-type": "System Type",
  "t-google-play-system-update": "Google Play System Update",
  "t-cpu-usage": "CPU Usage",
  "t-emv-kernel-version": "EMV Kernel Version",
  "t-express-pay-kernel-version": "Express Pay Kernel Version",
  "t-ifm-module-name-version": "IFM Module Name Version",
  "t-jspeedy-kernel-version": "JSpeedy Kernel Version",
  "t-bootloader": "Bootloader",
  "t-kernel-version": "Kernel Version",
  "t-pay-pass-kernel-version": "Pay Pass Kernel Version",
  "t-pay-wave-kernel-version": "Pay Wave Kernel Version",
  "t-pcd-module-name-version": "PCD Module Name Version",
  "t-platform-type": "Platform Type",
  "t-printer-density": "Printer Density",
  "t-quics-kernel-version": "QUICS Kernel Version",
  "t-ram": "RAM",
  "t-ram-usage": "RAM Usage",
  "t-screen-density": "Screen Density",
  "t-storage": "Storage",
  "t-storage-usage": "Storage Usage",
  "t-cortex-scanner-version": "Cortex Scanner Version",
  "t-signal-type": "Signal Type",
  "t-telecom-operators": "Telecom Operators",
  "t-tamper-operation": "Double-click to release the tamper operation",
  "t-network-status": "Network Status",
  "t-system-status": "System Status",
  "t-gb": "GB)",
  "t-device-activated-successfully": "Device Activated Successfully!",
  "t-check-device-status": "Please check whether the equipment works normally.",
  "t-error-device-updated": "Device status updated failed",
  "t-device-status-updated-successfully": "Device status updated successfully",
  "t-clear-tamper": "Please clear tamper first",
  "t-model-created-successfully": "Model {sn}created successfully!",
  "t-model-updated-successfully": "Model {sn}updated successfully!",
  "t-model-deleted-successfully": "Model {param} deleted successfully!",
  "t-error-creating-model": "Error occurred while creating model",
  "t-error-loading-model": "Error occurred loading models",
  "t-error-loading-manufacturers": "Error occurred loading manufacturers",
  "t-error-loading-manufacturer": "Error occurred loading manufacturer",
  "t-add-model": "Add Model",
  "t-collapse": "Collapse",
  "t-restore": "Restore",
  "t-no-result-found": " No Result Found",
  "t-search-model": "Model",
  "t-search-manufacturer": "Manufacturer",
  "t-enter-model-name": "Enter Model Name",
  "t-model-name-required": "Model name is required.",
  "t-manufacturer-required": "Manufacturer is required.",
  "t-model-deleted ": "Model deleted successfully.",
  "t-error-deleting-model": "Error occurred while deleting model",
  "t-add-model-version": "Add Model Version",
  "t-edit-model-version": "Edit Model Version",
  "t-image-upload": "Image Upload",
  "t-please-upload": "Please upload Image.",
  "t-maximum-file-size": "File size should be maximum 300 kb.",
  "t-maximum-file-size-6m": "File size should be maximum 6 mb.",
  "t-please-upload-file-type": "Please upload bin 、zip file.",
  "t-please-upload-certificate-file": "Please upload cer file.",
  "t-please-upload-apk": "Please upload apk file",
  "t-please-upload-dat-zip": "Please upload dat or zip file",
  "t-device-binding": "Device Binding",
  "t-device-unbinding": "Device UnBinding",
  "t-enter-version-name": "Enter Version Name",
  "t-version-name-required": "Version name is required.",
  "t-actions": "Actions",
  "t-select-year": "Select Year",
  "t-year-required": "Year is required.",
  "t-enter-valid-year": "Please enter valid year.",
  "t-select-icon": "Select Icon",
  "t-resolution-required": "Resolution is required.",
  "t-model-required": "Model is required.",
  "t-search-model-version": "Model Version",
  "t-delete-model-version-confirmation": "Delete Model Version Confirmation",
  "t-delete-model-version": "Are you sure you want to delete the Model Version-{param} ?",
  "t-error-deleting-model-version": "Error occurred while deleting model version.",
  "t-select-valid-model": "Please select a valid model",
  "t-confirm-delete-operation": "Confirm Delete Operation",
  "t-warning-to-delete": "Are you sure you want to delete - {param}?",
  "t-manufacturer-deleted": "Manufacturer {param} deleted successfully!",
  "t-model-version-deleted": "Model Version {param} deleted successfully!",
  "t-mfa-configuration": "Partner Settings",
  "t-error-fill-mandatory-fields": "Please fill in all mandatory fields",
  "t-processing": "Processing",
  "t-reset-email-sent": "Email sent for reset password",
  "t-delete-model-confirmation": "Delete Model Confirmation",
  "t-delete-confirmation-model": "Are you sure you want to delete the Model - {param}?",
  "t-device-deleted-successfully": "Device {param} deleted successfully!",
  "t-error-deleted-device": "Error occurred while deleted device",
  "t-error-loading-devices": "Error occurred while loading Devices",
  "t-no-response-from-device": "No response from device.",
  "t-installed-applications": "Installed Applications",
  "t-add-application": "Add Application",
  "t-edit-application": "Edit Application",
  "t-add-application-version": "Add Application Version",
  "t-edit-application-version": "Edit Application Version",
  "t-application-version-saved-successfully": "Application Version {param} Saved Successfully!",
  "t-application-version-updated-successfully": "Application Version {param} Updated Successfully!",
  "t-search-application-version": "Application Version",
  "t-application-device-name": "Application Name",
  "t-version-name": "Version Name",
  "t-select-valid-application": "Please select a valid Application",
  "t-delete-application-version-confirmation": "Delete Application Version Confirmation",
  "t-warning-delete-application-version": "Are you sure you want to delete the Application Version-{param} ?",
  "t-application-version-deleted": "Application Version {param} deleted successfully!",
  "t-error-deleting-application-version": "Error occurred while deleting Application Version",
  "t-error-application-name-required": "Application name is required.",
  "t-error-application-pattern": "The application name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-placeholder-enter-application-name": "Enter Application Name",
  "t-placeholder-enter-application-description": "Enter Application Description",
  "t-error-loading-application": "Error occured while loading application",
  "t-application-created-successfully": "Application {param} created successfully!",
  "t-error-created-application": "Error occured while created application",
  "t-application-updated-successfully": "Application {param} updated successfully!",
  "t-error-updated-application": "Error occured while updated application",
  "t-application-version-file": "Application Version File",
  "t-select-application-file": "Select Application File",
  "t-placeholder-enter-application-version-name": "Enter Version Name",
  "t-error-application-version-required": "Application Version name is required.",
  "t-error-application-version-pattern": "The application version name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-error-application-required": "Application is required.",
  "t-error-loading-application-version": "Error occured while loading application version",
  "t-error-created-application-version": "Error occured while created application version",
  "t-error-updated-application-version": "Error occured while updated application version",
  "t-select-certificate": "Select Certificate",
  "t-select-certificate-to-signed": "Please select the certificate to use",
  "t-application-deleted-successfully": "Application {param} deleted successfully!",
  "t-error-deleting-application": "Error occurred while deleting application",
  "t-application-choose-type": "Please choose type of copy to download {param}",
  "t-cannot-submit-repeatedly": "Cannot submit repeatedly",
  "t-activate-kiosk": "Activate Kiosk",
  "t-deactivate-kiosk": "Deactivate Kiosk",
  "t-activate-kiosk-mode": "Activate Kiosk Mode",
  "t-deactivate-kiosk-mode": "DeActivate Kiosk Mode",
  "t-device-bulk-upload": "Devices Bulk Upload",
  "t-manufacturer-bulk-upload": "Manufacturer Bulk Upload",
  "t-partner-bulk-upload": "Partner Bulk Upload",
  "t-merchant-bulk-upload": "Merchant Bulk Upload",
  "t-store-bulk-upload": "Store Bulk Upload",
  "t-customer-bulk-upload": "Customer Bulk Upload",
  "t-import-devices": "Import Devices",
  "t-from-date": "From Date",
  "t-to-date": "To Date",
  "t-error-from-date-required": "From Date is required.",
  "t-error-to-date-required": "To Date is required.",
  "t-state": "State",
  "t-delete-device-confirmation": "Delete Device Confirmation",
  "t-warning-to-delete-device": "Are you sure you want to delete the Device - {param}?",
  "t-warning-to-recover-device": "Are you sure recover tamper status from device?",
  "t-confirm-to-lock-device": "Are you sure you want to Un Lock the Device?",
  "t-delete-activated-device": "Cannot delete activated device.",
  "t-cannot-delete-device-has-tid": "Can not delete a device with defined TIDs.",
  "t-delete-device": "Delete Device",
  "t-add-transaction-param": "Add Transaction Param",
  "t-add-transaction-param-version": "Add Transaction Param Version",
  "t-search-transaction-param": "Transaction Param",
  "t-search-transaction-param-version": "Transaction Param Version",
  "t-transaction-param-version": "Transaction Param Version",
  "t-total-version": "Total Versions",
  "t-add-partner": "Add Partner",
  "t-search-push": "Push",
  "t-search-partner": "Partner",
  "t-add-customer": "Add Customer",
  "t-search-customer": "Customer",
  "t-edit-transaction-param": "Edit Transaction Param",
  "t-error": "Error",
  "t-error-loading-template": "Error occurred while loading template",
  "t-error-creating-template": "Error occurred while creating template",
  "t-error-update-template": "Error occurred while updating template",
  "t-invalid-json": "JSON is invalid",
  "t-validate": "Validate",
  "t-template-updated-successfully": "Transaction Param {param} updated successfully!",
  "t-template-created-successfully": "Transaction Param {param} created successfully!",
  "t-enter-transaction-paramName": "Enter Transaction Param Name",
  "t-required-transaction-name": "Transaction Param Name is required.",
  "t-action-code": "Action Code",
  "t-required-transaction-action-code": "Transaction Param Action is required.",
  "t-min-transaction-action-code": "Transaction Param Action must be greater than 200.",
  "t-max-transaction-action-code": "Transaction Param Action must be less than 299.",
  "t-pattern-transaction-action-code": "Transaction Param Action can only be a number.",
  "t-enter-action-code": "Enter Action Code",
  "t-transaction-deleted-successfully": "Transaction Param {param} deleted successfully!",
  "t-error-deleting-transaction": "Error occurred while deleting Transaction Param",
  "t-error-deleting-transaction-child": "There is a transaction param version under the transaction param. Please delete the transaction param version first!",
  "t-edit-transaction-param-version": "Edit Transaction Param Version",
  "t-enter-transaction-param-version-name": "Enter Transaction Param Version Name",
  "t-error-transaction-param-version-required": "Transaction Param version is required.",
  "t-enter-intent-name": "Enter Intent Name",
  "t-enter-file-name": "Enter File Name",
  "t-error-loading-template-param-version": "Error occurred while loading Transaction Param version",
  "t-template-version-updated-successfully": "Transaction Param Version {param} updated successfully!",
  "t-template-version-created-successfully": "Transaction Param Version {param} created successfully!",
  "t-error-creating-transaction-param-version": "Error occurred while creating Transaction Param version",
  "t-error-updating-transaction-param-version": "Error occurred while updating Transaction Param version",
  "t-groups": "Groups",
  "t-search-group": "Group",
  "t-add-group": "Add Group",
  "t-edit-group": "Edit Group",
  "t-search-group-device": "Search Group Device",
  "t-group-name-required": "Group name is required.",
  "t-group-name-pattern": "The group name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-enter-group-name": "Enter Group Name",
  "t-group-created-successfully": "Group {param} created successfully!",
  "t-error-group-created": "Error occurred while created group",
  "t-group-updated-successfully": "Group {param} updated successfully!",
  "t-error-group-updated": "Error occurred while updated group",
  "t-drag-device-to-group": "Drag device from available list to selected list",
  "t-to": "To",
  "t-device-update": "Device Update",
  "t-updated-group-device-successfully": "Update group {param} successfully!",
  "t-please-enter-name": "Please Enter Name.",
  "t-minimum-radius": "Minimum Radius should be 50.",
  "t-maximum-radius": "Maximum Radius should be 9999.",
  "t-duration-in-hours": "Duration in Hours",
  "t-please-enter-duration": "Please Enter Duration.",
  "t-minimum-duration": "Minimum Duration should be 0.",
  "t-maximum-duration": "Maximum Duration should be 72.",
  "t-please-enter-action": "Please Enter Action.",
  "t-already-have-lock-action": "If you already have Lock action, warning action should lower than Lock duration, because Device will not let any further actions be executed after Lock action.",
  "t-add-locak-action-info": "If you add Lock Action, the Duration should bigger than the latest duration, because If you choose Lock action, Device will not let any further actions be executed after this action.",
  "t-invalid-warning-message": "Invalid Warning Message",
  "t-invalid-action": "Invalid Action",
  "t-invalid-duration": "Invalid Duration",
  "t-geo-fence-created-successfully": "Geo Fence {param} created Successfully",
  "t-error-geo-fence-created": "Error occurred while created geo fence",
  "t-geo-fence-updated-successfully": "Geo Fence {param} updated Successfully",
  "t-error-geo-fence-updated": "Error occurred while updated geo fence",
  "t-category-name": "Category Name",
  "t-model-version-name": "Model Version Name",
  "t-production-batch-name": "Production Batch Name",
  "t-sales-batch-name": "Sales Batch Name",
  "t-select-valid-transaction-param": "Please select a valid Transaction Param",
  "t-delete-transaction-param-version-confirmation": "Delete Transaction Param Version Confirmation",
  "t-warning-delete-transaction-param-version": "Are you sure you want to delete the Transaction Param Version - {param}?",
  "t-transaction-param-version-deleted-successfully": "Transaction Param Version {param} deleted successfully!",
  "t-error-deleting-transaction-param-version": "Error occurred while deleting Transaction Param Version.",
  "t-please-check-values": "Please enter both values.",
  "t-check-value": "Check Value",
  "t-error-check-value": "Error occurred check value .",
  "t-error-combine-keys": "Error occurred combine keys.",
  "t-error-invalid-key-check": "Incorrect KCV value.",
  "t-error-loading-checking-key": "Error occurred while loading checking key.",
  "t-form-invalid-fill-mandatory": "Sorry! Form is Invalid. Please fill mandatory fields",
  "t-create-key": "Create key",
  "t-error-creating-key": "Error occurred while creating Key",
  "t-key-created-successfully": "Key {param} created successfully!",
  "t-error-key-created": "Error occurred while created key.",
  "t-add-key": "Add Key",
  "t-edit-key": "Edit Key",
  "t-error-loading-created": "Error occurred while loading key.",
  "t-error-loading-algorithms": "Error occurred while loading Algorithms.",
  "t-error-loading-partner": "Error occurred while loading partner.",
  "t-error-loading-keys": "Error occurred while loading keys.",
  "t-key-deleted-successfully": "Key {param} deleted successfully!",
  "t-error-deleting-key": "Error occurred while deleting Key",
  "t-key-name-criteria": "The Key name consists of letters, numbers, underscores, and cannot begin or end with a space.",
  "t-delete-key-confirmation": "Delete Key",
  "t-warning-delete-key": "Are you sure you want to delete Key - {param} ?",
  "t-zeros-not-allowed": "No zeros are allowed.",
  "t-enter-key-name": "Enter Key Name",
  "t-required-key-name": "Key name is required.",
  "t-enter-index": "Enter Index",
  "t-required-index": "Index is required.",
  "t-only-allowed-positive-integer-index": "Only positive integers are allowed.",
  "t-index-max": "The value of index cannot exceed 255.",
  "t-select-date": "Select Date",
  "t-select-customer": "Select Customer",
  "t-select-merchant": "Select Merchant",
  "t-select-store": "Select Store",
  "t-enter-key-group": "Enter Key Group",
  "t-required-key-group": "Key group is required.",
  "t-required-encrypted-key-under": "Encrypted Key Under is required.",
  "t-enter-key-value": "Enter Key Value",
  "t-required-key-value-1": "Key Value 1 is required.",
  "t-key-kcv": "KCV",
  "t-key-bdk-lmk": "BDK / LMK",
  "t-key-zmk-lmk": "ZMK / LMK",
  "t-key-lmk": "LMK Identifier",
  "t-required-key-kcv-1": "Key KCV 1 is required.",
  "t-expiry-date-greater-than-current-date": "Expiry Date should be greater than current Date",
  "t-execution-time-less-than-current-time": "The execution time should be greater than the current time",
  "t-expiration-time-less-than-current-time": "The expiration time should be greater than the current time",
  "t-error-loading-key": "Error occurred while loading key",
  "t-partners": "Partners",
  "t-keys": "Keys",
  "t-key-name": "Key Name",
  "t-is-required": "is required",
  "t-enter-kcv": "Enter KCV",
  "t-final-key": "Final Key",
  "t-full-apk": "Full APK",
  "t-patch-file": "Patch File",
  "t-application-certificate-message": "Device list are displayed depending on the approved certificate for customer.",
  "t-error-patch-file-fail": "Failed to generate Patch File",
  "t-create-patch-file-success": "Patch File generated successfully, start to push, please forward to Push Report for detailed status",
  "t-create-patch-file": "Start to generate Patch File",
  "t-required-type": "Type is required.",
  "t-required-version": "Version is required.",
  "t-list-group": "Group List",
  "t-list-device": "Device List",
  "t-list": "List",
  "t-search-by-serial-number": "Search Device By Serial Number",
  "t-sort": "Sort",
  "t-sort-asc": "Ascending",
  "t-sort-desc": "Descending",
  "t-sort-devices": "Sort Devices",
  "t-uploading": "Uploading",
  "t-please-select-group-devices": "Please select group or devices",
  "t-error-push-group-empty": "The selected group does not contain device!",
  "t-error-push-group-empty-by-model-version": "The selected group does not contain device with  Model Version {param} !",
  "t-error-push-group-store-empty": "The devices in the selected group do not have a store bound! ",
  "t-error-key-formation": "Error in Key formation.",
  "t-key-generation": "Key Generation",
  "t-error-push-operation": "Some devices may have problem in push operation",
  "t-error-push-device-inactive": "The selected device contains inactive status",
  "t-error-push-device-abnormal": "The selected device contains abnormal status",
  "t-push-completed-successfully": "Push {param} completed successfully",
  "t-push-batch-completed-successfully": "Push {param} has been sent, please go to Push Report for more details.",
  "t-push-device-certificate-unpush": "{param} Has been moved out of the partner and will not push again",
  "t-went-wrong": "Something went wrong",
  "t-add-folder": "Add File Folder",
  "t-edit-folder": "Edit File Folder",
  "t-required-file-name": "File name is required.",
  "t-file-name-pattern": "File name only supports letters, numbers, underscores and horizontal line.",
  "t-select-file-type": "Select File Type",
  "t-select-file": "Select File",
  "t-maximum-folder-file-size": "FileCreate File size should be maximum 100 MB.",
  "t-error-loading-folder": "Error occurred while loading file folder",
  "t-error-creating-folder": "Error occurred while creating file folder",
  "t-error-updating-folder": "Error occurred while updating file folder",
  "t-folder-created-successfully": "Folder {param} created successfully!",
  "t-folder-updated-successfully": "Folder {param} updated successfully!",
  "t-folder-deleted-successfully": "Folder {param} deleted successfully!",
  "t-required-folder-name": "File folder name is required.",
  "t-folder-name-pattern": "File folder name only supports letters, numbers, underscores and horizontal line.",
  "t-select-partner": "Select Partner",
  "t-warning-delete-folder": "Are you sure you want to delete {param} ?",
  "t-enter-folder-name": "Enter File Folder Name",
  "t-error-deleting-file": "Error occurred while deleting File",
  "t-file-deleted-successfully": "File {param} deleted successfully!",
  "t-select-folder": "Please select a valid File Folder",
  "t-file-created-successfully": "File {param} created successfully.",
  "t-create-file": "Add File",
  "t-create-folder": "Add file folder",
  "t-file-updated-successfully": "File {param} updated successfully.",
  "t-file-updated-failed": "Error occurred while updating File.",
  "t-error-select-file": "Please select an image that meets one of the {param} formats",
  "t-error-select-file-video": "Please select an video that meets one of the {param} formats",
  "t-file-creation-failed": "File Creation Failed",
  "t-warning-delete-file": "Are you sure you want to delete the File - {param}?",
  "t-add-file": "Add File",
  "t-edit-file": "Edit File",
  "t-search-file": "File",
  "t-search-advertisement": "Advertisement",
  "t-preview": "Preview",
  "t-file-uploaded-failed": "File uploaded failed.",
  "t-file-uploaded-successfully": "File uploaded successfully.",
  "t-select-role": "Select Role",
  "t-add-role": "Add Role",
  "t-edit-role": "Edit Role",
  "t-delete-role": "Remove Role",
  "t-delete-role-successfully": "Role-{param} deleted successfully!",
  "t-widget-settings": "Widget Settings",
  "t-enter-role-name": "Enter Role Name",
  "t-required-role-name": "Role name is required.",
  "t-role-name-criteria": "The role name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space.",
  "t-role-created-successfully": "Role {param}  created successfully!",
  "t-error-creating-role": "Error occurred while creating Role.",
  "t-role-updated-successfully": "Role {param}  updated successfully!",
  "t-error-updating-role": "Error occurred while updating Role.",
  "t-permissions-updated-successfully": "Permissions updated successfully",
  "t-permissions-error-updated": "Error occurred while updating Permissions",
  "t-permission": "Permission",
  "t-browser-local-time": "Browser local time",
  "t-panel-name": "Panel Name",
  "t-edit-system-param": "Edit System Param",
  "t-search-system-param": "Search System Param",
  "t-enter-system-param-name": "Enter System Param Name",
  "t-required-system-param": "System Param Name is required.",
  "t-error-loading-system-param": "Error occurred while loading System Param",
  "t-system-param-created-successfully": "System Param {param}  created successfully!",
  "t-error-creating-system-param": "Error occurred while creating System Param.",
  "t-system-param-updated-successfully": "System Param {param}  updated successfully!",
  "t-error-updating-system-param": "Error occurred while updating System Param.",
  "t-system-param-deleted-successfully": "System Param {param} deleted successfully!",
  "t-error-deleting-system-param": "Error occurred while deleting System Param.",
  "t-enter-system-param-version-name": "Enter System Param Version Name",
  "t-required-system-param-version": "System Param version is required.",
  "t-system-param-name-criteria": "The System Param version name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space.",
  "t-add-system-param-version": "Add System Param Version",
  "t-edit-system-param-version": "Edit System Param Version",
  "t-error-loading-system-param-version": "Error occurred while loading System Param Version",
  "t-system-param-version-created-successfully": "System Param Version {param} created successfully!",
  "t-error-creating-system-param-version": "Error occurred while creating System Param version.",
  "t-search-system-param-version": "Search System Param Version",
  "t-select-valid-system-param-version": "Please select a valid System Param",
  "t-delete-system-param-version-confirmation": "Delete System Param Version Confirmation",
  "t-warning-delete-system-param-version": "Are you sure you want to delete the System Param Version - {param}?",
  "t-system-param-version-deleted-successfully": "System Param Version {param} deleted successfully!",
  "t-error-deleting-system-param-version": "Error occurred while deleting System Param Version",
  "t-add-ui-settings": "Add UI Settings",
  "t-edit-ui-settings": "Edit UI Settings",
  "t-error-loading-ui-settings": "Error occurred while loading UI Settings.",
  "t-error-creating-ui-settings": "Error occurred while creating UI Settings.",
  "t-error-updating-ui-settings": "Error occurred while updating UI Settings.",
  "t-ui-settings-created": "Themes {param} created successfully!",
  "t-ui-settings-updated": "Themes {param} updated successfully!",
  "t-enter-ui-settings-name": "Enter Themes Name",
  "t-required-ui-settings": "Themes Name is required.",
  "t-error-description-pattern": "The Description consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space.",
  "t-enter-ui-settings-description": "Enter Themes Description",
  "t-required-ui-settings-action": "Themes action is required.",
  "t-file-type": "File Type",
  "t-search-ui-settings": "Search UI Settings",
  "t-error-deleting-ui-settings": "Error occurred while deleting Themes.",
  "t-ui-settings-deleted-successfully": "Themes {param} deleted successfully!",
  "t-no-preview-available-zip": "ZIP File. No Preview Available.",
  "t-no-preview-available-file": "Preview is not supported for this file.",
  "t-no-preview-available-video": "Video File. No Preview Available.",
  "t-browser-not-support-video-tags": "Your browser does not support video tags.",
  "t-preview-ui-settings": "Preview UI Settings",
  "t-download-failed": "Download Failed",
  "t-add-ui-settings-version": "Add UI Settings Version",
  "t-pushable": "Pushable",
  "t-ui-settings-version": "UI Settings Version",
  "t-please-select-valid-setting": "Please select a valid Setting",
  "t-warning-delete-ui-setting-version": "Are you sure you want to delete the Themes Version - {param}?",
  "t-confirmation-delete-ui-settings-version": "Delete Themes Version Confirmation",
  "t-ui-settings-version-deleted-successfully": "UI Settings Version {param} deleted successfully!",
  "t-error-deleting-ui-settings-version": "Error occurred while deleting UI Settings version",
  "t-enter-description": "Enter Description",
  "t-required-ui-setting": "Themes is required.",
  "t-ui-setting-version-file": "Themes Version File",
  "t-select-setting-file": "Select Setting File",
  "t-ui-setting-version": "Themes Version",
  "t-add-ui-setting-version": "Add Themes Version",
  "t-edit-ui-setting-version": "Edit Themes Version",
  "t-file-resolution-does-not-match": "File resolution does not match with Model resolution.",
  "t-file-type-does-not-match": "Please upload the correct file",
  "t-file-read-failed": "File reading failed, please re-upload",
  "t-ui-setting-version-file-type": "Please upload the {param} file.",
  "t-error-loading-setting-version": "Error occurred while loading Themes version.",
  "t-ui-setting-version-saved-successfully": "Themes version {param} saved successfully!",
  "t-ui-setting-version-updated-successfully": "Themes version {param} updated successfully!",
  "t-error-creating-ui-settings-version": "Error occurred while creating UI Settings version",
  "t-error-updating-ui-settings-version": "Error occurred while updating UI Settings version",
  "t-delete-brand": "Delete Brand",
  "t-brand": "Brand",
  "t-search-brand": "Search Brand",
  "t-add-brand": "Add Brand",
  "t-edit-brand": "Edit Brand",
  "t-warning-delete-model": "Are you sure you want to delete the Model - {param}?",
  "t-error-loading-brands": "Error occurred loading Brands",
  "t-brand-created-successfully": "Brand {param} created successfully!",
  "t-error-creating-brand": "Error occurred while creating Brand",
  "t-brand-updated-successfully": "Brand {param} updated successfully!",
  "t-error-updating-brand": "Error occurred while updating Brand",
  "t-brand-deleted-successfully": "Brand {param} deleted successfully!",
  "t-error-deleting-brand": "Error occurred while deleting HSM Setting",
  "t-enter-brand-name": "Enter Brand Name",
  "t-required-brand-name": "Brand Name is required.",
  "t-edit-model": "Edit Model",
  "t-error-updating-model": "Error occurred while updating Model.",
  "t-spec-url": "Spec Url",
  "t-enter-spec-url": "Enter SpecUrl",
  "t-required-spec-url": "Please enter valid spec Url.",
  "t-hsm-brand": "Hsm Brand",
  "t-add-interface": "Add Interface",
  "t-edit-interface": "Edit Interface",
  "t-error-loading-interfaces": "Error occurred loading Interfaces",
  "t-interface-created-successfully": "Interface {param} created successfully!",
  "t-error-creating-interface": "Error occurred while creating Interface",
  "t-interface-updated-successfully": "Interface {param} updated successfully!",
  "t-error-updating-interface": "Error occurred while updating Interface",
  "t-search-interface": "Search Interface",
  "t-enter-interface-name": "Enter Interface Name",
  "t-required-interface-name": "Interface name is required.",
  "t-enter-user-name": "Enter User Name",
  "t-required-user-name": "Please enter valid User Name.",
  "t-required-password": "Please enter valid Password.",
  "t-enter-primary-host": "Enter Primary Host",
  "t-required-primary-host": "Please enter valid Primary Host.",
  "t-enter-primary-port": "Enter Primary Port",
  "t-required-primary-port": "Please enter valid Primary Port number.",
  "t-enter-secondary-host": "Enter Secondary Host",
  "t-required-secondary-host": "Please enter valid Secondary Host.",
  "t-enter-secondary-port": "Enter Secondary Port",
  "t-required-secondary-port": "Please enter valid Secondary Port number.",
  "t-is-enable": "Is Enable",
  "t-select-valid-interface": "Please select a valid Interface",
  "t-delete-interface-confirmation": "Delete Interface Confirmation",
  "t-warning-delete-interface": "Are you sure you want to delete the Interface - {param}?",
  "t-delete-interface": "Delete Interface",
  "t-interface-deleted-successfully": "Interface {param} deleted successfully!",
  "t-error-deleting-interface": "Error while deleting Interface",
  "t-partner-name": "Partner Name",
  "t-enable-2FA": "Enable OTP",
  "t-enable-signature": "Enable Signature",
  "t-enable-remote-control": "Remote Control",
  "t-partner-setting": "Partner Setting",
  "t-search-user": "User",
  "t-add-user": "Add User",
  "t-edit-user": "Edit User",
  "t-error-creating-user": "Error occurred while creating User",
  "t-user-created-successfully": "User {param} created successfully!",
  "t-error-updating-user": "Error occurred while updating User",
  "t-required-email": "Email is required",
  "t-enter-correct-email": "Please enter the correct email format.",
  "t-enter-email": "Enter Email",
  "t-enter-first-name": "Enter FirstName",
  "t-required-first-name": "First Name is required.",
  "t-enter-last-name": "Enter LastName",
  "t-current-password": "Current Password",
  "t-new-password": "New Password",
  "t-please-fill-all-mandatory-fields": "Please fill all mandatory fields.",
  "t-user-password-changed-successfully": "User Password changed successfully,please login again!",
  "t-error-changing-user-password": "Current password incorrect Or Error occurred while changing user password",
  "t-user-profile": "User Profile",
  "t-user-avatar-modified-successfully": "User avatar modified successfully!",
  "t-user-avatar-modified-failed": "User avatar modified failed!",
  "t-user-avatar-deletion-successfully": "User avatar deleted successfully!",
  "t-user-avatar-deletion-failed": "User avatar deleted failed!",
  "t-user-avatar-select-failed": "Please select user avatar!",
  "t-user-avatar-not-exist": "User avatar not exist!",
  "t-roles": "Roles",
  "t-error-length-password": "Password length should be minimum ",
  "t-error-minimum-length-password": "Password length should be minimum 6",
  "t-error-maximum-length-password": "Password length should be maximum 32",
  "t-error-password-criteria": "Password format is a combination of numbers and letters.",
  "t-enter-confirm-password": "Enter Confirm Password",
  "t-warning-reset-password": "Are you sure you want to Reset Password?",
  "t-resend-email-successfully": "The user sent the email successfully!",
  "t-error-resend-email": "The user sent the email failed!",
  "t-delete-user": "Delete User",
  "t-cannot-delete-activated-user": "Cannot delete activated User.",
  "t-user-deactivated-successfully": "User Deactivated successfully.",
  "t-user-permission-update-successfully": "User permission updated successfully.",
  "t-user-activated-successfully": "User Activated Successfully",
  "t-reset-password-sent-successfully": "Reset password email sent successfully.",
  "t-user-activated-token-successfully": "User activated OTP successfully!",
  "t-user-updated-successfully": "User {param} updated successfully!",
  "t-warning-delete-user": "Are you sure you want to delete the user - {param1} {param2}?",
  "t-delete-user-confirmation": "Delete User Confirmation",
  "t-token-replaced-successfully": "User replaced OTP successfully!",
  "t-error-token-replace": "User replaced OTP failed!",
  "t-error-token-activation": "User activated OTP failed!",
  "t-group-deleted-successfully": "Group {param} deleted successfully!",
  "t-error-deleting-group": "Error occurred while deleting group",
  "t-delete-partner": "Delete Partner",
  "t-partner-deleted-successfully": "Partner {param} deleted successfully!",
  "t-error-deleted-partner": "Error occurred while deleted partner",
  "t-edit-partner": "Edit Partner",
  "t-error-loading-partners": "Error occurred loading partners",
  "t-partner-created-successfully": "Partner {param} created successfully!",
  "t-error-created-partner": "Error occurred while created partner",
  "t-partner-updated-successfully": "Partner {param} updated successfully!",
  "t-error-updated-partner": "Error occurred while updated partner",
  "t-required-continent-name": "Continent Name is required.",
  "t-required-region-name": "Region Name is required.",
  "t-required-country-name": "Country Name is required.",
  "t-select-continent": "Select continent",
  "t-select-region": "Select region",
  "t-error-loading-countries": "Error occurred loading countries",
  "t-enter-partner-name": "Enter Partner Name",
  "t-required-partner-name": "Partner Name is required.",
  "t-partner-name-criteria": "The partner name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space.",
  "t-enter-phone-no": "Enter Phone Number",
  "t-required-valid-phone-no": "Enter Valid Phone Number.",
  "t-enter-email-address": "Enter Email Address",
  "t-required-valid-email-address": "Please Enter Valid Email Address.",
  "t-enter-address": "Enter Address",
  "t-error-enter-valid-address": "Address only allows input of uppercase and lowercase letters, numbers and horizontal bars.",
  "t-required-parent-partner": "Please Enter Parent Partner.",
  "t-edit-customer": "Edit Customer",
  "t-enter-customer-name": "Enter Customer Name",
  "t-required-customer-name": "Customer name is required.",
  "t-required-customer": "Customer is required.",
  "t-customer-name-criteria": "The customer name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-error-loading-customers": "Error occurred loading customers",
  "t-customer-created-successfully": "Customer {param} created successfully!",
  "t-error-created-customer": "Error occurred while created customer",
  "t-customer-updated-successfully": "Customer {param} updated successfully!",
  "t-error-updated-customer": "Error occurred while updated customer",
  "t-warning-delete-customer": "Are you sure you want to delete the Customer - {param}?",
  "t-warning-delete-merchant": "Are you sure you want to delete the Merchant - {param}?",
  "t-warning-delete-store": "Are you sure you want to delete the Store - {param}?",
  "t-delete-customer": "Delete Customer",
  "t-customer-deleted-successfully": "Customer {param} deleted successfully!",
  "t-error-deleted-customer": "Error occurred while deleted customer",
  "t-add-merchant": "Add Merchant",
  "t-edit-merchant": "Edit Merchant",
  "t-enter-mid": "Enter MID",
  "t-error-loading-merchant": "Error occurred loading Merchant",
  "t-merchant-created-successfully": "Merchant {param} created successfully!",
  "t-error-created-merchant": "Error occurred while created merchant",
  "t-merchant-updated-successfully": "Merchant {param} updated successfully!",
  "t-error-updated-merchant": "Error occurred while updated merchant",
  "t-enter-merchant-name": "Enter Merchant Name",
  "t-required-merchant-name": "Merchant name is required.",
  "t-required-merchant": "Merchant is required.",
  "t-merchant-name-criteria": "The merchant name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-merchant-deleted-successfully": "Merchant {param} deleted successfully!",
  "t-error-deleted-merchant": "Error occurred while deleted merchant",
  "t-delete-merchant": "Delete Merchant",
  "t-search-merchant": "Merchant",
  "t-merchant-name": "Merchant Name",
  "t-error-loading-store": "Error occurred loading store",
  "t-store-created-successfully": "Store {param} created successfully!",
  "t-error-created-store": "Error occurred while created store",
  "t-store-updated-successfully": "Store {param} updated successfully!",
  "t-error-updated-store": "Error occurred while updated store",
  "t-enter-store-name": "Enter Store Name",
  "t-required-valid-customer": "Please select a valid customer",
  "t-required-valid-merchant": "Please select a valid merchant",
  "t-required-store-name": "Store name is required.",
  "t-store-name-criteria": "The store name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-search-store": "Store",
  "t-add-store": "Add Store",
  "t-edit-store": "Edit Store",
  "t-required-valid-store": "Please select a valid store",
  "t-delete-store": "Delete Store",
  "t-store-deleted-successfully": "Store deleted successfully!",
  "t-deleting-store": "Deleting Store",
  "t-error-store-deleted": "Error occurred while deleted store",
  "t-manufacturer-created-successfully": "Manufacturer {param} created successfully!",
  "t-error-manufacturer-created": "Error occurred while created manufacturer",
  "t-manufacturer-updated-successfully": "Manufacturer {param} updated successfully!",
  "t-error-manufacturer-updated": "Error occurred while updated manufacturer",
  "t-manufacturer-deleted-successfully": "Manufacturer {param} deleted successfully!",
  "t-error-manufacturer-deleted": "Error occurred while deleted manufacturer",
  "t-error-model-pattern": "The model name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-error-model-version-pattern": "The model version name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-error-format-required": "Format is required.",
  "t-model-version-created-successfully": "Model Version {param} created successfully!",
  "t-model-version-updated-successfully": "Model Version {param} updated successfully!",
  "t-error-creating-model-version": "Error occurred while created model version",
  "t-error-updated-model-version": "Error occurred while updated model version",
  "t-error-deleted-model": "Error occurred while deleted model",
  "t-error-deleted-model-version": "Error occurred while deleted model version",
  "t-error-deleting-transaction-param": "Error occurred while deleting Transaction Param",
  "t-transaction-param-deleted-successfully": "Transaction Param {param} deleted successfully!",
  "t-required-valid-group": "Please select a valid group",
  "t-firmware-deleted-successfully": "Firmware {param} deleted successfully!",
  "t-error-deleting-firmware": "Error occurred while deleting firmware",
  "t-required-valid-firmware": "Please select a valid firmware",
  "t-transaction-name-criteria": "The Transaction Param  name  consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space.",
  "t-firmware-version-deleted-successfully": "Firmware Version {param} deleted successfully!",
  "t-error-deleting-firmware,version": "Error occurred while deleting firmware",
  "t-download-firmware": "Download Firmware",
  "t-add-firmware-version": "Add Firmware Version",
  "t-edit-firmware-version": "Edit Firmware Version",
  "t-firmware-name": "Firmware Name",
  "t-search-firmware": "Firmware",
  "t-add-firmware": "Add Firmware",
  "t-edit-firmware": "Edit Firmware",
  "t-enter-firmware-name": "Enter Firmware Name",
  "t-required-firmware-name": "Firmware Name is required.",
  "t-firmware-name-criteria": "The firmware name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-error-loading-firmware": "Error occurred while loading firmware",
  "t-firmware-created-successfully": "Firmware {param} created successfully!",
  "t-error-creating-firmware": "Error occurred while creating firmware",
  "t-firmware-updated-successfully": "Firmware {param} updated successfully!",
  "t-error-updating-firmware": "Error occurred while updating firmware",
  "t-firmware-file": "Firmware File",
  "t-select-firmware-file": "Select Firmware file",
  "t-firmware-version-name": "Firmware Version Name",
  "t-required-version-name": "Version name is required.",
  "t-required-firmware": "Firmware is required.",
  "t-error-firmware-version-pattern": "The firmware version name consists of letters, numbers, underscores, dots and spaces, Horizontal line, and cannot begin or end with a space",
  "t-error-loading-firmware-version": "Error occured while loading firmware version",
  "t-firmware-version-created-successfully": "Firmware version {param} created successfully!",
  "t-error-creating-firmware-version": "Error occurred while creating firmware version",
  "t-firmware-version-updated-successfully": "Firmware version {param} updated successfully!",
  "t-error-updating-firmware-version": "Error occurred while updating firmware version",
  "t-manufacturer-consists": "The manufacturer name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-ui-settings-consists": "The Themes name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-log-capture-title-types": "Log Types",
  "t-log-capture-title-logs": "Logs",
  "t-log-capture-title-main": "MainLog",
  "t-log-capture-title-kernel": "KernelLog",
  "t-btn-stop": "Stop",
  "t-btn-capture": "Capture",
  "t-log-type-main": "mainLog",
  "t-log-type-kernel": "kernelLog",
  "t-create-log-capture-event": "Added capture log event successfully!",
  "t-search-logs": "Logs",
  "t-error-creating-log-capture": "Error occurred while capturing log",
  "t-log-capture-process": "In the process of capturing logs",
  "t-stop-log-capture-event": "Stop capturing log successfully!",
  "t-error-stop-log-capture-event": "Error occurred while stopping capture log!",
  "t-stop-log-capture-info": "Log capture task completed!",
  "t-error-enter-log-capture": "Please check whether the device Sn or log type has been filled in!",
  "t-download-log": "Download Log",
  "t-file-download-failed": "File download failed!",
  "t-error-log-forbidden": "The capture log has not been completed, please wait a moment!",
  "t-error-deleting-log-file": "Error occurred while deleting log file!",
  "t-delete-log-file": "Log File {param} deleted successfully!",
  "t-error-show-detail-log": "Error occurred while viewing details",
  "t-detail-log-title": "Log File:  {param} {{date}}",
  "t-add-log-capture-event": "Add Log Capture Event",
  "t-ap": "AP",
  "t-sp": "SP",
  "t-apFirmware": "AP",
  "t-spFirmware": "SP",
  "t-general-all": "General All",
  "t-to-include": "To Include",
  "t-otp-password": "OTP Password",
  "t-select-entity": "Select Entity",
  "t-other-settings": "Other Settings",
  "t-metadata": "MetaData",
  "t-available-servers": "Available Servers",
  "t-service": "Service",
  "t-url": "URL",
  "t-send": "Send",
  "t-enter-email-instructions-to-tou": "Enter your email and instructions will be sent to you!",
  "t-search-message": "Message",
  "t-enter-message": "Enter Message",
  "t-send-message": "Send Message",
  "t-message-mgmt": "Message Management",
  "t-required-duration": "Duration is required.",
  "t-required-message": "Message is required.",
  "t-message-sent": "Message Sent Successfully",
  "t-ad-planner": "Ad Planner",
  "t-add-ad-planner": "Add Ad Planner",
  "t-search-ad-planner": "Ad Planner",
  "t-enter-planner-name": "Enter Ad Planner Name",
  "t-required-planner-name": "Ad Planner Name is required",
  "t-add-advertisement": "Add Advertisement",
  "t-edit-advertisement": "Edit Advertisement",
  "t-error-end-time-greater-than-start": "End time should be greater than Start time",
  "t-advertisement-updated-successfully": "Advertisement {param} updated successfully!",
  "t-error-updating-advertisement": "Error occurred while updating advertisement",
  "t-advertisement-created-successfully": "Advertisement {param} created successfully!",
  "t-error-creating-advertisement": "Error occurred while creating advertisement",
  "t-error-loading-advertisement": "Error occurred while loading advertisement",
  "t-add-planner": "Add Planner",
  "t-edit-planner": "Edit Planner",
  "t-select-planner": "Please select a valid Ad Planner",
  "t-error-loading-planner": "Error occurred while loading Ad Planner",
  "t-planner-created-successfully": "Ad Planner {param} created successfully!",
  "t-error-created-planner": "Error occurred while created Ad Planner",
  "t-planner-updated-successfully": "Ad Planner {param} updated successfully!",
  "t-error-updated-planner": "Error occurred while updated Ad Planner",
  "t-delete-advertisement": "Delete Advertisement",
  "t-advertisement-deleted-successfully": "Advertisement {param} deleted successfully!",
  "t-error-deleting-advertisement": "Error occurred while deleting advertisement",
  "t-advertisement-expired": "Advertisement has expired",
  "t-advertisement-end-time": "End time should be greater than current time",
  "t-planner-deleted-successfully": "Planner {param} deleted successfully!",
  "t-error-deleting-planner": "Error occurred while deleting planner",
  "t-warning-delete-advertisement": "Are you sure you want to delete the Advertisement - {param}?",
  "t-warning-delete-planner": "Are you sure you want to delete the Planner - {param}?",
  "t-select-ads-start-date": "Select Adv Start Date",
  "t-select-ads-end-date": "Select Ads End Date",
  "t-ads-name": "Ads Name",
  "t-ads-name-required": "Ads Name is required.",
  "t-enter-ad-name": "Enter Ads Name",
  "t-ads-start-required": "Ads Start Date is required.",
  "t-ads-end-required": "Ads End Date is required.",
  "t-enter-detail-url": "Enter Detail URL",
  "t-detail-url-required": "Detail Url is required.",
  "t-start-date": "Start Date",
  "t-end-date": "End Date",
  "t-message-name-required": "Message name is required.",
  "t-required-message-type": "Message type is required.",
  "t-message-content-required": "Message content is required.",
  "t-placeholder-message-text": "Write text message here...",
  "t-select-execute-date": "Select Execute Date",
  "t-select-expired-date": "Select Expired Date",
  "t-select-executed-date": "Select Executed Date",
  "t-expiration-time-greater-than-execution-time": "Expiration time should be greater than execution time",
  "t-message-created-successfully": "Message {param} created  successfully!",
  "t-error-creating-message": "Error occurred while creating message",
  "t-message-updated-successfully": "Message {param} updated successfully!",
  "t-error-updated-message": "Error occurred while updated message",
  "t-folders": "File Folders",
  "t-available-files": "Available Files",
  "t-selected-files": "Selected Files",
  "t-start-remote-control": "Start Remote Control",
  "t-stop-remote-control": "Stop Remote Control",
  "t-account-not-exist": "This login account does not exist, please check carefully",
  "t-search-Keys": "Search Key",
  "t-details": "Details",
  "t-transaction-id": "Transaction ID",
  "t-payment-certificates": "TLS Certificate",
  "t-payment-application-certificates": "TLS Certificate",
  "t-add-payment-application-certificate": "Add TLS Certificate",
  "t-search-certificate": "Certificate",
  "t-add-certificate": "Add Certificate",
  "t-edit-certificate": "Edit Certificate",
  "t-enter-name": "Enter Name",
  "t-set-password": "Set Password",
  "t-enter-password": "Enter Password",
  "t-enter-new-password": "Enter New Password",
  "t-confirm-new-password": "Confirm New Password",
  "t-private-key-password": "Private Key Password",
  "t-certificateLevel-1": "Certificate Level 1",
  "t-certificateLevel-2": "Certificate Level 2",
  "t-level1-certificates": "Level 1 Certificates",
  "t-please-select-customer": "Please Select Customer.",
  "t-please-select-certificate": "Please Select Certificate.",
  "t-please-select-common-name": "Please enter Common Name.",
  "t-please-select-org-unit": "Please enter Org Unit.",
  "t-please-select-org-name": "Please enter Org Name.",
  "t-please-select-city": "Please enter City.",
  "t-please-select-state": "Please enter State.",
  "t-please-select-country": "Please enter Country.",
  "t-please-select-rsa-key": "Please Select RSA key.",
  "t-please-enter-password": "Please Enter Password.",
  "t-prohibit-enter-space": "Prohibit entering spaces.",
  "t-error-maximum-length-key-password": "Password length should be maximum 10.",
  "t-error-confirm-password-equal-new-password": "Confirm Password must be equal to New Password.",
  "t-signed-l2-certificate": "Signed L2 Certificate",
  "t-cert-name": "Certificate Friendly Name",
  "t-enter-common-name": "Enter Common Name",
  "t-enter-org-unit": "Enter Organization Unit",
  "t-enter-org": "Enter Organization",
  "t-enter-city": "Enter City",
  "t-enter-state": "Enter State",
  "t-enter-country": "Enter Country",
  "t-certificate-updated-successfully": "Certificate {param} update successfully",
  "t-certificate-created-successfully": "Certificate {param} created successfully",
  "t-reover-tamper-status": "Are you sure recover tamper status from device?",
  "t-recover-tamper-success": "Recover Tamper request sent to device successfully",
  "t-recover-tamper-error": "Recover Tamper request sent to device failed",
  "t-recover-key-error": "Recover key request sent to device failed",
  "t-add-message": "Add Message",
  "t-select-message": "Please select a valid Partner",
  "t-enter-message-name": "Enter Message Name",
  "t-warning-delete-messageList": "Are you sure you want to delete the message-{param} ?",
  "t-messageList-deleted-successfully": "Message {param} deleted successfully!",
  "t-error-deleting-messagelist": "Message deleted failed",
  "t-error-loading-message": "Error occurred while loading message",
  "t-create-message": "Add Message",
  "t-edit-message": "Edit Message",
  "t-key-bulk-upload": "Key Bulk Upload",
  "t-import-key": "Import Key",
  "t-update-type": "Update Type",
  "t-full": "Full",
  "t-patch": "Patch",
  "t-warning-delete-certificate": "Are you sure you want to delete the certificate-{param} ?",
  "t-cert-mgmt": "Certificate Mgmt",
  "t-create-certificate": "Create Certificate",
  "t-error-deleting-certificate": "Error occurred while deleting certificate",
  "t-certificate-deleted-successfully": "Certificate {param} deleted successfully!",
  "t-upload-successfully": "Upload file successfully!",
  "t-upload-failed": "Upload file failed!",
  "t-delete-sub-ca-confirm-tip": "Deleting this Sub CA will also delete the Server Cert and private key of the same partner; affected devices need to rebind.",
  "t-delete-server-cert-confirm-tip": "Deleting this Server Cert requires bound devices of the same partner to rebind.",
  "t-certificateLevel": "Certificate Level",
  "t-signature-success": "Certificate Generated Successful",
  "t-error-creating-certificate": "Error occurred while creating certificate",
  "t-error-updating-certificate": "Error occurred while updating certificate",
  "t-import-customer": "Import Customer",
  "t-import-manufacturer": "Import Manufacturer",
  "t-import-partner": "Import Partner",
  "t-import-merchant": "Import Merchant",
  "t-import-store": "Import Store",
  "t-search-folder": "File Folder",
  "t-timeline-device": "Timeline",
  "t-upload-certificate": "Upload Certificate",
  "t-login-confirm-partner": "Partner login detected, do you want to logout as partner or continue?",
  "t-created-date": "Create Date",
  "t-created-by": "Create By",
  "t-created-time": "Create Time",
  "t-partner-open-2nd-signature": " Partner has opened the second signature",
  "t-signed-by-feitian": "Signed By Feitian Cert",
  "t-add-profile": "Add Profile",
  "t-edit-profile": "Edit Profile",
  "t-delete-profile": "Delete Profile",
  "t-profile-name": "Profile Name",
  "t-partnerName": "PartnerName",
  "t-modelVersionName": "ModelVersionName",
  "t-profile-name-required": "Profile Name is required.",
  "t-profile-created": "Profile {param} created successfully!",
  "t-profile-updated": "Profile {param} updated successfully!",
  "t-error-creating-profile": "Error occurred while creating profile",
  "t-error-updating-profile": "Error occurred while updating profile",
  "t-select-least-operation": "Please select at least one Operation",
  "t-select-identical-application": "You have selected a duplicate application",
  "t-enable-profile-success": "Terminal Profiles Enabled Successfully",
  "t-enable-profile-close": "Terminal Profiles Close Successfully",
  "t-enable-profile-fail": "Terminal Profiles Enabled Failed",
  "t-delete-profile-error": "The terminal profile is enable and cannot be deleted!",
  "t-search-profile": "Profile",
  "t-warning-delete-profile": "Are you sure you want to delete the Profile - {param} ?",
  "t-delete-profile-confirmation": "Delete Profile Confirmation",
  "t-profile-deleted": "Profile {param} deleted successfully!",
  "t-cancel-push": "Abort Push",
  "t-abort": "Abort",
  "t-warning-delete-geo-fence": "Are you sure you want to delete the Geo Fence - {param} ?",
  "t-add-geo-fencing": "Add Geo Fencing",
  "t-edit-geo-fencing": "Edit Geo Fencing",
  "t-search-geo-fencing": "Geo Fencing",
  "t-save": "Save",
  "t-delete-file": "Delete File",
  "t-warning-message": "Warning Message",
  "t-warning-add-block-device": "If you choose Lock action, Device will not let any further actions be executed after this action.",
  "t-confirm-block-device": "Confirm Lock Device",
  "t-proceed": "Proceed",
  "t-fix-report": "Fixed Report",
  "t-start-time": "Start Time",
  "t-end-time": "End Time",
  "t-select-start-time": "Select Start Date",
  "t-select-end-time": "Select End Date",
  "t-error-exporting-report": "Error occurred while exporting report",
  "t-report-mgmt": "Report Mgmt",
  "t-select-all": "Select All",
  "t-select-current-page": "Select Current Page",
  "t-deselect-all": "Deselect All",
  "t-transaction-version-information": "STORM has already integrated TID & MID at Json according to SN automatically, so you do not need to set TID & MID inside the Json. If you still set TID & MID, we will use your version",
  "t-support-mgmt": "Support Mgmt",
  "t-tickets-updated-successfully": "Tickets updated successfully!",
  "t-error-push-ui-group-empty": "The selected group does not contain devices with the same model version!",
  "t-warning-to-delete-push-event": "Are you sure you want to delete the push event?",
  "t-push-event-deleted-successfully": "Push event deleted successfully!",
  "t-application-push-by-group-error": "{param} have not bind to Customer level, please bind them first!",
  "t-merchant-redirect-confirm": "Do you want to redirect to Merchant Portal? Or continue with STORM?",
  "t-merchant-redirect-title": "Redirect to Merchant Portal",
  "t-merchant-redirect": "Redirect",
  "t-abnormal-device": "Ab-normal Devices",
  "t-log-download-failed": "Log fetching failed, unable to download",
  "t-log-deleting-error": "When log fetching fails, you should prompt that log fetching fails and cannot be deleted",
  "t-account-exception": "Your account is in an abnormal state, please contact the administrator!",
  "t-account-permission-exception": "User permission has been updated, please contact the administrator!",
  "t-signed": "Signed",
  "t-unsigned": "Unsigned",
  "t-select-valid-partner": "Please select valid partner.",
  "t-password-mismatch": "Password mismatch",
  "t-support-gms": "Support Gms",
  "t-search-repository": "Repository",
  "t-repository": "Repository",
  "t-add-repository": "Add Repository",
  "t-edit-repository": "Edit Repository",
  "t-error-loading-repository": "Error occurred while loading Repository",
  "t-repository-updated-successfully": "Repository {param} updated successfully!",
  "t-error-updating-repository": "Error occurred while updating Repository",
  "t-repository-created-successfully": "Repository {param} created successfully!",
  "t-error-creating-repository": "Error occurred while creating Repository",
  "t-error-deleting-repository": "Error occurred while deleting Repository",
  "t-repository-name-criteria": "The repository name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-required-repository-name": "Repository Name is required.",
  "t-enter-repository-name": "Enter Repository Name",
  "t-add-cloud-message": "Add Cloud Message",
  "t-required-valid-cloud-message": "Please select a valid cloud message",
  "t-required-cloud-name": "Name is required",
  "t-token": "Token",
  "t-repository-deleted-successfully": "Repository {param} deleted successfully!",
  "t-cloud-message-deleted-successfully": "Cloud Message {param} deleted successfully!",
  "t-search-cloud-message": "Cloud Message",
  "t-cloud-name-criteria": "The cloud name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-enter-token": "Enter Token",
  "t-edit-cloud-message": "Edit Cloud Message",
  "t-error-loading-cloud-message": "Error occured while loading Cloud Message",
  "t-cloud-message-updated-successfully": "Cloud Message {param} updated successfully!",
  "t-error-loading-updating-cloud-message": "Error occured while updating Cloud Message",
  "t-cloud-message-created-successfully": "Cloud Message {param} created successfully!",
  "t-error-loading-creating-cloud-message": "Error occured while creating Cloud Message",
  "t-error-deleting-cloud-message": "Error occurred while deleting Cloud Message",
  "t-push-setting": "Push Setting",
  "t-error-deleting-folder": "Error occurred while deleting file folder",
  "t-cortex-scanner-import": "Cortex Scanner Import",
  "t-cortex-scanner-bulk-upload": "Cortex Scanner Bulk Upload",
  "t-import-cortex-scanner": "Import Cortex Scanner",
  "t-import-cortex-scanner-success": "File imported successfully！",
  "t-system-info": "System Info",
  "t-payment-kernel": "Payment Kernel",
  "t-device-configuration": "Device Configuration",
  "t-functional-info": "Functional Info",
  "t-push-install-type": "Install Type",
  "t-automatic-upgrade": "Automatic Upgrade",
  "t-push-transaction-detail": "Push Transaction",
  "t-push-is-mobile-traffic": "Whether to use mobile data",
  "t-push-start-time": "Start Time",
  "t-push-end-time": "End Time",
  "t-push-details": "Push Details",
  "t-activated-kiosk-mode": "Activated Kiosk Mode",
  "t-unActivated-kiosk-mode": "UnActivated Kiosk Mode",
  "t-push-abort-successfully": "Abort Push successfully!",
  "t-error-push-abort": "Error occurred while push abort",
  "t-push-event": "Push Event",
  "t-add-push-event": "Add Push Event",
  "t-edit-push-event": "Edit Push Event",
  "t-required-event-name": "Event name is required.",
  "t-event-name-pattern": "The Event name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-event-is-planned": "Is Planned",
  "t-required-action": "Action is required.",
  "t-search-group-by-name": "Search Group By Name",
  "t-search-device-by-sn": "Search Device By SN",
  "t-push-event-application-version": "Application & Versions",
  "t-old": "Old",
  "t-is-planned": "isPlanned",
  "t-inStalled-application": "InStalled Application",
  "t-push-event-firmware-version": "Firmware & Versions",
  "t-new-version": "New Version",
  "t-old-version": "Old Version",
  "t-enable-disable": "Enable / Disable",
  "t-ui-setting-list": "Themes List",
  "t-select-group-or-device": "Please select the Group or device that contains the Device",
  "t-select-application-to-install": "Please select the application version to push",
  "t-select-fireware-to-install": "Please select the fireware version to install",
  "t-select-application-to-uninstall": "Please select the application to unInstall",
  "t-select-ui-setting": "Please select the Themes",
  "t-push-event-created-successfully": "Push Event {param} created successfully",
  "t-error-created-push-event": "Error occurred while created push Event",
  "t-execution-time-greater-than-current-time": "Execution time should be greater than current time",
  "t-push-event-updated-successfully": "Push event {param} updated successfully",
  "t-import-device": "Import Device",
  "t-import-device-information-details": "Import device information details",
  "t-import-customer-information-details": "Import customer information details",
  "t-import-partner-information-details": "Import partner information details",
  "t-import-manufacturer-information-details": "Import manufacturer information details",
  "t-import-merchant-information-details": "Import Merchant information details",
  "t-import-store-information-details": "Import Store information details",
  "t-import-key-information-details": "Import key information details",
  "t-import-cortex-scanner-information-details": "Import cortex scanner information details",
  "t-push-key-empty-error": "There is no device matching the key under the group",
  "t-total-number": "Total number",
  "t-select-tid-to-use": "Please select the TID to use",
  "t-import-failed": "Import failed",
  "t-network-gateway-timeout": "Network request timed out, please try again!",
  "t-network-service-unavailable": "Maintenance in progress, please try again later!",
  "t-network-bad-gateway": "Invalid request, please try again!",
  "t-network-not-found": "The resource does not exist, please contact the administrator!",
  "t-network-forbidden": "No permission, no access!",
  "t-network-bad-request": "Request body error, please try again!",
  "t-network-method-not-allowed": "Method is not allowed, please try again!",
  "t-spring-configuration": "Spring configuration",
  "t-prefix": "Prefix",
  "t-properties": "Properties",
  "t-done": "Done",
  "t-property": "Property",
  "t-git-branch": "git-branch",
  "t-git-version": "git-version",
  "t-zone": "zone",
  "t-management-port": "management.port",
  "t-git-commit": "git-commit",
  "t-health-checks": "Health Checks",
  "t-service-name": "Service Name",
  "t-otp-mobile-installation-manual": "OTP Mobile installation manual",
  "t-otp-mobile-installation-manual-android": "OTP Mobile (Android) installation manual",
  "t-installation-manual-android-1": "1. Enter the Google market, search 'OTP Mobile', download it, and install it on your phone.",
  "t-installation-manual-android-2": "2. To open otp mobile App and open app for the first time, you need to enable a series of permissions to prevent problems during use. It is recommended that users enable these permissions.",
  "t-installation-manual-android-3": '3. Use the "scan" function to scan the QR code information in the email to activate the token.',
  "t-installation-manual-android-4": "4. After the activation is successful, the password value is displayed on the app interface.",
  "t-installation-manual-android-5": "5. When an ordinary user logs in, if the partner to which he belongs has enabled two-factor authentication, you need to fill in the password to log in.",
  "t-otp-mobile-installation-manual-ios": " OTP Mobile (IOS) installation manual",
  "t-installation-manual-ios-1": "1. Enter App store, search 'otp mobile token', to download and install it on your phone.",
  "t-installation-manual-ios-2": "2. Open otp mobile App.",
  "t-installation-manual-ios-3": '3. Use the "scan" function to scan the QR code information in the email to activate the token.',
  "t-installation-manual-ios-4": "4. After the activation is successful, the password value is displayed on the app interface.",
  "t-installation-manual-ios-5": "5. When an ordinary user logs in, if the partner to which he belongs has enabled two-factor authentication, you need to fill in the password to log in.",
  "t-password-configuration": "Password Policy",
  "t-passeord-use-least-one-uppercase-letter": "Use at least one uppercase letter",
  "t-not-allows-use-special-characters": "Do Not Allows the use of special characters",
  "t-not-allows-use-chinese-special-characters": "Do Not Allows the use of chinese special characters",
  "t-default-template": "Default Template",
  "t-user-changed-to-partner": "Role changed to partner: {param}",
  "t-smart-terminal-operations-remote-manager": "Smart Terminal Operations Remote Manager",
  "t-account-profile": "Profile",
  "t-sign-out": "Sign Out",
  "t-merchant-portal": "Merchant Portal",
  "t-storm": "STORM",
  "t-init-key": "InitKey",
  "t-password-does-not-match": "Password does not match",
  "t-password-changed": "Password changed, please login",
  "t-selectd-devices": "Selected Devices",
  "t-store-not-associated": "Store Not Associated",
  "t-push-group": "GROUP",
  "t-error-loading-group-device": "Error occurred while loading group device",
  "t-reset-password-link-invalid": "Password changed failed:The link is invalid",
  "t-changed-password": "Changed Password",
  "t-continue": "Continue",
  "t-invalid-credentials": "Invalid Credentials",
  "t-storm-version-release-notes": "STORM V1.3.3 Release Notes",
  "t-version-notes-content": "This version release we focus on the Report Module, Fixed Report will provides you a general view about data from different Modules.",
  "t-version-notes-one-title": "--Report Managment: Fixed Report",
  "t-version-notes-one-content": "STORM now gives you the Report generation function at here, STORM can generate multiple Report format from different perspectives: Device, Application, Firmware, Push and Timeline. Also support with PDF, Excel format Reports.",
  "t-version-notes-two-title": "--Device Network Status",
  "t-version-notes-two-content": "We now offer a variety of colours to indicate the status of different devices, so that users can get a quicker overview of the current network status of their device.",
  "t-version-notes-two-content-green": "Green: Online",
  "t-version-notes-two-content-red": "Red: Offline",
  "t-version-notes-two-content-orange": "Orange: Out Of Geo Fence",
  "t-version-notes-two-content-blue": "Blue: Under Activation",
  "t-version-notes-two-content-grey": "Grey: Inactive",
  "t-version-notes-three-title": "--Push Report",
  "t-version-notes-three-content": "STORM offers a conspicuous way to illustrate the push status, whether the push is Success, Fail, or Pending, user can receive the status at the very first eye sight according to specific color and numbers. Also, users can Abort the push when it is not too late, which means the request has not been pushed to device side.",
  "t-version-optimisaziton-points": "Optimisaziton Points：",
  "t-version-optimisaziton-points-one-title": "--Partner Selection update",
  "t-version-optimisaziton-points-one-content": "We used to just give users one type of search Partner name . Now we offer selection and search box two methods so that STORM can fit in different user perspectives.",
  "t-version-optimisaziton-points-two-title": "--Device Excel Export Report",
  "t-version-optimisaziton-points-two-content": "Inside Excel, there is more detailed information about a specific device, so that the user is able to reach more information in just 1 Excel.",
  "t-version-optimisaziton-points-three-title": "--Application Push Notification",
  "t-version-optimisaziton-points-three-content": "When pushing Application to a Group of Devices, if one or more Devices are not bind with Customer level, a notification will pop-up.",
  "t-certificate-file": "Certificate File",
  "t-select-certificate-file": "Select Certificate File",
  "t-select-start-end-time-limit": "The inspection time span cannot exceed three months",
  "t-select-multiple-options": "Please select at least one filter condition",
  "t-cannot-empty-existing-imei": "Cannot Empty Existing Imei",
  "t-required-payment-certificate-name": "TLS Certificate Name is required",
  "t-payment-certificate-saved-successfully": "TLS Certificate Saved Successfully",
  "t-payment-certificate-deleted-successfully": "TLS Certificate {param} deleted successfully!",
  "t-error-deleting-payment-certificate": "Error occurred while deleting TLS Certificate",
  "t-warning-to-delete-payments": "Are you sure you want to delete the TLS Certificate - {param}?",
  "t-delete-device-payments": "Delete TLS Certificate Confirmation",
  "t-enable-tid": "Edit TID",
  "t-key-expired": "Key Expired, please create a new one, in case the Key Index duplicated.",
  "t-sub-partner": "Sub Partner",
  "t-open-enable-otp": "Administrator Enable OTP",
  "t-otp-identification-code": "Token Identification Code",
  "t-token-identification-code-setting": "(OTP Mobile Token Appllication -> Setting -> About)",
  "t-required-identification-code": "Token Identification Code is required",
  "t-enter-otp-code": "Enter Token Identification Code",
  "t-generate-qr-code": "Generate QR Code",
  "t-otp-code-to-active": "Input OTP Code to active: ",
  "t-enter-otp-code-to-active": "Enter OTP Code",
  "t-generated-code": "Generated Code",
  "t-enter-generated-code-to-active": "Enter Generated Code",
  "t-required-otp-code": "OTP Code is required",
  "t-identification-code-criteria" : "The OTP Identification Code consists of numbers",
  "t-otp-code-criteria" : "The OTP Code consists of numbers",
  "t-please-generate-qr-code": "Please get the QR code first. ",
  "t-enable-update-token": "Replace Token",
  "t-active-otp-success": "Active OTP Success!",
  "t-error-enter-minlength-identification-code": "The Token Identification Code length cannot be less than 20.",
  "t-bind-token-sn": "The user has bound a token(Token Number: ",
  "t-activation-otp": "Activation OTP",
  "t-activation-otp-link-invalid": "Activation OTP failed:The link is invalid",
  "t-generate-qr-code-failed": "Failed to generate QR code",
  "t-activation-otp-failed": "Activation OTP failed",
  "t-error-reset-password": "Failed to reset password",
  "t-error-download-repeat": "The file has been downloaded, please do not download it again",
  "t-profile-application-layout": "If you have turn on Application Signature function(means you have uploaded Application Certification ), please make sure your devices bind to specific Customer!",
  "t-server-mfm-tlsCertificate-name-exists": "TLS Certificates with the provided name already exists.",
  "t-export-to-json": "Export To Json",
  "t-device-status": "Device Status",
  "t-versions": "Versions",
  "t-search-application": "Application",
  "t-tls-certificate-import": "TLS Certificate Import",
  "t-tls-certificate-bulk-upload": "TLS Certificate Bulk Upload",
  "t-import-tls-certificate": "Import TLS Certificate",
  "t-import-tls-certificate-information-details": "Import TLS Certificate information details",
  "t-tls-file-name": "File Name：{param}",
  "t-push-confirm": "Push Confirm",
  "t-install-cer": "Install.cer",
  "t-push-confirm-desc": "Please confirm you are going to push all Certificates to devices contained in the compressed file.",
  "t-tls-certificate": "TLS Certificate",
  "t-add-event": "Add Event",
  "t-modified-date": "Modified Date",
  "t-main-log": "Main Log",
  "t-bluetooth": "Bluetooth",
  "t-kernel-log": "Kernel Log",
  "t-security-processor-log": "Security Processor Log",
  "t-pos-server-log": "POS Server Log",
  "t-log-seconds": "seconds",
  "t-log-mins": "mins",
  "t-log-hour": "hour",
  "t-log-hours": "hours",
  "t-previous": "Previous",
  "t-today": "Today",
  "t-month-view": "Month View",
  "t-week-view": "Week View",
  "t-day-view": "Day View",
  "t-message-version": "Message Version",
  "t-search-firmware-version": "Firmware Version",
  "t-capturen-not-start": "Capture Not Start",
  "t-capture-completed": "Capture Completed",
  "t-capture-failed": "Capture Failed",
  "t-capturing": "Capturing",
  "t-modelversion": "Model Version",
  "t-firmwareversion": "Firmware Version",
  "t-applicationversion": "Application Version",
  "t-keymanagement": "Key Management",
  "t-message-management": "Message Management",
  "t-pushmanagement": "Push Management",
  "t-importmanagement": "Import Management",
  "t-logmanagement": "Log Management",
  "t-ui-mgmt": "UI Management",
  "t-roles---permissions": "Roles Permissions",
  "t-certificate-mgmt": "Certificate Mgmt",
  "t-rki-certificate": "Certificate",
  "t-application-certificate": "Application Certificates",
  "t-block~disable": "BLOCK~DISABLE",
  "t-disable~block": "DISABLE~BLOCK",
  "t-kiosk-mode-activated": "Kiosk Mode Activated",
  "t-install-app": "Install APP",
  "t-firmware-incremental-upgrade": "Firmware Incremental",
  "t-firmware-full-package": "Firmware incremental upgrade",
  "t-restart-device": "Restart Device",
  "t-storm-factory-reset-device": "Factory Reset - STORM",
  "t-device-factory-reset-device": "Factory Reset - Device",
  "t-unlock-device": "Unlock Device",
  "t-device-initialization": "Device Initialiazatioin",
  "t-start-log-capture": "Start Log Capture",
  "t-stop-log-capture": "Stop Log Capture",
  "t-erase-tamper": "Erase Tamper",
  "t-payment-application-certificate": "Payment Application Certificate",
  "t-automatic-active": "Automatic Active",
  "t-device-automatic-initialization": "Device Automatic Initialization",
  "t-transaction-parameter": "Transaction Parameter",
  "t-not-yet-executed": "Not yet executed.",
  "t-application---full-package": "Application - Full Package",
  "t-application---batch-update": "Application - Batch Update",
  "t-factory-reset-device---storm": "Factory Reset - STORM",
  "t-factory-reset-device---device": "Factory Reset - DEVICE",
  "t-please-improve-tid": "Please improve tid.",
  "t-please-clear-tid-bind": "Please remove all TIDs related with the SN.",
  "t-error-geo-fence-action-list": "The action list cannot be empty",
  "t-error-geo-fence-region-list": "The region list cannot be empty",
  "t-error-geo-fence-action": "The action cannot be empty",
  "t-maximize": "Maximize",
  "t-dashboard-widget-selection": "Dashboard Widget Selection",
  "t-ui-management-version": "UI Management Version",
  "t-system-params-version": "System Params Version",
  "t-action-create": "CREATE",
  "t-action-update": "UPDATE",
  "t-action-delete": "DELETE",
  "t-add-region": "Add Region",
  "t-password-configuration-select": "Select at least one password policy",
  "t-network-try-again": "Network error, please try again.",
  "t-connection-time-out": "Connection timed out, please try again.",
  "t-test-connection": "Test Connection",
  "t-connection-test-success": "Connection test successful",
  "t-connection-test-failed": "Connection test failed",
  "t-": "Wallpaper",
  "t-ui-management---boot-picture": "Boot Picture",
  "t-ui-management---boot-animation": "Boot Animation",
  "t-application-signed-failed": "Application Signed Fail",
  "t-add-profile-check-application": "Make sure that the signature APK is detected successfully.",
  "t-tid-require-valid": "If tid is filled in, country and current are required.",
  "t-profile-application-fail-cause": "Application Processing Status",
  "t-profile-uisettings-fail-cause": "Themes Processing Status",
  "t-profile-systemparam-fail-cause": "System Param Processing Status",
  "t-profile-application-name": "Application Name",
  "t-profile-application-version-name": "Application Version Name",
  "t-profile-firmware-fail-cause": "Firmware Fail Cause",
  "t-profile-firmware-processing-status": "Firmware Processing Status",
  "t-profile-firmware-name": "Firmware Name",
  "t-profile-firmware-version-name": "Firmware Version Name",
  "t-profile-fail-cause": "Fail Cause",
  "t-profile-uisettings-name": "Themes Name",
  "t-profile-uisettings-version-name": "Themes Version Name",
  "t-profile-systemparam-name": "System Param Name",
  "t-profile-systemparam-version-name": "System Param Version Name",
  "t-profile-systemparam-version": "System Param Version",
  "t-file-upload": "File Upload",
  "t-application-control": "Application Control",
  "t-remove-uninstall-block": "Remove Uninstall Block",
  "t-remove-password": "Remove Password",
  "t-app-set-uninstall-block": "APP Set Uninstall Block",
  "t-app-remove-uninstall-block": "APP Remove Uninstall Block",
  "t-app-set-password": "APP Set Password",
  "t-app-remove-password": "APP Remove Password",
  "t-configuration-success": "Application Setting has been sent to Device.",
  "t-error-enter-minlength-password": "Sn length cannot be less than 6.",
  "t-error-enter-password": "Password is required.",
  "t-warning-to-remove-uninstall-block": "Are you sure you want to Remove Uninstall Block?",
  "t-warning-to-logout": "Are you sure you want to log out？",
  "t-search-key": "Key",
  "t-email-name-required": "Email Settings Name is required.",
  "t-email-created-successfully": "Email Settings {param} created successfully!",
  "t-email-updated-successfully": "Email Settings {param} updated successfully!",
  "t-error-creating-email": "Error occurred while creating Email Settings",
  "t-error-updating-email": "Error occurred while updating Email Settings",
  "t-enable-email-success": "Email Settings Enabled Successfully",
  "t-enable-email-close": "Email Settings Closed Successfully",
  "t-enable-email-fail": "Email Settings Enabled Failed",
  "t-delete-email-error": "The email settings is enabled and cannot be deleted!",
  "t-search-email": "Email",
  "t-warning-delete-email": "Are you sure you want to delete the Email Settings - {param} ?",
  "t-delete-email-confirmation": "Delete Email Settings Confirmation",
  "t-email-deleted": "Email Settings {param} deleted successfully!",
  "t-add-email": "Add Email",
  "t-edit-email": "Edit Email",
  "t-enter-email-name": "Enter Email Name",
  "t-enter-email-server": "Enter Email Server",
  "t-enter-port": "Enter Port",
  "t-enter-email-account": "Enter Email Account",
  "t-enter-email-sender": "Enter Email Sender",
  "t-required-email-sender": "Email Sender is required",
  "t-error-email-name-pattern": "The email name consists of letters, numbers, underscores, dots and spaces, and cannot begin or end with a space",
  "t-error-email-server-required": "Email Server is required",
  "t-error-email-account-required": "Email Account is required",
  "t-error-email-port-required": "Port is required",
  "t-error-email-port-pattern": "Port should be between 1-65535",
  "t-error-email-host-pattern": "Please enter a legitimate mail server!",
  "t-search-push-detail": "Search Push Detail",
  "t-search-push-event": "Search Push Event",
  "t-search-log-capture-event": "Search Logs",
  "t-search-partner-setting": "Partner",
  "t-search-ui-settings-version": "Search UI Settings Version",
  "t-search-payment-application-certificate": "TLS Certificate",
  "t-search-message-sidebar": "Search Partner",
  "t-email-setting-connection-success": "Email Settings connection succeeded",
  "t-email-setting-connection-failed": "Email Settings connection failed",
  "t-lat-and-lng": "Lng&Lat",
  "t-version-low-to-upgrade": "The current version is too low to support this feature. Please upgrade the version.",
  "t-email-settings-enable-ssl": "SSL",
  "t-email-settings-enable-starttls": "STARTTLS",
  "t-email-settings-meanwhile-enbale": "SSL protocol and TLS protocol cannot be enabled at the same time",
  "t-error-update-application": "Update Applications Fail",
  "t-file-size-bigger": "File Size Bigger",
  "t-error-bind-device": "Device binding Fail",
  "t-error-unbind-device": "Device unbinding Fail",
  "t-required-transaction-param-version-name": "Transaction Param Version Name is required.",
  "t-required-package-name": "Package Name is required.",
  "t-required-intent-name": "Intent Name is required.",
  "t-upload-file": "Upload File",
  "t-deleted": "Deleted",
  "t-customer-name": "Customer Name",
  "t-store-name": "Store Name",
  "t-expired-at": "Expired At",
  "t-hsm-model-name": "Hsm Model Name",
  "t-pushes": "Pushes",
  "t-is-batch-upload": "isBatchUpload",
  "t-system-param-name": "System Param Name",
  "t-folder-name": "File folder Name",
  "t-batch-devices-details": "Batch bind/unbind devices information details",
  "t-model-type": "Model Type",
  "t-model-type-required": "Device Type is required.",
  "t-smart-pos": "Smart POS",
  "t-id-pos": "ID POS",
  "t-mpos": "MPOS",
  "t-task-scheduler-name": "Task Scheduler Name",
  "t-add-task-scheduler": "Add Task Scheduler",
  "t-edit-task-scheduler": "Edit Task Scheduler",
  "t-delete-task-scheduler": "Delete Task Scheduler",
  "t-warning-delete-task-scheduler": "Are you sure you want to delete the Task Scheduler - {param} ?",
  "t-task-scheduler-deleted": "Task Scheduler {param} deleted successfully!",
  "t-error-deleting-task-scheduler": "Error occurred while deleting Task Scheduler",
  "t-second": "Second",
  "t-cycle-by": "Cycle By",
  "t-not-specified": "Not Specified",
  "t-follow": "Follow",
  "t-this-month": "This Month",
  "t-this-week": "This Week",
  "t-specified": "Specified",
  "t-last-five-runs": "Last 5 Runs",
  "t-permissible-wildcards": "Permissible Wildcards",
  "t-last": "Last",
  "t-monthly": "Monthly",
  "t-most-recent-working-day": "The most recent working day",
  "t-warning-execute-task-scheduler": "Confirm to execute immediately once' {param} 'the task?",
  "t-error-execute-task-scheduler": "Error executing Task Scheduler",
  "t-enable-task-scheduler-success": "Task Scheduler Enabled Successfully",
  "t-enable-task-scheduler-close": "Task Scheduler Close Successfully",
  "t-enable-task-scheduler-fail": "Task Scheduler Enabled Failed",
  "t-please-select-model-version": "Please select model version!",
  "t-path": "Path",
  "t-execute-date": "Execute Date",
  "t-expired-date": "Expired Date",
  "t-empty-device-password": "The current device has not set a password lock yet",
  "t-rom-version": "Rom Version",
  "t-k21-version": "K21 Version",
  "t-memory-total": "Memory Total",
  "t-memory-available": "Memory Available",
  "t-flash-total": "Flash Total",
  "t-flash-available": "Flash Available",
  "t-battery": "Battery",
  "t-model-type-exist": "Model type already exists. Please delete the existing data and add it again.",
  "t-model-functions": "Model Functions",
  "t-error-enter-valid-cleancondition": "Clean Condition can only enter numbers.",
  "t-cleancondition": "Clean Condition",
  "t-set-version-type": "Set Version Type",
  "t-not-support-log-capture": "Traditional terminals do not support manual capture of logs",
  "t-example": "Example",
  "t-type-of-30-second": "Type 1 represents 30s",
  "t-type-of-60-second": "Type 2 represents 60s",
  "t-example-of-capture": '{"fileName":"11.txt","path":"","type":""}',
  "t-push-scheduled-tasks": "Push Scheduled Tasks",
  "t-executing": "Executing",
  "t-task-created": "Task Created",
  "t-search-push-scheduled-tasks": "Search Push Scheduled Tasks",
  "t-warning-to-cancel-push-scheduled-tasks": "Are you sure you want to abort push scheduled tasks?",
  "t-push-scheduled-tasks-abort-successfully": "Abort Push Scheduled Tasks successfully!",
  "t-error-push-scheduled-tasks-abort": "Error occurred while push scheduled tasks abort",
  "t-error-version-type-required": "Version Type is required",
  "t-not-support-log-capture-if-id": "The protocol type of this authentication terminal does not support capturing logs",
  "t-cancel-push-success": "Abort Push Success",
  "t-error-enter-maxlength-password": "Password length needs to be 6 digits.",
  "t-last-update-by": "Last Update By",
  "t-not-allow-same-duration": "The same Duration is not allowed.",
  "t-signature-file-currently-creating": "The signature file is currently being created...",
  "t-differential-package-creating": "Differential package in production...",
  "t-connection-type-required": "Connection Type is required.",
  "t-message-protocol-required": "Message Protocol is required.",
  "t-apk": "APK",
  "t-zip-dat": "ZIP|DAT",
  "t-file-type-required": "File type is required",
  "t-no-preview-available-tiff": "TIFF File. No Preview Available.",
  "t-inconsistent-apk-signatures-unable-push-patch-file": "Inconsistent application signatures, unable to push patch file",
  "t-enter-push-event-name": "Enter the push schedule task name",
  "t-downloading": "Downloading",
  "t-batch-delete": "Batch Delete",
  "t-confirm-batch-delete": "Are you sure you want to delete {count} items?",
  "t-batch-delete-devices": "Batch Delete Devices",
  "t-batch-delete-select-at-least-one": "Please select at least one item",
  "t-batch-delete-invalid-id-format": "Invalid ID format",
  "t-batch-delete-some-items-not-exist": "Some items do not exist",
  "t-batch-delete-request-failed": "Batch delete request failed",
  "t-batch-delete-no-permission": "No permission for batch delete",
  "t-batch-delete-success-count": "Successfully deleted {count} items",
  "t-batch-enable-device": "Enable Device",
  "t-batch-disable-device": "Disable Device",
  "t-batch-enable-disable-device": "Batch Enable And Disable Devices",
  "t-no-available-devices": "There is no device available, please check",
  "t-search-by-group-name": "Search By Group Name",
  "t-search-device-by-sn-tid-mid": "Search Device By SN、TID、MID",
  "t-batch-delete-device": "Delete Device",
  "t-batch-delete-devices-details": "Batch Delete Device Info",
  "t-support-upgrade-strategy-for-version-code": "SMA Version Code XXX and above support this upgrade strategy",
  "t-install-immediately-after-downloading": "Install immediately after downloading ",
  "t-install-immediately-for-tips": "Reminder: MMay affect the customer's ongoing operations",
  "t-automatic-upgrade-after-startup": "Automatic upgrade after startup",
  "t-select-installation-period": "Select installation period",
  "t-installation-time": "Installation Time",
  "t-input-invalid-apk-password": "Password only allows entering numbers.",
  "t-search-by-firmware": "Search By Firmware Name",
  "t-search-by-firmware-version": "Search By Firmware Version Name",
  "t-search-by-application": "Search By Application Name",
  "t-search-by-application-version": "Search By Application Version Name",
  "t-partner-mgmt": "Partner Mgmt",
  "t-customer-mgmt": "Customer Mgmt",
  "t-merchant-mgmt": "Merchant Mgmt",
  "t-system-general-parameter": "General Parameter",
  "t-add-wallpaper": "Add Wallpaper",
  "t-enter-wallpaper-name": "Enter Wallpaper Name",
  "t-wallpaper-name-required": "Wallpaper name is required.",
  "t-add-boot-picture": "Add Boot Picture",
  "t-enter-boot-picture-name": "Enter Boot Picture Name",
  "t-boot-picture-name-required": "Boot Picture name is required.",
  "t-add-boot-animation": "Add Boot Animation",
  "t-enter-boot-animation-name": "Enter Boot Animation Name",
  "t-boot-animation-name-required": "Boot Animation name is required.",
  "t-boot-picture-file": "Boot Picture File",
  "t-boot-animation-file": "Boot Animation File",
  "t-preview-wallpaper": "Preview Wallpaper",
  "t-preview-boot-picture": "Preview Boot Picture",
  "t-preview-boot-animation": "Preview Boot Animation",
  "t-retract": "Retract",
  "t-expand": "Expand",
  "t-app-mgmt": "App Mgmt",
  "t-please-select-installation-time": "Please select the first time after downloading the file.",
  "t-key-mgmt": "Key Mgmt",
  "t-firmware-mgmt": "Firmware Mgmt",
  "t-system-settings": "System Settings",
  "t-search-sn-tid-mid": "SN、TID、MID、IMEI",
  "t-search-sn-mid": "SN、MID、IMEI",
  "t-search-sn-tid": "SN、TID",
  "t-search-name-mid": "NAME、MID",
  "t-search-wallpaper": "Wallpaper",
  "t-search-boot-picture": "Boot Picture",
  "t-search-boot-animation": "Boot Animation",
  "t-search-hardware-parameter": "Hardware Parameter",
  "t-batch-operate-device": "Batch Operate Device",
  "t-apps-list": "Application",
  "t-app-certificates": "Application Certificates",
  "t-on-board-merchants": "Onboard Merchants",
  "t-device-status-tampered": "Tampered",
  "t-device-status-out-of-country": "Out Of Country",
  "t-device-status-out-of-fence": "Out Of Fence",
  "t-device-status-online": "On-Line",
  "t-device-status-offline": "Off-Line",
  "t-device-status-disabled": "Disabled",
  "t-edit-wallpaper": "Edit Wallpaper",
  "t-edit-boot-picture": "Edit Boot Picture",
  "t-edit-boot-animation": "Edit Boot Animation",
  "t-action-name": "Action Name",
  "t-currencyName": "CurrencyName",
  "t-add-hardware-parameter": "Add Hardware Parameter",
  "t-edit-hardware-parameter": "Edit Hardware Parameter",
  "t-add-system-general-parameter": "Add General Parameter",
  "t-edit-system-general-parameter": "Edit General Parameter",
  "t-error-push-search": "Push Search",
  "t-boot-picture-version-saved-successfully": "Successfully uploaded the first frame file after startup",
  "t-warning-unbind-device-for-group": "Are you sure you want to unbind the device -{param} ?",
  "t-unbind-device-confirmation": "Unbind Device Confirmation",
  "t-enable-device": "Enable Device",
  "t-disable-device": "Disable Device",
  "t-warning-delete-role": "Are you sure you want to delete the Role-{param} ?",
  "t-confirmation-delete-role": "Delete Role Confirmation",
  "t-select-valid-manufacturer": "Please select a valid manufacturer",
  "t-add-delete-device": "Add/Delete Device",
  "t-add-tls-certificate": "Add TLS Certificate",
  "t-delete-device-information-details": "Delete device information details",
  "t-enable-device-information-details": "Enable device information details",
  "t-disable-device-information-details": "Disable device information details",
  "t-add-search-device": "Add Devices to group",
  "t-error-enable-device": "Error occurred while enable device",
  "t-error-disable-device": "Error occurred while disable device",
  "t-user-sourse": "User Source",
  "t-start-time-than-end-time-one-hour": "The planned start time and planned end time must be greater than thirty minutes",
  "t-enter-tid": "Enter TID",
  "t-enter-hardware-param-version-name": "Enter Hardware Parameter Name",
  "t-required-hardware-param-version-name": "Hardware Parameter Name is required.",
  "t-enter-system-general-param-version-name": "Enter System General Parameter Name",
  "t-required-system-general-param-version-name": "System General Parameter Name is required.",
  "t-import-failed-info": "Import failed：",
  "t-import-file-not-allow-special-characters": "The uploaded file name cannot contain special characters.",
  "t-dateYear": "Date Year",
  "t-num": "Num",
  "t-placeholder-enter-device-secret": "Enter Device Secret",
  "t-placeholder-enter-product-key": "Enter Product Secret",
  "t-error-enter-device-secret": "Device secret is required.",
  "t-error-enter-product-key": "Product key is required.",
  "t-error-product-key-pattern": "Product key only allows input of uppercase letters and numbers.",
  "t-warning-delete-boot-animation": "Are you sure you want to delete the Boot Animation - {param}?",
  "t-confirmation-delete-boot-animation": "Delete Boot Animation Confirmation",
  "t-warning-delete-boot-picture": "Are you sure you want to delete the Boot Picture - {param}?",
  "t-confirmation-delete-boot-picture": "Delete Boot Picture Confirmation",
  "t-warning-delete-wallpaper": "Are you sure you want to delete the Wallpaper - {param}?",
  "t-confirmation-delete-wallpaper": "Delete Wallpaper Confirmation",
  "t-delete-system-general-parameter-version-confirmation": "Delete General Parameter Version Confirmation",
  "t-warning-delete-system-general-parameter-version": "Are you sure you want to delete the General Parameter Version - {param}?",
  "t-system-general-parameter-version-deleted-successfully": "General Parameter Version {param} deleted successfully!",
  "t-error-deleting-system-general-parameter-version": "Error occurred while deleting General Parameter Version",
  "t-system-general-parameter-version": "General Parameter Version",
  "t-delete-hardware-parameter-version-confirmation": "Delete Hardware Parameter Version Confirmation",
  "t-warning-delete-hardware-parameter-version": "Are you sure you want to delete the Hardware Parameter Version - {param}?",
  "t-hardware-parameter-version-deleted-successfully": "Hardware Parameter Version {param} deleted successfully!",
  "t-error-deleting-hardware-parameter-version": "Error occurred while deleting Hardware Parameter Version",
  "t-hardware-parameter-version": "Hardware Parameter Version",
  "t-system-general-parameter-version-created-successfully": "General Parameter Version {param}  created successfully!",
  "t-error-creating-system-general-parameter-version": "Error occurred while creating General Parameter version.",
  "t-error-loading-system-general-parameter-version": "Hardware Parameter Version {param} created successfully!",
  "t-hardware-parameter-version-created-successfully": "Hardware Parameter Version {param}  created successfully!",
  "t-error-creating-hardware-parameter-version": "Error occurred while creating System General Parameter version.",
  "t-error-loading-hardware-parameter-version": "Error occurred while creating Hardware Parameter version.",
  "t-boot-animation-saved-successfully": "Boot Animation {param} saved successfully!",
  "t-boot-picture-saved-successfully": "Boot Picture {param} saved successfully!",
  "t-wallpaper-saved-successfully": "Wallpaper {param} saved successfully!",
  "t-boot-animation-updated-successfully": "Boot Animation {param} updated successfully!",
  "t-boot-picture-updated-successfully": "Boot Picture {param} updated successfully!",
  "t-wallpaper-updated-successfully": "Wallpaper {param} updated successfully!",
  "t-error-updating-boot-animation": "Error occurred while updating Boot Animation",
  "t-error-updating-boot-picture": "Error occurred while updating Boot Picture",
  "t-error-updating-wallpaper": "Error occurred while updating Wallpaper",
  "t-error-creating-boot-animation": "Error occurred while creating Boot Animation",
  "t-error-creating-boot-picture": "Error occurred while creating Boot Picture",
  "t-error-creating-wallpaper": "Error occurred while creating Wallpaper",
  "t-error-loading-boot-animation": "Error occurred while loading Boot Animation.",
  "t-error-loading-boot-picture": "Error occurred while loading Boot Picture.",
  "t-error-loading-wallpaper": "Error occurred while loading Wallpaper.",
  "t-load-more": "Load More",
  "t-load-earlier-records": "View Earlier",
  "t-timeline-hint": "Currently showing push tasks from the past year only",
  "t-boot-animation-deleted-successfully": "Boot Animation {param} deleted successfully!",
  "t-boot-picture-deleted-successfully": "Boot Picture {param} deleted successfully!",
  "t-wallpaper-deleted-successfully": "Wallpaper {param} deleted successfully!",
  "t-error-deleting-boot-animation": "Error occurred while deleting Boot Animation",
  "t-error-deleting-boot-picture": "Error occurred while deleting Boot Picture",
  "t-error-deleting-wallpaper": "Error occurred while deleting Wallpaper",
  "t-recover-tamper-from-device": "Are you sure recover tamper status from device?",
  "t-enter-otp-from-email": "Please Enter OTP from email",
  "t-list-header-updated-successfully": "List Header updated successfully!",
  "t-list-header": "List Header",
  "t-push-record": "Push Report",
  "t-devices-report": "Devices Report",
  "t-dynamic-report-new": "Dynamic Report",
  "t-fixed-report-new": "Fixed Report",
  "t-functional-module": "Functional Module",
  "t-updated-successfully": "Updated successfully!",
  "t-required-report-name": "Report Name is required.",
  "t-required-report-language": "Language Type is required.",
  "t-required-report-attribute-name": "Attribute Name is required.",
  "t-deleted-successfully": "Delete successfully!",
  "t-push-name": "Push Name",
  "t-reduce": "Reduce",
  "t-increase": "Increase",
  "t-enable-tamper-auth": "Enable Tamper Auth",
  "t-otp-password-sent-successfully": "OTP password sent successfully!",
  "t-authorization-times-required": "Authorization times is required",
  "t-resend-in": "Resend in",
  "t-status-indicates-scheduled-task": "This status only indicates that the scheduled task has been created.",
  "t-update-authorization-times": "Update Authorization Times",
  "t-warning-delete-allocate-authorization": "Are you sure you want to delete the allocate authorization-{param} ?",
  "t-allocate-authorization-deleted-successfully": "Allocate authorization {param} deleted successfully!",
  "t-error-deleting-allocate-authorization": "Error occurred while deleting allocate authorization",
  "t-please-enter-authorization-times": "Please Enter Authorization Times.",
  "t-minimum-authorization-times": "Minimum authorization times should be 1.",
  "t-maximum-authorization-times": "Maximum authorization times should be 10000.",
  "t-error-loading-allocate-authorization": "Error occurred while loading allocate authorization",
  "t-async-download": "Report Download",
  "t-background-audio": "Background Audio",
  "t-upload-folder": "Upload Folder",
  "t-upload-folder-is-empty": "The uploaded file is empty",
  "t-upload-folder-maximum-length": "The maximum length of uploaded file should not exceed 100",
  "t-upload-folder-minimum-length": "The minimum length of uploaded file should not be less than 1",
  "t-number-of-cycles": "Number of cycles",
  "t-number-of-images-play-second": "Plays per second",
  "t-number-of-images-limited-sheets": "The number of files is limited to 1-100 sheets",
  "t-wav": "Wav",
  "t-sheets": "Sheets",
  "t-number-of-5": "1-5",
  "t-customize": "Customize",
  "t-license-information-name-required": "License Information Name is required.",
  "t-upload-license-information-file": "Upload License File",
  "t-edit-license-information": "Edit Notification Email",
  "t-error-license-information-created": "Error occurred while created License Information",
  "t-server-info": "Server Info",
  "t-enable-server-authorization": "Enable Server Authorization",
  "t-specified-deployment-server-info": "Specified Deployment Server Info",
  "t-ip-address": "IP Address",
  "t-mac-address": "Mac Address",
  "t-authorization-period": "Validity Period",
  "t-expiration-time-authorization": "Expiration time",
  "t-buffer-after-expiration": "Buffer After Expiration",
  "t-server-utc": "Server UTC",
  "t-enable-pre-expiration-alarms": "Enable Pre-expiration Alarms",
  "t-time-to-send-alarm-emails": "Time To Send Alarm Emails",
  "t-reminder-interval": "Reminder Interval",
  "t-licensed-nums": "Licensed Quantity",
  "t-num-of-devices": "Devices",
  "t-num-of-keys": "keys",
  "t-device-tamper-times": "Device Tamper Times",
  "t-num-of-partners": "Partners",
  "t-num-of-apps-installed": "Apps Installed",
  "t-num-of-firmwares": "Firmwares",
  "t-num-of-users": "Users",
  "t-num-of-merchants": "Merchants",
  "t-num-of-transaction-params": "Transaction Params",
  "t-send-email-notifications": "Send Email Notifications",
  "t-others": "Others",
  "t-enable-ads": "Advertisement",
  "t-enable-open-api": "Open API",
  "t-remaining": "Remaining",
  "t-days": "Days",
  "t-authorization-expiration-date": "Authorization Expiration Date",
  "t-please-charge-in-time": "Please Charge In Time",
  "t-the-authorization-file-has-expired": "The Authorization File Has Expired",
  "t-upload-authorization-file": "Please upload the license file",
  "t-alarm-email": "Notification Email",
  "t-enable-key-push": "Key",
  "t-created-successfully": "Created Successfully",
  "t-auth-file-parsing-failed": "Authorization File Parsing Failed",
  "t-planned-push-after-auth-period": "The planned push time cannot exceed the authorization validity period",
  "t-expired-by": "Expired by",
  "t-detamper": "De-Tamper",
  "t-task-created-successfully": "Task Scheduler created successfully!",
  "t-error-creating-task": "Error occurred while creating Task Scheduler",
  "t-task-updated-successfully": "Task Scheduler updated successfully!",
  "t-error-updating-task": "Error occurred while updating Task Scheduler",
  "t-player-second-cannot-exceed-total": "Plays per second cannot exceed the total number",
  "t-function-name": "Function Name",
  "t-key-block-value": "Key Block Value",
  "t-enter-key-block-value": "Enter Key Block Value",
  "t-required-key-block-value": "Key Block Value is required",
  "t-enter-lmk-index": "Enter LMK Index",
  "t-required-lmk-index": "LMK Index is required",
  "t-required-currency-code": "Currency is required",
  "t-required-country-code": "Country is required",
  "t-terminal-action-analysis": "Generate Terminal Code",
  "t-copy-close": "Copy & Close",
  "t-add-tid": "Add TID",
  "t-update-tid": "Update TID",
  "t-delete-tid": "Remove TID",
  "t-required-tid": "Tid is required.",
  "t-device-to-swap": "Device to Swap",
  "t-swap": "Swap",
  "t-swap-tid": "Swap TID",
  "t-menu-start-color": "Menu Start Color",
  "t-menu-end-color": "Menu End Color",
  "t-menu-text-color": "Menu Text Color",
  "t-partner-icon": "Partner Portal Logo",
  "t-cloud-message-push-history": "Cloud Message Push History",
  "t-push-history": "Push History",
  "t-expiry-unlimited": "Unlimited Expiry",
  "t-enable-cloud-messaging": "Cloud Message",
  "t-receipt-layout-details": "Receipt Layout Details",
  "t-receipt-type": "Receipt Type",
  "t-layout-name": "Layout Name",
  "t-receipt-layout": "Receipt Layout",
  "t-receipt-created": "Receipt Created.",
  "t-receipt-updated": "Receipt Updated.",
  "t-default-layout": "Default Layout",
  "t-add-new-row": "Add New Row",
  "t-add-new-column": "Add New Column",
  "t-create-row": "Create Row",
  "t-update-row": "Update Row",
  "t-other": "Other",
  "t-full-screen": "Full screen",
  "t-display": "Display",
  "t-row-number": "Row Number",
  "t-text-style": "Text Style",
  "t-text-align": "Text Align",
  "t-receipt-rows": "Receipt Rows",
  "t-label": "Label",
  "t-onboard-merchant": "Onboard Merchant",
  "t-feitian-iam": "FeiTian IAM",
  "t-feitian-partner": "FeiTian Partner",
  "t-user-activated": "Merchant user has been activated",
  "t-error-user-activation": "Error while activating merchant user.",
  "t-onboard-application": "Onboard Application",
  "t-server-mcm-enable-signature-error": "Cannot enable Signature, 2nd Level Certificate not found",
  "t-server-version-exists-different-partner": "There are version under different partner, cannot be edited",
  "t-server-version-exists-public-partner": "There are version under public partner, cannot be edited",
  "t-mobile-activated": "Mobile Activated",
  "t-kyc-completed": "Kyc Completed",
  "t-personal": "Personal Details",
  "t-mobile-number": "Mobile Number",
  "t-date-of-birth": "Date of Birth",
  "t-enter-date-of birth": "Please enter Date of Birth.",
  "t-citizenship": "Citizenship",
  "t-company": "Company Details",
  "t-country-of-registration": "Country Of Registration",
  "t-legal-form": "Legal Form",
  "t-company-name": "Company Name",
  "t-contact-number": "Contact Number",
  "t-contact-person": "Contact Person",
  "t-business-sector": "Business Sector",
  "t-business-activity": "Business Activity",
  "t-registered-company-street": "Registered Company Street",
  "t-registered-company-house-number": "Registered Company House Number",
  "t-registered-company-city": "Registered Company City",
  "t-registered-company-zip": "Registered Company Zip",
  "t-registered-company-country": "Registered Company Country",
  "t-tax-country": "Tax Country",
  "t-tax-id": "Tax Id",
  "t-bank": "Bank Details",
  "t-account-holder-name": "Account Holder Name",
  "t-account-type": "Account Type",
  "t-account-currency": "Account Currency",
  "t-bank-name": "Bank Name",
  "t-account-number": "Account Number",
  "t-additional": "Additional Details",
  "t-intent-of-use": "Intent Of Use",
  "t-source-of-use": "Source Of Income",
  "t-annual-turnover-foresee": "Annual Turnover Foresee",
  "t-expected-average-transaction-amount": "Expected Average Transaction Amount",
  "t-online-channel": "Online Channel",
  "t-documents": "Documents",
  "t-bank-statement": "Bank Statement",
  "t-id-proof": "ID Proof",
  "t-address-proof": "Address Proof",
  "t-address-proof1": "Address Proof1",
  "t-alert-mgmt": "Notice Mgmt",
  "t-alert-settings": "Alarm Settings",
  "t-add-alert": "Add Alarm Settings",
  "t-edit-alert": "Edit Alarm Settings",
  "t-notice-name": "Alarm Name",
  "t-notice-start-time": "Notice Start Time",
  "t-alert-level-info": "Common",
  "t-alert-level-warn": "Warn",
  "t-alert-level-critical": "Critical",
  "t-day-and-time": "Week",
  "t-notifying-email": "Email",
  "t-add-alert-contacts-group": "Add Contact Group",
  "t-edit-contacts-group": "Edit Contact Group",
  "t-search-alert-contacts-group": "Name",
  "t-contacts-group-name": "Name",
  "t-enter-contacts-group-name": "Enter Contact Group Name",
  "t-error-contacts-group-name-required": "Contact Group Name is required",
  "t-warning-delete-contactGroup": "Are you sure you want to delete the contact group {param} ?",
  "t-add-alert-policy": "Add Policy",
  "t-edit-alert-policy": "Edit Policy",
  "t-search-alert-policy": "Policy Name",
  "t-warning-delete-policy": "Are you sure you want to delete policy {param} ?",
  "t-policy-name": "Policy Name",
  "t-enter-policy-name": "Enter Policy Name",
  "t-error-policy-name-required": "Policy Name is required",
  "t-error-policy-rule-template-required": "Rule Template is required",
  "t-add-alert-contacts-user": "Add ContactPerson",
  "t-edit-contacts-user": "Edit ContactPerson",
  "t-search-alert-contacts-user": "First Name",
  "t-alert-status-info-unread": "Unread",
  "t-notice-default-rule": "Rule",
  "t-add-rule": "Add Rule Template",
  "t-edit-rule": "Edit Rule Template",
  "t-search-rule": "Search Rule Template",
  "t-enter-alert-rule-name": "Enter Rule Name",
  "t-error-alert-rule-name-required": "Rule Name is required",
  "t-error-alert-name-required": "Alarm Name is required",
  "t-alert-rule-updated-successfully": "Rule Template {param} update successfully !",
  "t-enable-tampered-alert": "Enable Tamper Alarm",
  "t-enable-out-of-country": "Enable Country Fence Alarm",
  "t-email-message": "Email Message",
  "t-error-delay-time-required": "The next notification interval is required",
  "t-error-delay-time-max": "The max next notification interval is ",
  "t-error-delay-time-min": "The min. next notification interval is 1",
  "t-error-alert-channel-required": "The notification channel is required",
  "t-error-alert-weeks-required": "The notification week required",
  "t-search-alert-alarm-template": "Template Title",
  "t-add-alert-alarm-template": "Add Email Alarm Template",
  "t-update-alert-template": "Modify Email Alarm Template",
  "t-please-select-the-person-to-alert": "Please select the Alarm person",
  "t-attestation": "Attestation",
  "t-add-attestation": "Add Attestation",
  "t-error-attestation-created": "Error occurred while creating Attestation",
  "t-error-attestation-updated": "Error occurred while updating Attestation",
  "t-attestation-updated-successfully": "Attestation Updated Successfully",
  "t-attestation-created-successfully": "Attestation Created Successfully",
  "t-attestation-deleted-successfully": "Attestation deleted successfully!",
  "t-error-deleting-attestation": "Error occurred while deleting Attestation",
  "t-search-attestation": "Search Attestation",
  "t-warning-delete-attestation": "Are you sure you want to delete the Attestation - {param} ?",
  "t-error-deleting-attestation-version": "Error occurred while deleting Attestation",
  "t-attestation-history": "Attestation History",
  "t-old-rule": "Old Rule",
  "t-new-rule": "New Rule",
  "t-view": "View",
  "t-attestation-monitor": "Attestation Monitor",
  "t-alert-settings-created-successfully": "Alarm Settings {param} create successfully !",
  "t-error-created-alert-settings": "Error creating Alarm Settings !",
  "t-alert-settings-updated-successfully": "Alarm Settings {param} update successfully !",
  "t-error-update-alert-settings": "Error updating Alarm Settings",
  "t-alert-settings-deleted-successfully": "Alarm Settings {param} delete successfully !",
  "t-error-deleting-alert-settings": "Error deleting Alarm Settings",
  "t-contacts-user-created-successfully": "Contact User create successfully !",
  "t-error-created-contacts-user": "An error occurred while creating a contact user !",
  "t-contacts-user-updated-successfully": "Contact user {param} update successfully",
  "t-error-update-contacts-user": "An error occurred while updating a contact user",
  "t-contacts-user-deleted-successfully": "Contact user {param} delete successfully",
  "t-error-deleting-contacts-user": "An error occurred while deleting a contact user",
  "t-contacts-group-created-successfully": "Contact Group {param} create successfully",
  "t-error-created-contacts-group": "An error occurred while creating contact group",
  "t-contacts-group-updated-successfully": "Contact Group {param} update successfully",
  "t-error-update-contacts-group": "An error occurred while updating contact group",
  "t-contacts-group-deleted-successfully": "Contact Group {param} delete successfully",
  "t-error-deleting-contacts-group": "An error occurred while deleting contact group",
  "t-alerts-policy-created-successfully": "Alarm policy {param} create successfully",
  "t-error-created-alerts-policy": "An error occurred while creating Alarm policy",
  "t-alerts-policy-updated-successfully": "Alarm policy {param} update successfully",
  "t-error-update-alerts-policy": "An error occurred while updating Alarm policy",
  "t-alerts-policy-deleted-successfully": "Alarm policy {param} delete successfully",
  "t-error-deleting-alerts-policy": "An error occurred while deleting Alarm policy",
  "t-alert-template-created-successfully": "Email Alarm template {param} create successfully",
  "t-alert-template-updated-successfully": "Email Alarm template {param} modify successfully",
  "t-error-updated-email-alert-template": "An error occurred while updating Alarm email template",
  "t-error-created-email-alert-template": "An error occurred while updating Alarm email template",
  "t-error-alert-email-template-title-required": "The title of Alarm Email Template is required",
  "t-error-alert-email-template-subject-required": "The subject of Alarm Email Template is required",
  "t-error-update-alert-logs": "An error occurred when modifying the Alarm log status",
  "t-alert-logs-updated-successfully": "Alarm log status modify successfully",
  "t-notifier": "Notifier",
  "t-minimum-mobile-phone-number": "Mobile phone number must be at least 8 digits",
  "t-maximum-mobile-phone-number": "Mobile phone number must be at most 50 digits",
  "t-phone-duplicate":"Duplicate phone",
  "t-email-duplicate":"Duplicate email",
  "t-select-valid-user-or-partner": "Please select the necessary contact person",
  "t-sms-settings-sms": "SMS Service Provider",
  "t-add-sms-gateway": "Add SMS Gateway",
  "t-edit-sms-gateway": "Edit SMS Gateway",
  "t-enable-sms-success": "SMS Settings Enabled successfully",
  "t-enable-sms-close": "SMS Settings Closed Successfully",
  "t-enable-sms-fail": "SMS status operation failed",
  "t-sms-deleted": "SMS Settings deleted successfully",
  "t-error-deleting-sms-settings": "An error occurred while deleting SMS settings",
  "t-delete-sms-error": "SMS Settings are enabled and cannot be deleted",
  "t-sms-settings-created-successfully": "SMS Settings created successfully",
  "t-error-create-sms-settings": "An error occurred while creating SMS settings",
  "t-sms-settings-updated-successfully": "SMS Settings updated successfully",
  "t-error-updated-sms-settings": "An error occurred while modifying SMS settings",
  "t-sms-settings-accessKeySecret": "Access Key Secret",
  "t-error-sms-settings-accessKeyId-required": "Access Key Id is required in SMS settings",
  "t-error-sms-settings-accessKeySecret-required": "Access Key Secret is required in SMS settings",
  "t-error-sms-settings-signName-required": "Signature name is required in SMS settings",
  "t-error-silence-time-required": "Silence Time is required",
  "t-error-silence-time-min": "The minimum silence time is 5 Minutes",
  "t-error-silence-time-max": "The maximum silence time is 1440 Minutes",
  "t-push-status-public-key-no-mismatch": "FAIL,PUBLIC KEY NO MISMATCH",
  "t-enable-manufacturer": "Product Model",
  "t-enable-tls-certificate": "TLS Certificate",
  "t-enable-ticket": "Tickets",
  "t-enable-merchant-user": "Onboard Merchants",
  "t-enable-attestation": "Attestation",
  "t-enable-sms": "SMS Settings",
  "t-enable-hsm": "HSM",
  "t-enable-geo-fence": "Geo Fencing",
  "t-enable-messages": "Message",
  "t-enable-cloud-messages": "Cloud Messaging",
  "t-enable-report": "Report",
  "t-enable-transaction-param": "Transaction Param",
  "t-enable-cortex-scanner": "Cortex Scanner",
  // "t-enable-system-health": "Enable System Health",
  "t-enable-task-scheduler": "Task Scheduler",
  "t-enable-feitian-partner": "FeiTian Partner",
  "t-enable-feitian-iam": "FeiTian IAM",
  "t-enable-static-report": "Static Report",
  "t-enable-customize-report": "Customize Report",
  "t-enable-widget-report": "Widget Report",
  "t-enable-report-setting": "Report Setting",
  "t-enable-otp": "MFA",
  "t-enable-notice": "Alarm",
  "t-enable-tamper": "Device Tampered Authorization",
  "t-public-platform-type": "Public cloud authorization",
  "t-server-common-name-already-exists": "Report Name already exists.",
  "t-server-customer-be-consistent": "The customer bound by The advertisement version should be consistent with advertisement.",
  "t-use-password-length": "The password length range is 4-32.",
  "t-server-common-file-name-format-mismatch": "The file name cannot contain special symbols:? And #",
  "t-license-id": "ID",
  "t-user-deleted-successfully": "User {param} deleted successfully!",
  "t-error-deleting-user": "Error occurred while deleting user!",
  "t-bind-unbind": "Bind / UnBind",
  "t-device-has-been-bind-other-partner": "There are devices bound to other partners in the device list (click to download)",
  "t-device-has-been-bind-other": "There are devices bound to other Partner/Customer/Merchant/Store in the device list",
  "tool": {
    "t-routerTitle": "Configuración del informe",
    "t-addbtn": "Nueva Categoría",
    "t-reportName": "Nombre del informe",
    "t-createTime": "Tiempo de creación",
    "t-createBy": "Creador",
    "t-updateTime": "Tiempo de actualización",
    "t-updateBy": "Actualizar persona",
    "t-reportType": "Tipo de informe",
    "t-universal": "Universal",
    "t-custom": "Personalizado",
    "t-popUp": "¿Seguro que desea eliminar el informe -{param}?",
    "t-delectTool": "Eliminar el informe",
    "t-sortAllocation": "Configuración de clasificación",
    "t-conditions": "Condiciones",
    "t-attributeCode": "Código del atributo",
    "t-attributeName": "Nombre del atributo",
    "t-dataType": "Tipo de datos",
    "t-enumeratedValue": "Enumerar valores",
    "t-enumerationName": "Enumerar el nombre",
    "t-sortDigit": "Ordenar números",
    "t-associatedPath": "Ruta de asociación",
    "t-associationSQL": "Asociar SQL",
    "t-chartType": "Tipo de gráfico",
    "t-chartSQL": "Gráfico SQL",
    "t-internationalization": "Internacionalización",
    "t-languageType": "Tipo de idioma",
    "t-remark": "Observaciones",
    "t-pleaseEnter": "Por favor escriba",
    "t-pieChart": "Gráfico circular",
    "t-barChart": "Gráfico de barras",
    "t-lineChart": "Diagrama de líneas",
    "t-string": "String",
    "t-time": "Tiempo",
    "t-timeFrame": "Intervalo de tiempo",
    "t-enumeration": "Enumeración",
    "t-year": "en",
    "t-month": "de",
    "t-report": "Report",
  },
  "charts": {
    "t-fixedReport": "Informe estático",
    "t-dynamicReport": "Informe dinámico",
    "t-search": "Buscar",
    "t-export": "Exportar",
    "t-editHeader": "Editar encabezados de lista",
    "log": {
      "t-routerTitle": "Push Report",
      "t-partner": "Socio",
      "t-customer": "Cliente",
      "t-merchant": "Comerciante",
      "t-store": "Tienda",
      "t-modelCode": "código del modelo",
      "t-perform": "Ejecutar la acción",
      "t-execution": "Tiempo de ejecución",
      "t-result": "olek",
      "t-resultCause": "põhjus",
      "t-push-name": "Push Name",
    },
    "device": {
      "t-routerTitle": "Dispositivo",
      "t-sn": "SN",
      "t-imei": "código internacional de identificación de dispositivo móvil",
      "t-tid": "Id de transacción",
      "t-signalStrength": "Red",
      "t-status": "Estado activo",
      "t-activateTime": "Tiempo de activación",
      "t-tamper": "Desmontar o no la máquina",
      "t-modelVersionName": "Versión del modelo",
      "t-buildNum": "código de construcción",
      "t-spBootloader": "SP bootloader",
      "t-spFirmware": "SP firmware",
      "t-smaVersionCode": "número de versión de SMA",
      "t-longitude": "Latitud y longitud",
      "t-keyName": "Clave",
      "t-partnerName": "Socio",
      "t-customerName": "Cliente",
      "t-merchantName": "Comerciante",
      "t-storeName": "Tienda",
      "t-merchantEmail": "Merchant Email",
      "t-storeEmail": "Store Email",
      "t-merchantPhone": "Merchant Phone",
      "t-storePhone": "Store Phone",
      "t-merchantAddress": "Merchant Address",
      "t-storeAddress": "Store Address",
      "t-merchantWebsite": "Merchant Website",
      "t-storeWebsite": "Store Website",
      "t-currency": "Currency",
      "t-groupName": "Grupo",
      "t-countryName": "Región",
      "t-lastOnlineTime": "última hora en línea",
      "t-lastDataUpdatedTime": "Cuándo se actualizaron los últimos datos",
      "t-lastFactorySettingTime": "última vez que se restableció la configuración de fábrica",
      "t-mid": "Id del comerciante",
    },
    "model": {
      "t-head": "Cabeza de lista",
      "t-applications": "Aplicaciones (hasta 3)",
    },
  },
  "t-api-key": "API Key",
  "t-api-secret": "API Secret",
  "t-online-status": "Online Status",
  "t-api-logs": "API Call Logs",
  "t-api-parameters": "Request parameters",
  "t-click-or-drag-file-upload-file": "Click or drag file to this area to upload",
  "t-input-invalid-pattern-special-char-name":"Composed of numbers, letters, underscores, dots, comma, spaces and …,&,(,),-,/,@, and cannot start or end with spaces.",
  "t-cancel-message": "Cancel Message",
  "t-cancel-ad": "Cancel Advertisement Plan",
  "t-warning-to-cancel-message": "Are you sure you want to Cancel Message?",
  "t-warning-to-cancel-ad": "Are you sure you want to Cancel Advertisement?",
  "t-select-device-for-operation": "Please select the device for batch operation",
  "t-select-operation-for-performed": "Please select the operation to be performed in bulk",
  "t-themes": "Themes",
  "t-theme-customizer": "Theme Customizer",
  "t-layout": "Layout",
  "t-choose-layout": "Choose your layout",
  "t-color-scheme": "Color Scheme",
  "t-choose-color-scheme": "Choose Light or Dark Scheme",
  "t-sidebar": "Sidebar",
  "t-choose-sidebar-size": "Choose a size of Sidebar",
  "t-sidebar-color": "Sidebar Color",
  "t-choose-sidebar-color": "Choose Light or Dark Sidebar Color",
  "t-choose-sidebar-image": "Choose a image of Sidebar",
  "t-light": "Light",
  "t-dark": "Dark",
  "t-vertical": "Vertical",
  "t-horizontal": "Horizontal",
  "t-small": "Small",
  "t-gradient": "Gradient",
  "t-add-more-notifier-tips": "To add multiple contacts, please use \",\" to separate them",
  "t-items": "Items",
  "t-push.abort.successfully": "Abort Push successfully!",
  "t-events": "Events",
  "t-event": "Event",
  "t-working-time-period": "Working time period",
  "t-repetition-interval-time": "Repetition Interval Time",
  "t-means-of-notification": "Means of notification",
  "t-close-left-tabs": "Close Left Tabs",
  "t-close-right-tabs": "Close Right Tabs",
  "t-close-other-tabs": "Close Other Tabs",
  "t-parameter-settings": "Parameter Settings",
  "t-transaction-mgmt": "Transaction Mgmt",
  "t-restore-default": "Restore Default",
  "t-device-extend-attribute": "Device Extend Attribute",
  "t-device-life-cycle": "Device Life Cycle",
  "t-otp-type-ft": "OTP Mobile",
  "t-otp-type-feitian": "Feitian OTP",
  "t-otp-type-google": "Google Authenticator",
  "t-otp-google-download-detail": "Download and install",
  "t-otp-google-download-detail-2":" for your phone",
  "t-otp-install-notes":" Installation Notes",
  "t-otp-mobile-download":" Download an OTP Mobile app",
  "t-error-enter-otp-code": "The length of OTP Code is 6-10 digits!",
  "t-scan-QRCode":"Scan the QR code",
  "t-scan-QRCode-detail":"Open the authentication app and scan the image to the left using your phone's camera",
  "t-otp-google-download":"Download an authenticator app",
  "t-google-otp-link-invalid":"Activation Authenticator failed:The link is invalid",
  "t-product-model": "Product Model",
  "t-release-time": "Release Time",
  "t-wallpaper-format": "Wallpaper Format",
  "t-bootPicture-format": "BootPicture Format",
  "t-BootAnimation-format": "BootAnimation Format",
  "t-model-version-identification": "Model Version identification",
  "t-enable-device-extend-attribute": "Device Extend Attribute",
  "t-enable-device-life-cycle": "Device Life Cycle",
  "t-is-empty": "{param} cannot be empty",
  "t-error-updating-device-extend-attribute-value": "Error occurred updating the device's extended attribute value",
  "t-enter-attribute-value": "Enter Extend Attribute Value",
  "t-server-attribute-type-string": "Attribute Value length: 0-50; format: letters, numbers",
  "t-server-attribute-type-integer":"Attribute Value should be between 0-65535",
  "t-server-attribute-type-boolean": "Attribute value is of type boolean. Please check and modify it",
  "t-device-extend-attribute-value-updated-successfully": "The extended attribute value of the device is updated successfully!",
  "t-export-to-csv": "Export To CSV",
  "t-tooltip-device-tid": "SN、TID",
  "t-tid-list": "TID List",
  "t-device-life-cycle-desc": "Life Cycle Description",
  "t-device-life-cycle-modifyTime": "Life Cycle ModifyTime",
  "t-fence-boundary":"Fence Boundary",
  "t-more":"More",
  "t-visual-range": "Open to",
  "t-belong-to": "Move to",
  "t-belong-to-application": "Move To Application",
  "t-belong-to-firmware": "Move To Firmware",
  "t-global-visibility": "All",
  "t-specified-range": "Authorized Hier",
  "t-not-open-to": "Not Open To",
  "t-shared-data-already-exists": "There is already a same level range allocation. If there are any changes, please delete the original designated range first and then add the latest designated range!",
  "t-partner-users-cannot-add-partner-data": "Not allowed to select data bound to oneself.",
  "t-belong-to-firmware-error": "The specified range cannot be empty.",
  "t-remember-password": "Wait, I remember my password...",
  "t-log-in-again": "Wait, I need to log in again...",
  "t-select-device-exist-disable-device": "The selected devices include disabled devices.",
  "t-select-device-exist-inactive-device": "The selected device contains inactive devices",
  "t-device-sma-version-not-support": "FAIL,PUSH DEVICE SMA VERSION NOT SUPPORT",
  "t-owner": "Owner",
  "t-operator": "Operator",
  "t-support-format": "Support Format",
  "t-support-resolution": "Support Resolution",
  "t-device-life-cycle-bulk-upload":"Device Life Cycle Bulk Upload",
  "t-import-device-life-cycle-information-details":"Import Device Life Cycle information details",
  "t-have-joined-download-queue":"IN PROCESS",
  "t-key-value-length-is-too-long":"KEY VALUE LENGTH IS TOO LONG",
  "t-pad-mode":"Pad Mode Identifier",
  "t-key-not-support-pad-mode-type":"Not Support Pad Mode Type",
  "t-cipher-by-pubKey":"Cipher By pubKey",
  "t-not-export":"Not Export",
  "t-exported":"Exported",
  "t-key-has-been-changed":"Key Has Been Changed",
  "t-marker":"Marker",
  "t-export-device-public-key":"Export Public Key",
  "t-import-tid-device-tid-conflict":"THERE IS A CONFLICT BETWEEN THE DEVICE TID AND THE TID IN THE IMPORTED FILE",
  "t-please-enter-account-password":"Please enter your account password.",
  "t-authorization-file":"Authorization File",
  "t-select-device-unbind": "Please select device to unbid",
  "t-signature-name": "Signature Name",
  "t-select-installed-numbers": "Only supports selecting up to five apk files.",
  "t-success-process-message": "Oh, yes, you successfully handled this alarm message.",
  "t-fail-process-message": "Oh, yes, you failed to process this alarm message.",
  "t-device-apk-password-length": "Password only supports entering 6 digits.",
  "t-no-permission": "The user does not have access to the STORM System. Please contact the administrator.",
  "t-hsm-message-header": "HSM Message Header",
  "t-direct-connection": "Direct Connection",
  "t-username-password": "Username & Password",
  "t-tls-certificate-connect": "TLS Certificate",
  "t-client-ks-certificate": "Client Certificate (.ks)",
  "t-client-ks-password": "Client Certificate Password",
  "t-ca-ts-certificate": "CA Certificate (.ts)",
  "t-ca-ts-password": "CA Certificate Password",
  "t-cert-uploaded": "Uploaded",
  "t-cert-not-uploaded": "Not Uploaded",
  "t-push-device-information": "Note: The push interface only displays activated devices, except that the push activation command only displays inactivated devices",
  "t-warning-to-delete-push-scheduled-tasks": "Are you sure you want to delete push scheduled tasks?",
  "t-delete-push-success": "Delete Push Success",
  "t-app-uninstall-block": "App Uninstall Block",
  "t-app-password": "App Password",
  "t-mfa-type": "MFA Type",
  "t-only-add-up-to-10-items-events": "Only add up to 10 items events.",
  "t-search-name-sn": "Name、SN",
  "t-search-name-version": "Name、Version",
  "t-recorded-in-audit": "Only recorded in audit log",
  "t-device-status-active-key-not-exist": "Public key not exist",
  "t-pos-server-version": "POS Server Version",
  "t-transaction-param-version-json-desc": "(STORM has already integrated TID & MID at Json according to SN automatically, so you do not need to set TID & MID inside the Json. If you still set TID & MID, we will use your version)",
  "t-select-algorithm": "Please select algorithm",
  "t-direct-push-success": "Direct Push Success",
  "t-app-file-upload-right-spec": "File names only support letters, numbers, underscores, and the English period.",
  "t-range": "Range",
  "t-add-more-package-name-tips": "To add multiple package names, use \",\" to separate them",
  "t-authorization-has-expired-contact-administrator": "Authorization has expired, Please contact the administrator",
  "t-confirm-modify-password": "Password expired: Your password is older than {param} days. Reset it to continue.",
  "t-static-report": "Static Report",
  "t-customize-time-before-days": "How many days ago did you customize",
  "t-report_export_successfully": "Export successfully, please go to the \"Report Download\" to download",
  "t-report-type": "Report Type",
  "t-chart-type": "Chart Type",
  "t-confirm-stop": "Are you sure you want to stop this record",
  "t-enter-maximum-package": "Enter up to 3 package names separated by commas",
  "t-log-capture-stop": "Capture Stopped",
  "t-generate": "Generate",
  "t-schedule": "Schedule",
  "t-data-scope": "Data Scope",
  "t-report-data-range": "Data Range",
  "t-table-head": "Table Head",
  "t-visual-widget": "Visual Widget",
  "t-custom-report": "Custom Report",
  "t-generate-schedule": "Generate Schedule",
  "t-authorized-list": "Authorized List",
  "t-pushed": "Pushed",
  "t-search-criteria": "Search Criteria",
  "t-days-range": "Days Range",
  "t-maximum-json-length": "The maximum supported JSON length is 32,000 characters.",
  "t-push-status-same-file-exist": "FAIL,SAME_FILE_EXIST",
  "t-push-status": "Push Status",
  "t-app": "APP",
  "t-only-show-groups-with-available-devices": "Only display groups with available devices",
  "t-only-show-available-devices": "Only show available devices",
  "t-licensed-features": "Licensed Features",
  "t-period": "Period",
  "t-send-type": "Send Type",
  "t-smtp": "SMTP",
  "t-sendgrid": "SendGrid",
  "t-key-capture-device-encrypted-key-not-exist": "Encrypted Key Not Exist",
  "t-select-all-device-note": "Note: Key Capture will be performed on all devices within the specified range that are in an active state and operating normally.",
  "t-select-device": "Select Device",
  "t-select-group": "Select Group",
  "t-all-device": "All Devices",
  "t-all-group": "All Groups",
  "t-select-this-page": "Select This Page",
  "t-selected-count": "{count} selected",
  "t-all-devices-selected": "All {count} devices selected",
  "t-all-groups-selected": "All {count} groups selected",
  "t-clear-selection": "Clear selection",
  "t-all-selected-cannot-unselect": "All selected, cannot unselect single item",
  "t-device-operation": "Device Operation",
  "t-key-gen-rules-no-duplicate": "No duplicate key",
  "t-key-gen-rules-append-existing": "Append device to existing record",
  "t-key-gen-rules-append-new": "Append device in new record",
  "t-display-only-devices-without-generated-keys": "Display only devices without generated keys",
  "t-key-gen-rules-regenerate": "Regenerate",
  "t-key-gen-rules-no-duplicate-warning": "Current key configuration has no duplicate key",
  "t-key-gen-rules-append-existing-warning": "Append device association to existing key record",
  "t-key-gen-rules-append-new-warning": "Create new key record and append device association",
  "t-key-gen-rules-regenerate-warning": "Regenerate key and overwrite existing key record",
  "t-proxy-settings": "Download Channel",
  "t-download-setting": "Download Settings",
  "t-proxy": "Proxy",
  "t-mpush": "MPUSH",
  "t-mqtt": "MQTT",
  "t-download-directly": "Amazon S3",
  "t-cdn-download": "AWS Cloud Front",
  "t-platform-download": "STORM Service",
  "t-feitian-proxy": "Proxy by FT",
  "t-proxy-service-by-ip": "Feitian Proxy Server(IP)",
  "t-proxy-service-by-domain": "Feitian Proxy Server(Domain)",
  "t-proxy-service": "Proxy Service",
  "t-successful-push-tasks": "Successful Push Tasks",
  "t-all-push-tasks": "All Push Tasks",
  "t-real-time-logs": "Remote ADB Debug",
  "t-issue-the-command": "Command",
  "t-communication-log": "View logs",
  "t-refresh-interval": "Refresh interval",
  "t-local-log": "Local log",
  "t-keywords": "Keywords",
  "t-start-scraping": "Start Scraping",
  "t-stop-scraping": "Stop Scraping",
  "t-only-supported-high-version": "“Allow downloading using mobile network“ is only supported on SMA 100517 and above.",
  "t-only-supported-high-version-old-version-prompt-Upgrade": "“Automatic upgrade“ is only supported on SMA 100517 and above; earlier versions will only prompt for upgrade.",
  "t-overwrite": "Overwrite",
  "t-append": "Append",
  "t-user-login-stats": "Login Logs",
  "t-search-by-user": "Search by User",
  "t-new-login-count": "New Login Count",
  "t-old-login-count": "Old Login Count",
  "t-last-login-time": "Last Login Time",
  "t-data-load-failed": "Data Load Failed",
  "t-new-storm": "New STORM",
  "t-login-type": "Login Page",
  "t-google-maps-error-tips": "Map loading failed. Please check your network connection or try again later.",
  "t-frequent-operations-try-again-later": "Frequent operations, please try again later.",
  "t-captcha-required": "Please complete the sliding verification",
  "t-captcha-length-error": "Captcha length should be {param} characters",
  "t-captcha-error": "Incorrect captcha, please enter again",
  "t-captcha-success": "Verification successful",
  "t-captcha": "Captcha",
  "t-captcha-input-placeholder": "Enter captcha",
  "t-captcha-expired": "Captcha has expired, please enter again",
  "t-captcha-slide-to-verify": "Slide to complete verification",
  "t-captcha-verify-success": "Verification successful",
  "t-unlock-user": "Unlock User",
  "t-lock-user": "Lock User",
  "t-user-locked-successfully": "User locked successfully",
  "t-user-unlocked-successfully": "User unlocked successfully",
  "t-warning-lock-user": "Are you sure you want to lock this user?",
  "t-warning-unlock-user": "Are you sure you want to unlock this user?",
  "t-change-the-password-error-protect": "Enable password error protection",
  "t-more-wrong-password-temporarily-locking": "Number of consecutive wrong password attempts. After reaching this number, the account will be temporarily locked [Value: 5-10]",
  "t-more-wrong-password-permanently-locking": "Cumulative number of wrong password attempts. After reaching this number, the account will be permanently locked and will require administrator intervention to unlock [Value: 10-30]",
  "t-temporarily-locking-automatically": "Once the account is temporarily locked, it will be automatically unlocked after the time set here (minutes) [Value: 5-60]",
  "t-clear-logs": "Clear Logs",
  "t-adb-command": "ADB Command",
  "t-dict": "System Variable Config",
  "t-dictionary": "Parameters",
  "t-dictionary-type": "Parameter Type",
  "t-enabled": "Enabled",
  "t-disabled": "Disabled",
  "t-dict-data": "Parameter Data",
  "t-dict-label": "Parameter Label",
  "t-dict-value": "Parameter Value",
  "t-rca-logs": "RCA Logs",
  "t-application-not-installed": "APP not detected. Install it via the “Install APP” button below to perform this operation",
  "t-application-waiting-installed": "The device is currently being installed, please wait ..",
  "t-install-application": "Install application",
  "t-reinstall-application": "Reinstall application",
  "t-remote-assistance": "Invite FT Remote Assistance",
  "t-device-needs-app-for-remote-control": "Device needs to install application for remote control",
  "t-checking-app-installation-status": "Checking application installation status...",
  "t-transfer-files": "Transfer files",
  "t-request-sent-device-failed": "Request sent to device failed",
  "t-start-downloading-apps": "START DOWNLOADING APPLICATIONS TASK",
  "t-create-push-task": "Create Push Task",
  "t-from-version": "From Version",
  "t-to-version": "To Version",
  "t-delta-package": "Delta Package",
  "t-whole-package": "Full",
  "t-push-status-apn-sim-state-not-ready": "FAIL, APN SIM STATE NOT READY",
  "t-push-status-apn-slotindex-mistake": "FAIL, APN SLOTINDEX MISTAKE",
  "t-push-status-apn-numeric-mistake": "FAIL, APN NUMERIC MISTAKE",
  "t-push-status-apn-mnc-mistake": "FAIL, APN MNC MISTAKE",
  "t-push-status-apn-and-name-not-mistake": "FAIL, APN AND NAME MISMATCH",
  "t-push-status-apn-insert-failed": "FAIL, APN INSERT FAILED",
  "t-push-status-task-superseded": "FAIL, REPLACED BY NEW TASK",
  "t-push-status-revoked-terminal-confirmed": "Revoked (Terminal Confirmed)",
  "t-push-status-reverting": "REVOKING",
  "t-push-status-init-firmware-not-supported": "FAIL, INITIALIZATION FIRMWARE NOT SUPPORTED",
  "t-push-status-upgrade-in-progress": "FAIL, UPGRADE IN PROGRESS",
  "t-push-status-already-target-version": "FAIL, ALREADY TARGET VERSION",
  "t-push-status-some-tasks-succeeded-others-failed": "FAIL, SOME TASKS SUCCEEDED, OTHERS FAILED",
  "t-push-status-insufficient-battery-will-execute-when-charged": "INSUFFICIENT BATTERY, WILL EXECUTE WHEN CHARGED",
  "t-push-status-second-signature-enabled-device-not-bound-to-customer": "FAIL, SECOND SIGNATURE ENABLED, DEVICE NOT BOUND TO CUSTOMER",
  "server.mpm.device.not.in.customer": "Partner has enabled secondary signature. Devices must be bound to a customer.",
  "server.mpm.customer.without.signature.application.signed.fail": "Customer without signature, application signed fail",
  "t-open-remote-control-model-notes": "Please note",
  "t-open-remote-control-model-notes-1": "This operation will incur a certain amount of data usage (in scenarios without file transfer). For reference, approximately 7MB of data is estimated to be consumed when using the F20 device for 10 minutes.",
  "t-open-remote-control-model-notes-tha": "This operation will incur a certain amount of data usage.",
  "t-open-remote-control-model-notes-2": "Actual data consumption is subject to factors such as device performance, operation frequency, and screen resolution.",
  "t-open-remote-control-model-waiting": "Remote control request has been initiated, please wait ..",
  "t-sma-manager": "SMA Manager",
  "t-select-target-device": "Select target device",
  "t-filter-device-by-version-group": "Devices can be filtered by model version/group, and batch selection is supported",
  "t-match": "Match",
  "t-match-result": "Matching result",
  "t-system-auto-match-version": `The system has automatically matched differential packages based on the current version of the device and the target version ({param})`,
  "t-task": "Task",
  "t-target": "Target",
  "t-task-confirmation-submit": "Task confirmation submission",
  "t-number-of-success-match": "Number of successful matches",
  "t-skip-number-of-unpackaged-devices": "Skip the number of unpackaged devices",
  "t-target-os-version": "Target OS Version",
  "t-current-os-version": "Current OS Version",
  "t-upgrade-package-type": "Upgrade Mode",
  "t-submitting": "Submitting",
  "t-file-type-not-patch-package": "The uploaded file does not comply with the differential package rules",
  "t-information": "Information",
  "t-match-diff-package": "Match Diff Package",
  "t-steps": "Steps",
  "t-websocket-connected": "--- WebSocket Connected ---",
  "t-start-scraping-logs": "--- Start Scraping Logs ---",
  "t-stop-scraping-logs": "--- Stop Scraping Logs ---",
  "t-websocket-connection-error": "--- WebSocket Connection Error, please check console ---",
  "t-websocket-closed": "--- WebSocket Connection Closed ---",
  "t-logs-cleared": "--- Logs Cleared ---",
  "t-command-issued": "> Command Issued: {command}",
  "t-command-failed": "> Command Failed: {command}",
  "t-command-exception": "> Command Exception: {message}",
  "t-websocket-not-connected": "> WebSocket Not Connected, cannot issue command",
  "t-websocket-reconnecting": "> WebSocket Not Connected, attempting to reconnect...",
  "t-reconnection-success": "> Reconnection Successful",
  "t-reconnection-attempt-failed": "> Reconnection Attempt {i}/5 Failed",
  "t-reconnection-failed-cannot-issue": "> Reconnection Failed, cannot issue command",
  "t-command-sent-wait": "> Command sent, please wait for the result...",
  "t-ft-remote-control": "FT RCA",
  "t-adb-debug-logs": "Remote ADB Debug Logs",
  "t-differential-upgrade-strategy": "Firmware Rules",
  "t-diff-package-rule-configuration": "Firmware Rules Configuration",
  "t-version-identifier": "Version Identifier",
  "t-derivative-flag": "Derivative Flag",
  "t-diff-package-push": "Delta Package Push",
  "t-diff-package": "Differential Package",
  "t-full-package": "Full Package",
  "t-scheduler-firmware-delta-package": "Firmware Upgrade - Delta Package",
  "t-scheduler-firmware-full-package": "Firmware Upgrade - Full Package",
  "t-upload-package-tips": "For example: Files from version {formVersion} to version {toVersion} need to be uploaded",
  "t-selected-records": "Selected Records",
  "t-all-records-this-query": "All records of this query",
  "t-no-corresponding-differential-package": "No corresponding package file",

  "t-ota-mgmt": "OTA Mgmt",
  "t-grayscale-publishing-strategy": "Grayscale publishing strategy",
  "t-grayscale-stage": "Grayscale Stage",
  "t-suggested-add": "Suggested Add",
  "t-model-addable": "Model Addable (Units)",
  "t-model-added": "Model Added (Units)",
  "t-release-strategy": "Release Strategy",
  "t-full-release": "Full Release",
  "t-grayscale-release": "Grayscale Release",
  "t-auto-upgrade": "Auto Upgrade",
  "t-scheduled-upgrade": "Scheduled Upgrade",
  "t-remind-customer-on-upgrade": "Remind customer on upgrade",
  "t-upgrade-task": "Upgrade Task",
  "t-task-name": "Task Name",
  "t-target-version": "Target Version",
  "t-release-strategy-type": "Release Strategy Type",
  "t-upgrade-mgmt": "Firmware Upgrade",
  "t-upgrade-type": "Upgrade Type",
  "t-upgrade-option": "Upgrade Option",
  "t-current-version": "Current Version",
  "t-update-log": "Update Log",
  "t-last-request-time": "Last Request Time",
  "t-cancel-upgrade": "Cancel Upgrade",
  "t-task-cannot-be-revoked": "Task cannot be cancelled",
  "t-device-list": "Device List",
  "t-distribution-map": "Firmware Overview",
  "t-whole-package-push": "Full Package Push",
  "t-full-upgrade": "Full Upgrade",
  "t-delta-upgrade": "Delta Upgrade",
  "t-not-equipped-upgrades": "Exclude Devices With Upgrade Tasks",
  "t-source-to-target": "Source To Target",
  "t-confirm-change": "Confirm Switch",
  "t-confirm-change-proxy": "Confirm proxy configuration Switch?",
  "t-warning": "Warning",
  "t-change-model-warning": "Proxy Switch Warning",
  "t-app-used-quota": "Application quota used",
  "t-firmware-used-quota": "Firmware quota used",
  "t-switch-to": "Switch to",
  "t-app-available-use": "Application available",
  "t-firmware-available-use": "Firmware available",
  "t-forced-switch":"Forced Switch",
  "t-start-time-cannot-be-greater-than-end-time":"The start time must not be later than the end time",
  "t-allow-download-during-sleep":"Allow downloading during sleep",
  "t-allow-download-during-sleep-desc":"If you select this option, the terminal will be allowed to download firmware files during sleep mode",
  "t-not-upgrade-task-by-firmware-tips": "No OS Upgrade Task",
  "t-not-upgrade-task-by-firmware-tips-desc": "Excludes devices with existing OS upgrade tasks.",
  "t-filters-device-by-status-title": "Default Excluded Devices",
  "t-filters-device-by-status-desc1": "- Already on target version",
  "t-filters-device-by-status-desc2": "- Inactive",
  "t-filters-device-by-status-desc3": "- Outside geo-fence",
  "t-filters-device-by-status-desc4": "- Outside Country",
  "t-succeeded": "Succeeded",
  "t-failed": "Failed",
  "t-revoked": "Revoked",
  "t-auto-recognize-version": "Auto-recognize version",
  "t-revoked-task-tips": "Only tasks that have been created but not yet initiated by the terminal can be revoked (SMA Version must be 200112 or higher).",
  "t-product": "Product",
  "t-ota-error-logs": "Device Exception Event",
  "t-event-type": "Event Type",
  "t-active-os-upgrade-tasks": "Active Firmware Upgrade Tasks (Last 12 Months)",
  "t-file-upload-error-try-again": "The uploaded firmware format is incorrect, please try again",
  "t-update-time": "Update Time",
  "t-filter-same-versions": "Exclude Target Version Devices",
  "t-filter-same-versions-desc": "When checked, devices that are already on the target version will be excluded.",
  "t-allow-same-version-upgrade": "Allow Same Version Upgrade",
  "t-allow-same-version-upgrade-desc": "If you select this option, the terminal will be allowed to upgrade to the same firmware version as the current version",
  "t-replace-uncompleted-tasks": "Overwrite Task",
  "t-replace-uncompleted-tasks-desc": "The new task will replace previous task which are not completed in device.",
  "t-time-period-not-allowed-across-days": "The time period is not allowed to span across days",
  "t-file-upload-successful": "The {type} file corresponding to device {device} has been uploaded successfully!",
  "t-select-identical-rule": "You have selected a duplicate rule",
  "t-formversion-toversion-same": "From version and to version cannot be the same",
  "t-please-complete-the-information-for-all-rules": "Please fill in the complete rule information",
  "t-all-day": "All Day",
  "t-custom-period": "Custom Period",
  "t-json-err-check-retry": "JSON format error, please check the input content",
  "t-only-supported-high-version-new": "Support is provided for SMA version 100517 and above.",
  "t-search_report_name_user": "Report Name、 Create By",
  "t-password-must-be-6-digits": "Please enter a 6-digit password",
  "t-batch-operation": "Batch operation",
  "t-sub-action": "Sub Action",
  "t-batch-application-fail-cause": "Application Fail Cause",
  "t-reissue-device-warning": "Add devices to existing records",
  "t-overwrite-device-key-warning": "the same key exists",
  "t-historical-records-have-been-detected": "{count} historical records have been detected. If the selected device has already generated this Key, the old records will be deleted.",
  "t-firmware-sma-version-warning": "Note: Devices with SMA versions below 200117 do not support this setting. Firmware-related content will be excluded when creating Terminal Profiles.",
  "t-exclude-devices-with-terminal-profile-tasks": "Exclude Devices With Terminal Profile Tasks",
  "t-encrypt-type": "Encryption Type",
  "t-auto-select-recommended": "AUTO - Auto Select (Recommended)",
  "t-force-ecc": "ECC",
  "t-force-rsa": "RSA",
  "t-tr34": "TR34",
  "t-encrypt-type-hint-auto": "AUTO: Prioritize ECC encryption, automatically fall back to RSA if device does not support it",
  "t-encrypt-type-hint-ecc": "ECC: Only use ECC encryption, injection fails if device does not support it",
  "t-encrypt-type-hint-rsa": "RSA: Only use RSA encryption",
  "t-encrypt-type-hint-tr34": "TR34: Use TR34 standard format for key injection",
  "t-tr34-auth-required": "Please complete mutual authentication before selecting TR34 format",
  "t-go-to-mutual-auth": "Go to Bind Key Metadata",
  "t-device-ecc-not-supported": "Device does not support ECC encryption",
  "t-key-capture-device-cert-not-exist": "DEVICE CERT NOT EXIST",
  "t-key-capture-device-not-authenticated": "DEVICE NOT AUTHENTICATED",
  "t-key-capture-device-mutual-auth-unbound-key-invalidated": "DEVICE MUTUAL AUTH UNBOUND, KEY INVALIDATED",
  "t-key-capture-key-derivation-failed": "KEY DERIVATION FAILED",
  "t-root-ca-certificate": "Root CA Certificate",
  "t-sub-ca-certificate": "Sub CA Certificate",
  "t-server-certificate": "Server Certificate",
  "t-import-certificate": "Import Certificate",
  "t-export-csr": "Export CSR",
  "t-generate-csr": "Generate CSR",
  "t-key-size": "Key Size",
  "t-valid": "Valid",
  "t-expired": "Expired",
  "t-public-key-algorithm": "Public Key Algorithm",
  "t-private-key-location": "Private Key Location",
  "t-re-import": "Re-import",
  "t-rki-root-ca-alert": "Root CA certificate is issued by FT Safe factory. The platform only stores it for certificate chain verification and cannot modify it.",
  "t-rki-sub-ca-alert": "Sub CA certificate is issued by FT Safe factory and imported to the platform. It is used to verify Device Cert certificate chain during mutual authentication.",
  "t-rki-server-cert-alert": "Server Cert is generated by the platform in HSM. The CSR is exported to FT Safe factory for signing. The private key never leaves the HSM.",
  "server.cert.root.ca.not.found": "Root CA not found, cannot verify Sub CA",
  "server.cert.verify.sub.ca.failed": "Cert verification failed",
  "server.cert.import.failed": "Server Certificate import failed",
  "server.cert.private.key.not.found": "Private key not found, please generate CSR first",
  "server.cert.private.key.mismatch": "Private key does not match the Server Certificate",
  "server.cert.expired": "The certificate has expired. Please re-issue a valid certificate",
  "server.cert.not.yet.valid": "The certificate is not yet valid. Please check the issuance time",
  "server.cert.not.exists": "Server Certificate does not exist",
  "t-mutual-auth": "Bind Key Metadata",
  "t-initiate-auth": "Bind Key Metadata",
  "t-batch-auth": "Batch Authentication",
  "t-rki-mutual-auth-alert": "Mutual authentication flow: TMS sends authentication command → Device uploads Device Cert → TMS verifies with Sub CA → TMS sends Server Cert → Device verifies with Sub CA → Authentication successful",
  "t-auth-status": "Status",
  "t-auth-time": "Bind Time",
  "t-authenticated": "Bound",
  "t-unauthenticated": "Unauthenticated",
  "t-authenticating": "Binding",
  "t-auth-failed": "Binding failed",
  "t-auth-fail-cause": "Failure Reason",
  "t-unbound": "Pending CSR Generation",
  "t-server-cert-not-exist": "The server certificate for the partner does not exist. Please configure it before initiating binding.",
  "t-csr-pending": "CSR Pending",
  "t-csr-received": "CSR Received",
  "t-not-authenticated": "Pending Binding",
  "t-cert-pending-inject": "Certificate Pending Inject",
  "t-inject-cert": "Inject Certificate",
  "t-sync-device-cert": "Sync Device Cert",
  "t-sync-device-random-number": "Sync Device Random Number",
  "t-download-csr": "Download CSR",
  "t-download-success": "Download Success",
  "t-csr-content-empty": "CSR content is empty",
  "t-upload-cert": "Upload Certificate",
  
  "t-cert-file": "Certificate File",
  "t-upload-success": "Upload Success",
  "t-server-exception-try-later": "Server exception, please try again later!",
  "t-gray-release-template": "Gray Scale Template",
  "t-template-name": "Template Name",
  "t-strategy-type": "Strategy Type",
  "t-release-mode": "Release Mode",
  "t-batch-config": "Stage Config",
  "t-auto-promote-threshold": "Auto Promote Threshold",
  "t-auto-promote-threshold-required": "Auto Promote Threshold is required",
  "t-auto-promote-threshold-range": "Auto Promote Threshold must be greater than 0 and cannot exceed 100",
  "t-fast-release": "Fast Release",
  "t-standard-release": "Standard Release",
  "t-conservative-release": "Conservative Release",
  "t-by-percentage": "By Percentage",
  "t-by-device-count": "By Device Count",
  "t-template-name-required": "Template name is required",
  "t-batch-config-required": "Batch config is required",
  "t-enabled-success": "Enabled successfully",
  "t-disabled-success": "Disabled successfully",
  "t-enabled-cannot-delete": "Cannot delete when enabled",
  "t-operation-failed": "Operation failed",
  "t-add-batch": "Add Stage",
  "t-threshold-hint": "Auto-promote to next stage when upgrade success rate ≥ threshold",
  "t-collect-duration": "Collection Duration",
  "t-collect-count": "Collection Count",
  "t-collect-duration-required": "Collection Duration is required",
  "t-collect-count-required": "Collection Count is required",
  "t-times": "times",
  "t-units": "unit(s)",
  "t-percentage": "Percentage",
  "t-device-count": "Device Count",
  "t-custom": "Custom",
  "t-must-be-greater": "must be greater than previous",
  "t-use-gray-release-template": "Gray Scale Upgrade",
  "t-select-template": "Select Template",
  "t-gray-release-allocation-valid": "{count} selected device(s) meet the allocation requirement for {stages} upgrade stage(s).",
  "t-gray-release-allocation-insufficient": "{count} device(s) selected. The selected count must exceed the total device count of all stages ({required}); {missing} more device(s) are needed.",
  "t-gray-release-allocation-invalid-template": "This gray release template cannot allocate at least one device to every upgrade stage.",
  "t-gray-release-task-detail": "Gray Scale Upgrade Task Detail",
  "t-gray-task": "Gray Scale Task",
  "t-gray-detail": "View Gray Detail",
  "t-gray-template-name": "Gray Scale Template Name",
  "t-current-batch": "Current Batch",
  "t-total-progress": "Total Progress",
  "t-health-rate": "Health Rate",
  "t-task-status": "Task Status",
  "t-pause": "Pause",
  "t-resume": "Resume",
  "t-force-promote": "Force Promote",
  "t-enter-next-stage": "Jump to Next Stage",
  "t-cancel-task": "Cancel Task",
  "t-batch-progress": "Batch Progress",
  "t-gray-batch-progress": "Batch",
  "t-progress": "Progress",
  "t-success-rate": "Success Rate",
  "t-threshold": "Threshold",
  "t-no-batch-data": "No batch data",
  "t-health-evaluation": "Device Upgrade Overview",
  "t-pass": "Pass",
  "t-no-health-data": "No health data",
  "t-paused-success": "Task paused successfully",
  "t-resume-success": "Task resumed successfully",
  "t-force-promote-success": "Force promoted",
  "t-enter-next-stage-success": "Jumped to next stage",
  "t-stage": "Stage",
  "t-upgrade-stage-progress-overview": "Upgrade Stage Progress Overview",
  "t-cancel-success": "Cancelled",
  "t-not-started": "Not Started",
  "t-in-progress": "In Progress",
  "t-paused": "Paused",
  "t-completed": "Completed",
  "t-cancelled": "Cancelled",
  "t-terminated": "Terminated",
  "t-auto-promote": "Auto Promote",
  "t-health-evaluated-success": "Health evaluation completed",
  "t-health-all-passed": "All health checks passed",
  "t-health-not-passed": "Health check failed",
  "t-health-all-passed-desc": "All core metrics meet the threshold",
  "t-health-not-passed-desc": "Some core metrics did not meet the threshold",
  "t-card-read-success-rate": "Card Read Success Rate",
  "t-print-status": "Print Status",
  "t-core-health": "Core Health Metrics",
  "t-firmware-upgrade-success-rate": "Firmware Upgrade Success Rate",
  "t-app-name": "App Name",
  "t-file-path": "File Path",
  "t-app-type": "Application Type",
  "t-ftrca-desc": "Remote Control Agent",
  "t-fttha-desc": "Terminal Health Agent",
  "t-apk-parse-result": "APK Parse Result",
  "t-file-not-found": "File not found",
  "t-max-count": "Max Count",
  "t-last-batch-must-be-unlimited": "last batch must be unlimited",
  "t-must-set-device-count": "must set device count, cannot be unlimited",
  "server.partner.traffic.quota.config.already.exists": "The quota configuration for this partner already exists"
}
